(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function $41718d655488e1fe$var$_defineProperty(e, r, t) {
    return (r = $41718d655488e1fe$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $41718d655488e1fe$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $41718d655488e1fe$var$_setPrototypeOf(t, e);
}
function $41718d655488e1fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41718d655488e1fe$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41718d655488e1fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41718d655488e1fe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41718d655488e1fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41718d655488e1fe$var$_setPrototypeOf(t, e) {
    return $41718d655488e1fe$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $41718d655488e1fe$var$_setPrototypeOf(t, e);
}
function $41718d655488e1fe$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $41718d655488e1fe$var$_toPropertyKey(t) {
    var i = $41718d655488e1fe$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $41718d655488e1fe$var$_wrapRegExp() {
    $41718d655488e1fe$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $41718d655488e1fe$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $41718d655488e1fe$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $41718d655488e1fe$var$_wrapRegExp.apply(this, arguments);
}
const $41718d655488e1fe$var$noop = ()=>{};
let $41718d655488e1fe$var$_WINDOW = {};
let $41718d655488e1fe$var$_DOCUMENT = {};
let $41718d655488e1fe$var$_MUTATION_OBSERVER = null;
let $41718d655488e1fe$var$_PERFORMANCE = {
    mark: $41718d655488e1fe$var$noop,
    measure: $41718d655488e1fe$var$noop
};
try {
    if (typeof window !== 'undefined') $41718d655488e1fe$var$_WINDOW = window;
    if (typeof document !== 'undefined') $41718d655488e1fe$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $41718d655488e1fe$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $41718d655488e1fe$var$_PERFORMANCE = performance;
} catch (e) {}
const { userAgent: $41718d655488e1fe$var$userAgent = '' } = $41718d655488e1fe$var$_WINDOW.navigator || {};
const $41718d655488e1fe$var$WINDOW = $41718d655488e1fe$var$_WINDOW;
const $41718d655488e1fe$var$DOCUMENT = $41718d655488e1fe$var$_DOCUMENT;
const $41718d655488e1fe$var$MUTATION_OBSERVER = $41718d655488e1fe$var$_MUTATION_OBSERVER;
const $41718d655488e1fe$var$PERFORMANCE = $41718d655488e1fe$var$_PERFORMANCE;
const $41718d655488e1fe$var$IS_BROWSER = !!$41718d655488e1fe$var$WINDOW.document;
const $41718d655488e1fe$var$IS_DOM = !!$41718d655488e1fe$var$DOCUMENT.documentElement && !!$41718d655488e1fe$var$DOCUMENT.head && typeof $41718d655488e1fe$var$DOCUMENT.addEventListener === 'function' && typeof $41718d655488e1fe$var$DOCUMENT.createElement === 'function';
const $41718d655488e1fe$var$IS_IE = ~$41718d655488e1fe$var$userAgent.indexOf('MSIE') || ~$41718d655488e1fe$var$userAgent.indexOf('Trident/');
var $41718d655488e1fe$var$p = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $41718d655488e1fe$var$g = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var $41718d655488e1fe$var$S = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    }
}, $41718d655488e1fe$var$A = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $41718d655488e1fe$var$P = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $41718d655488e1fe$var$s = "classic", $41718d655488e1fe$var$t = "duotone", $41718d655488e1fe$var$r = "sharp", $41718d655488e1fe$var$o = "sharp-duotone", $41718d655488e1fe$var$L = [
    $41718d655488e1fe$var$s,
    $41718d655488e1fe$var$t,
    $41718d655488e1fe$var$r,
    $41718d655488e1fe$var$o
];
var $41718d655488e1fe$var$G = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $41718d655488e1fe$var$lt = {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $41718d655488e1fe$var$pt = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ]
]), $41718d655488e1fe$var$xt = {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        brands: "fab"
    },
    duotone: {
        solid: "fad",
        regular: "fadr",
        light: "fadl",
        thin: "fadt"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds",
        regular: "fasdr",
        light: "fasdl",
        thin: "fasdt"
    }
};
var $41718d655488e1fe$var$Ft = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $41718d655488e1fe$var$St = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $41718d655488e1fe$var$At = [
    "kit"
];
var $41718d655488e1fe$var$Ct = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $41718d655488e1fe$var$Lt = [
    "fak",
    "fakd"
], $41718d655488e1fe$var$Wt = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $41718d655488e1fe$var$Et = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $41718d655488e1fe$var$t$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $41718d655488e1fe$var$r$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $41718d655488e1fe$var$bt$1 = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
];
var $41718d655488e1fe$var$Yt = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
};
var $41718d655488e1fe$var$ua = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    }
}, $41718d655488e1fe$var$I$1 = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ]
}, $41718d655488e1fe$var$ga = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    }
}, $41718d655488e1fe$var$x = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands"
], $41718d655488e1fe$var$Ia = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    ...$41718d655488e1fe$var$r$1,
    ...$41718d655488e1fe$var$x
], $41718d655488e1fe$var$m$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands"
], $41718d655488e1fe$var$c$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $41718d655488e1fe$var$F$1 = $41718d655488e1fe$var$c$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $41718d655488e1fe$var$ma = [
    ...Object.keys($41718d655488e1fe$var$I$1),
    ...$41718d655488e1fe$var$m$1,
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $41718d655488e1fe$var$t$1.GROUP,
    $41718d655488e1fe$var$t$1.SWAP_OPACITY,
    $41718d655488e1fe$var$t$1.PRIMARY,
    $41718d655488e1fe$var$t$1.SECONDARY
].concat($41718d655488e1fe$var$c$1.map((a)=>"".concat(a, "x"))).concat($41718d655488e1fe$var$F$1.map((a)=>"w-".concat(a)));
var $41718d655488e1fe$var$wa = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
const $41718d655488e1fe$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
const $41718d655488e1fe$var$UNITS_IN_GRID = 16;
const $41718d655488e1fe$var$DEFAULT_CSS_PREFIX = 'fa';
const $41718d655488e1fe$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
const $41718d655488e1fe$var$DATA_FA_I2SVG = 'data-fa-i2svg';
const $41718d655488e1fe$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
const $41718d655488e1fe$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
const $41718d655488e1fe$var$DATA_PREFIX = 'data-prefix';
const $41718d655488e1fe$var$DATA_ICON = 'data-icon';
const $41718d655488e1fe$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
const $41718d655488e1fe$var$MUTATION_APPROACH_ASYNC = 'async';
const $41718d655488e1fe$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
const $41718d655488e1fe$var$PRODUCTION = (()=>{
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
})();
function $41718d655488e1fe$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get (target, prop) {
            return prop in target ? target[prop] : target[$41718d655488e1fe$var$s];
        }
    });
}
const $41718d655488e1fe$var$_PREFIX_TO_STYLE = $41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$S);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$41718d655488e1fe$var$_PREFIX_TO_STYLE[$41718d655488e1fe$var$s] = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $41718d655488e1fe$var$S[$41718d655488e1fe$var$s]), $41718d655488e1fe$var$St['kit']), $41718d655488e1fe$var$St['kit-duotone']);
const $41718d655488e1fe$var$PREFIX_TO_STYLE = $41718d655488e1fe$var$familyProxy($41718d655488e1fe$var$_PREFIX_TO_STYLE);
const $41718d655488e1fe$var$_STYLE_TO_PREFIX = $41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$xt);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$41718d655488e1fe$var$_STYLE_TO_PREFIX[$41718d655488e1fe$var$s] = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, {
    duotone: 'fad'
}), $41718d655488e1fe$var$_STYLE_TO_PREFIX[$41718d655488e1fe$var$s]), $41718d655488e1fe$var$Et['kit']), $41718d655488e1fe$var$Et['kit-duotone']);
const $41718d655488e1fe$var$STYLE_TO_PREFIX = $41718d655488e1fe$var$familyProxy($41718d655488e1fe$var$_STYLE_TO_PREFIX);
const $41718d655488e1fe$var$_PREFIX_TO_LONG_STYLE = $41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$ga);
$41718d655488e1fe$var$_PREFIX_TO_LONG_STYLE[$41718d655488e1fe$var$s] = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$_PREFIX_TO_LONG_STYLE[$41718d655488e1fe$var$s]), $41718d655488e1fe$var$Wt['kit']);
const $41718d655488e1fe$var$PREFIX_TO_LONG_STYLE = $41718d655488e1fe$var$familyProxy($41718d655488e1fe$var$_PREFIX_TO_LONG_STYLE);
const $41718d655488e1fe$var$_LONG_STYLE_TO_PREFIX = $41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$ua);
$41718d655488e1fe$var$_LONG_STYLE_TO_PREFIX[$41718d655488e1fe$var$s] = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$_LONG_STYLE_TO_PREFIX[$41718d655488e1fe$var$s]), $41718d655488e1fe$var$Ct['kit']);
const $41718d655488e1fe$var$LONG_STYLE_TO_PREFIX = $41718d655488e1fe$var$familyProxy($41718d655488e1fe$var$_LONG_STYLE_TO_PREFIX);
const $41718d655488e1fe$var$ICON_SELECTION_SYNTAX_PATTERN = $41718d655488e1fe$var$p; // eslint-disable-line no-useless-escape
const $41718d655488e1fe$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
const $41718d655488e1fe$var$FONT_FAMILY_PATTERN = $41718d655488e1fe$var$g;
const $41718d655488e1fe$var$_FONT_WEIGHT_TO_PREFIX = $41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$G);
const $41718d655488e1fe$var$FONT_WEIGHT_TO_PREFIX = $41718d655488e1fe$var$familyProxy($41718d655488e1fe$var$_FONT_WEIGHT_TO_PREFIX);
const $41718d655488e1fe$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
const $41718d655488e1fe$var$DUOTONE_CLASSES = $41718d655488e1fe$var$A;
const $41718d655488e1fe$var$RESERVED_CLASSES = [
    ...$41718d655488e1fe$var$At,
    ...$41718d655488e1fe$var$ma
];
const $41718d655488e1fe$var$initial = $41718d655488e1fe$var$WINDOW.FontAwesomeConfig || {};
function $41718d655488e1fe$var$getAttrConfig(attr) {
    var element = $41718d655488e1fe$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $41718d655488e1fe$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($41718d655488e1fe$var$DOCUMENT && typeof $41718d655488e1fe$var$DOCUMENT.querySelector === 'function') {
    const attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    attrs.forEach((_ref)=>{
        let [attr, key] = _ref;
        const val = $41718d655488e1fe$var$coerce($41718d655488e1fe$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $41718d655488e1fe$var$initial[key] = val;
    });
}
const $41718d655488e1fe$var$_default = {
    styleDefault: 'solid',
    familyDefault: $41718d655488e1fe$var$s,
    cssPrefix: $41718d655488e1fe$var$DEFAULT_CSS_PREFIX,
    replacementClass: $41718d655488e1fe$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($41718d655488e1fe$var$initial.familyPrefix) $41718d655488e1fe$var$initial.cssPrefix = $41718d655488e1fe$var$initial.familyPrefix;
const $41718d655488e1fe$var$_config = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$_default), $41718d655488e1fe$var$initial);
if (!$41718d655488e1fe$var$_config.autoReplaceSvg) $41718d655488e1fe$var$_config.observeMutations = false;
const $41718d655488e1fe$var$config = {};
Object.keys($41718d655488e1fe$var$_default).forEach((key)=>{
    Object.defineProperty($41718d655488e1fe$var$config, key, {
        enumerable: true,
        set: function(val) {
            $41718d655488e1fe$var$_config[key] = val;
            $41718d655488e1fe$var$_onChangeCb.forEach((cb)=>cb($41718d655488e1fe$var$config));
        },
        get: function() {
            return $41718d655488e1fe$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($41718d655488e1fe$var$config, 'familyPrefix', {
    enumerable: true,
    set: function(val) {
        $41718d655488e1fe$var$_config.cssPrefix = val;
        $41718d655488e1fe$var$_onChangeCb.forEach((cb)=>cb($41718d655488e1fe$var$config));
    },
    get: function() {
        return $41718d655488e1fe$var$_config.cssPrefix;
    }
});
$41718d655488e1fe$var$WINDOW.FontAwesomeConfig = $41718d655488e1fe$var$config;
const $41718d655488e1fe$var$_onChangeCb = [];
function $41718d655488e1fe$var$onChange(cb) {
    $41718d655488e1fe$var$_onChangeCb.push(cb);
    return ()=>{
        $41718d655488e1fe$var$_onChangeCb.splice($41718d655488e1fe$var$_onChangeCb.indexOf(cb), 1);
    };
}
const $41718d655488e1fe$var$d$2 = $41718d655488e1fe$var$UNITS_IN_GRID;
const $41718d655488e1fe$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $41718d655488e1fe$var$insertCss(css) {
    if (!css || !$41718d655488e1fe$var$IS_DOM) return;
    const style = $41718d655488e1fe$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    const headChildren = $41718d655488e1fe$var$DOCUMENT.head.childNodes;
    let beforeChild = null;
    for(let i = headChildren.length - 1; i > -1; i--){
        const child = headChildren[i];
        const tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $41718d655488e1fe$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
const $41718d655488e1fe$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $41718d655488e1fe$var$nextUniqueId() {
    let size = 12;
    let id = '';
    while(size-- > 0)id += $41718d655488e1fe$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $41718d655488e1fe$var$toArray(obj) {
    const array = [];
    for(let i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $41718d655488e1fe$var$classArray(node) {
    if (node.classList) return $41718d655488e1fe$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter((i)=>i);
}
function $41718d655488e1fe$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $41718d655488e1fe$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce((acc, attributeName)=>{
        return acc + "".concat(attributeName, "=\"").concat($41718d655488e1fe$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $41718d655488e1fe$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce((acc, styleName)=>{
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $41718d655488e1fe$var$transformIsMeaningful(transform) {
    return transform.size !== $41718d655488e1fe$var$meaninglessTransform.size || transform.x !== $41718d655488e1fe$var$meaninglessTransform.x || transform.y !== $41718d655488e1fe$var$meaninglessTransform.y || transform.rotate !== $41718d655488e1fe$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $41718d655488e1fe$var$transformForSvg(_ref) {
    let { transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
    const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $41718d655488e1fe$var$transformForCss(_ref2) {
    let { transform: transform, width: width = $41718d655488e1fe$var$UNITS_IN_GRID, height: height = $41718d655488e1fe$var$UNITS_IN_GRID, startCentered: startCentered = false } = _ref2;
    let val = '';
    if (startCentered && $41718d655488e1fe$var$IS_IE) val += "translate(".concat(transform.x / $41718d655488e1fe$var$d$2 - width / 2, "em, ").concat(transform.y / $41718d655488e1fe$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $41718d655488e1fe$var$d$2, "em), calc(-50% + ").concat(transform.y / $41718d655488e1fe$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $41718d655488e1fe$var$d$2, "em, ").concat(transform.y / $41718d655488e1fe$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $41718d655488e1fe$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $41718d655488e1fe$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $41718d655488e1fe$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Sharp Duotone\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}";
function $41718d655488e1fe$var$css() {
    const dcp = $41718d655488e1fe$var$DEFAULT_CSS_PREFIX;
    const drc = $41718d655488e1fe$var$DEFAULT_REPLACEMENT_CLASS;
    const fp = $41718d655488e1fe$var$config.cssPrefix;
    const rc = $41718d655488e1fe$var$config.replacementClass;
    let s = $41718d655488e1fe$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        const dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        const rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
let $41718d655488e1fe$var$_cssInserted = false;
function $41718d655488e1fe$var$ensureCss() {
    if ($41718d655488e1fe$var$config.autoAddCss && !$41718d655488e1fe$var$_cssInserted) {
        $41718d655488e1fe$var$insertCss($41718d655488e1fe$var$css());
        $41718d655488e1fe$var$_cssInserted = true;
    }
}
var $41718d655488e1fe$var$InjectCSS = {
    mixout () {
        return {
            dom: {
                css: $41718d655488e1fe$var$css,
                insertCss: $41718d655488e1fe$var$ensureCss
            }
        };
    },
    hooks () {
        return {
            beforeDOMElementCreation () {
                $41718d655488e1fe$var$ensureCss();
            },
            beforeI2svg () {
                $41718d655488e1fe$var$ensureCss();
            }
        };
    }
};
const $41718d655488e1fe$var$w = $41718d655488e1fe$var$WINDOW || {};
if (!$41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER]) $41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER] = {};
if (!$41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER].styles) $41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER].hooks) $41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER].shims) $41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER].shims = [];
var $41718d655488e1fe$var$namespace = $41718d655488e1fe$var$w[$41718d655488e1fe$var$NAMESPACE_IDENTIFIER];
const $41718d655488e1fe$var$functions = [];
const $41718d655488e1fe$var$listener = function() {
    $41718d655488e1fe$var$DOCUMENT.removeEventListener('DOMContentLoaded', $41718d655488e1fe$var$listener);
    $41718d655488e1fe$var$loaded = 1;
    $41718d655488e1fe$var$functions.map((fn)=>fn());
};
let $41718d655488e1fe$var$loaded = false;
if ($41718d655488e1fe$var$IS_DOM) {
    $41718d655488e1fe$var$loaded = ($41718d655488e1fe$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($41718d655488e1fe$var$DOCUMENT.readyState);
    if (!$41718d655488e1fe$var$loaded) $41718d655488e1fe$var$DOCUMENT.addEventListener('DOMContentLoaded', $41718d655488e1fe$var$listener);
}
function $41718d655488e1fe$var$domready(fn) {
    if (!$41718d655488e1fe$var$IS_DOM) return;
    $41718d655488e1fe$var$loaded ? setTimeout(fn, 0) : $41718d655488e1fe$var$functions.push(fn);
}
function $41718d655488e1fe$var$toHtml(abstractNodes) {
    const { tag: tag, attributes: attributes = {}, children: children = [] } = abstractNodes;
    if (typeof abstractNodes === 'string') return $41718d655488e1fe$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($41718d655488e1fe$var$joinAttributes(attributes), ">").concat(children.map($41718d655488e1fe$var$toHtml).join(''), "</").concat(tag, ">");
}
function $41718d655488e1fe$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $41718d655488e1fe$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $41718d655488e1fe$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $41718d655488e1fe$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $41718d655488e1fe$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $41718d655488e1fe$var$toHex(unicode) {
    const decoded = $41718d655488e1fe$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $41718d655488e1fe$var$codePointAt(string, index) {
    const size = string.length;
    let first = string.charCodeAt(index);
    let second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $41718d655488e1fe$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce((acc, iconName)=>{
        const icon = icons[iconName];
        const expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $41718d655488e1fe$var$defineIcons(prefix, icons) {
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { skipHooks: skipHooks = false } = params;
    const normalized = $41718d655488e1fe$var$normalizeIcons(icons);
    if (typeof $41718d655488e1fe$var$namespace.hooks.addPack === 'function' && !skipHooks) $41718d655488e1fe$var$namespace.hooks.addPack(prefix, $41718d655488e1fe$var$normalizeIcons(icons));
    else $41718d655488e1fe$var$namespace.styles[prefix] = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $41718d655488e1fe$var$defineIcons('fa', icons);
}
const $41718d655488e1fe$var$duotonePathRe = [
    /*#__PURE__*/ $41718d655488e1fe$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $41718d655488e1fe$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)".*path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $41718d655488e1fe$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2
    })
];
const { styles: $41718d655488e1fe$var$styles, shims: $41718d655488e1fe$var$shims } = $41718d655488e1fe$var$namespace;
const $41718d655488e1fe$var$FAMILY_NAMES = Object.keys($41718d655488e1fe$var$PREFIX_TO_LONG_STYLE);
const $41718d655488e1fe$var$PREFIXES_FOR_FAMILY = $41718d655488e1fe$var$FAMILY_NAMES.reduce((acc, familyId)=>{
    acc[familyId] = Object.keys($41718d655488e1fe$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
let $41718d655488e1fe$var$_defaultUsablePrefix = null;
let $41718d655488e1fe$var$_byUnicode = {};
let $41718d655488e1fe$var$_byLigature = {};
let $41718d655488e1fe$var$_byOldName = {};
let $41718d655488e1fe$var$_byOldUnicode = {};
let $41718d655488e1fe$var$_byAlias = {};
function $41718d655488e1fe$var$isReserved(name) {
    return ~$41718d655488e1fe$var$RESERVED_CLASSES.indexOf(name);
}
function $41718d655488e1fe$var$getIconName(cssPrefix, cls) {
    const parts = cls.split('-');
    const prefix = parts[0];
    const iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$41718d655488e1fe$var$isReserved(iconName)) return iconName;
    else return null;
}
const $41718d655488e1fe$var$build = ()=>{
    const lookup = (reducer)=>{
        return $41718d655488e1fe$var$reduce($41718d655488e1fe$var$styles, (o$$1, style, prefix)=>{
            o$$1[prefix] = $41718d655488e1fe$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $41718d655488e1fe$var$_byUnicode = lookup((acc, icon, iconName)=>{
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'number';
            });
            aliases.forEach((alias)=>{
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $41718d655488e1fe$var$_byLigature = lookup((acc, icon, iconName)=>{
        acc[iconName] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'string';
            });
            aliases.forEach((alias)=>{
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $41718d655488e1fe$var$_byAlias = lookup((acc, icon, iconName)=>{
        const aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach((alias)=>{
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    const hasRegular = 'far' in $41718d655488e1fe$var$styles || $41718d655488e1fe$var$config.autoFetchSvg;
    const shimLookups = $41718d655488e1fe$var$reduce($41718d655488e1fe$var$shims, (acc, shim)=>{
        const maybeNameMaybeUnicode = shim[0];
        let prefix = shim[1];
        const iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $41718d655488e1fe$var$_byOldName = shimLookups.names;
    $41718d655488e1fe$var$_byOldUnicode = shimLookups.unicodes;
    $41718d655488e1fe$var$_defaultUsablePrefix = $41718d655488e1fe$var$getCanonicalPrefix($41718d655488e1fe$var$config.styleDefault, {
        family: $41718d655488e1fe$var$config.familyDefault
    });
};
$41718d655488e1fe$var$onChange((c$$1)=>{
    $41718d655488e1fe$var$_defaultUsablePrefix = $41718d655488e1fe$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $41718d655488e1fe$var$config.familyDefault
    });
});
$41718d655488e1fe$var$build();
function $41718d655488e1fe$var$byUnicode(prefix, unicode) {
    return ($41718d655488e1fe$var$_byUnicode[prefix] || {})[unicode];
}
function $41718d655488e1fe$var$byLigature(prefix, ligature) {
    return ($41718d655488e1fe$var$_byLigature[prefix] || {})[ligature];
}
function $41718d655488e1fe$var$byAlias(prefix, alias) {
    return ($41718d655488e1fe$var$_byAlias[prefix] || {})[alias];
}
function $41718d655488e1fe$var$byOldName(name) {
    return $41718d655488e1fe$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $41718d655488e1fe$var$byOldUnicode(unicode) {
    const oldUnicode = $41718d655488e1fe$var$_byOldUnicode[unicode];
    const newUnicode = $41718d655488e1fe$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $41718d655488e1fe$var$getDefaultUsablePrefix() {
    return $41718d655488e1fe$var$_defaultUsablePrefix;
}
const $41718d655488e1fe$var$emptyCanonicalIcon = ()=>{
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $41718d655488e1fe$var$getFamilyId(values) {
    let family = $41718d655488e1fe$var$s;
    const famProps = $41718d655488e1fe$var$FAMILY_NAMES.reduce((acc, familyId)=>{
        acc[familyId] = "".concat($41718d655488e1fe$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $41718d655488e1fe$var$L.forEach((familyId)=>{
        if (values.includes(famProps[familyId]) || values.some((v$$1)=>$41718d655488e1fe$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) family = familyId;
    });
    return family;
}
function $41718d655488e1fe$var$getCanonicalPrefix(styleOrPrefix) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { family: family = $41718d655488e1fe$var$s } = params;
    const style = $41718d655488e1fe$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $41718d655488e1fe$var$t && !styleOrPrefix) return 'fad';
    const prefix = $41718d655488e1fe$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $41718d655488e1fe$var$STYLE_TO_PREFIX[family][style];
    const defined = styleOrPrefix in $41718d655488e1fe$var$namespace.styles ? styleOrPrefix : null;
    const result = prefix || defined || null;
    return result;
}
function $41718d655488e1fe$var$moveNonFaClassesToRest(classNames) {
    let rest = [];
    let iconName = null;
    classNames.forEach((cls)=>{
        const result = $41718d655488e1fe$var$getIconName($41718d655488e1fe$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $41718d655488e1fe$var$sortedUniqueValues(arr) {
    return arr.sort().filter((value, index, arr)=>{
        return arr.indexOf(value) === index;
    });
}
function $41718d655488e1fe$var$getCanonicalIcon(values) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { skipLookups: skipLookups = false } = params;
    let givenPrefix = null;
    const faCombinedClasses = $41718d655488e1fe$var$Ia.concat($41718d655488e1fe$var$bt$1);
    const faStyleOrFamilyClasses = $41718d655488e1fe$var$sortedUniqueValues(values.filter((cls)=>faCombinedClasses.includes(cls)));
    const nonStyleOrFamilyClasses = $41718d655488e1fe$var$sortedUniqueValues(values.filter((cls)=>!$41718d655488e1fe$var$Ia.includes(cls)));
    const faStyles = faStyleOrFamilyClasses.filter((cls)=>{
        givenPrefix = cls;
        return !$41718d655488e1fe$var$P.includes(cls);
    });
    const [styleFromValues = null] = faStyles;
    const family = $41718d655488e1fe$var$getFamilyId(faStyleOrFamilyClasses);
    const canonical = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $41718d655488e1fe$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, canonical), $41718d655488e1fe$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $41718d655488e1fe$var$styles,
        config: $41718d655488e1fe$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $41718d655488e1fe$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $41718d655488e1fe$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    let { prefix: prefix, iconName: iconName } = canonical;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    const shim = givenPrefix === 'fa' ? $41718d655488e1fe$var$byOldName(iconName) : {};
    const aliasIconName = $41718d655488e1fe$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$41718d655488e1fe$var$styles['far'] && $41718d655488e1fe$var$styles['fas'] && !$41718d655488e1fe$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
const $41718d655488e1fe$var$newCanonicalFamilies = $41718d655488e1fe$var$L.filter((familyId)=>{
    return familyId !== $41718d655488e1fe$var$s || familyId !== $41718d655488e1fe$var$t;
});
const $41718d655488e1fe$var$newCanonicalStyles = Object.keys($41718d655488e1fe$var$ga).filter((key)=>key !== $41718d655488e1fe$var$s).map((key)=>Object.keys($41718d655488e1fe$var$ga[key])).flat();
function $41718d655488e1fe$var$getDefaultCanonicalPrefix(prefixOptions) {
    const { values: values, family: family, canonical: canonical, givenPrefix: givenPrefix = '', styles: styles = {}, config: config$$1 = {} } = prefixOptions;
    const isDuotoneFamily = family === $41718d655488e1fe$var$t;
    const valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    const defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    const canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $41718d655488e1fe$var$newCanonicalFamilies.includes(family)) {
        const validPrefix = Object.keys(styles).find((key)=>$41718d655488e1fe$var$newCanonicalStyles.includes(key));
        if (validPrefix || config$$1.autoFetchSvg) {
            const defaultPrefix = $41718d655488e1fe$var$pt.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $41718d655488e1fe$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $41718d655488e1fe$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
class $41718d655488e1fe$var$Library {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
        const additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach((key)=>{
            this.definitions[key] = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, this.definitions[key] || {}), additions[key]);
            $41718d655488e1fe$var$defineIcons(key, additions[key]);
            // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
            const longPrefix = $41718d655488e1fe$var$PREFIX_TO_LONG_STYLE[$41718d655488e1fe$var$s][key];
            if (longPrefix) $41718d655488e1fe$var$defineIcons(longPrefix, additions[key]);
            $41718d655488e1fe$var$build();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(additions, definition) {
        const normalized = definition.prefix && definition.iconName && definition.icon ? {
            0: definition
        } : definition;
        Object.keys(normalized).map((key)=>{
            const { prefix: prefix, iconName: iconName, icon: icon } = normalized[key];
            const aliases = icon[2];
            if (!additions[prefix]) additions[prefix] = {};
            if (aliases.length > 0) aliases.forEach((alias)=>{
                if (typeof alias === 'string') additions[prefix][alias] = icon;
            });
            additions[prefix][iconName] = icon;
        });
        return additions;
    }
}
let $41718d655488e1fe$var$_plugins = [];
let $41718d655488e1fe$var$_hooks = {};
const $41718d655488e1fe$var$providers = {};
const $41718d655488e1fe$var$defaultProviderKeys = Object.keys($41718d655488e1fe$var$providers);
function $41718d655488e1fe$var$registerPlugins(nextPlugins, _ref) {
    let { mixoutsTo: obj } = _ref;
    $41718d655488e1fe$var$_plugins = nextPlugins;
    $41718d655488e1fe$var$_hooks = {};
    Object.keys($41718d655488e1fe$var$providers).forEach((k)=>{
        if ($41718d655488e1fe$var$defaultProviderKeys.indexOf(k) === -1) delete $41718d655488e1fe$var$providers[k];
    });
    $41718d655488e1fe$var$_plugins.forEach((plugin)=>{
        const mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach((tk)=>{
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if (typeof mixout[tk] === 'object') Object.keys(mixout[tk]).forEach((sk)=>{
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            const hooks = plugin.hooks();
            Object.keys(hooks).forEach((hook)=>{
                if (!$41718d655488e1fe$var$_hooks[hook]) $41718d655488e1fe$var$_hooks[hook] = [];
                $41718d655488e1fe$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($41718d655488e1fe$var$providers);
    });
    return obj;
}
function $41718d655488e1fe$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    const hookFns = $41718d655488e1fe$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        accumulator = hookFn.apply(null, [
            accumulator,
            ...args
        ]); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $41718d655488e1fe$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    const hookFns = $41718d655488e1fe$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        hookFn.apply(null, args);
    });
    return undefined;
}
function $41718d655488e1fe$var$callProvided() {
    const hook = arguments[0];
    const args = Array.prototype.slice.call(arguments, 1);
    return $41718d655488e1fe$var$providers[hook] ? $41718d655488e1fe$var$providers[hook].apply(null, args) : undefined;
}
function $41718d655488e1fe$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    let { iconName: iconName } = iconLookup;
    const prefix = iconLookup.prefix || $41718d655488e1fe$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $41718d655488e1fe$var$byAlias(prefix, iconName) || iconName;
    return $41718d655488e1fe$var$iconFromMapping($41718d655488e1fe$var$library.definitions, prefix, iconName) || $41718d655488e1fe$var$iconFromMapping($41718d655488e1fe$var$namespace.styles, prefix, iconName);
}
const $41718d655488e1fe$var$library = new $41718d655488e1fe$var$Library();
const $41718d655488e1fe$var$noAuto = ()=>{
    $41718d655488e1fe$var$config.autoReplaceSvg = false;
    $41718d655488e1fe$var$config.observeMutations = false;
    $41718d655488e1fe$var$callHooks('noAuto');
};
const $41718d655488e1fe$var$dom = {
    i2svg: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($41718d655488e1fe$var$IS_DOM) {
            $41718d655488e1fe$var$callHooks('beforeI2svg', params);
            $41718d655488e1fe$var$callProvided('pseudoElements2svg', params);
            return $41718d655488e1fe$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { autoReplaceSvgRoot: autoReplaceSvgRoot } = params;
        if ($41718d655488e1fe$var$config.autoReplaceSvg === false) $41718d655488e1fe$var$config.autoReplaceSvg = true;
        $41718d655488e1fe$var$config.observeMutations = true;
        $41718d655488e1fe$var$domready(()=>{
            $41718d655488e1fe$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $41718d655488e1fe$var$callHooks('watch', params);
        });
    }
};
const $41718d655488e1fe$var$parse = {
    icon: (icon)=>{
        if (icon === null) return null;
        if (typeof icon === 'object' && icon.prefix && icon.iconName) return {
            prefix: icon.prefix,
            iconName: $41718d655488e1fe$var$byAlias(icon.prefix, icon.iconName) || icon.iconName
        };
        if (Array.isArray(icon) && icon.length === 2) {
            const iconName = icon[1].indexOf('fa-') === 0 ? icon[1].slice(3) : icon[1];
            const prefix = $41718d655488e1fe$var$getCanonicalPrefix(icon[0]);
            return {
                prefix: prefix,
                iconName: $41718d655488e1fe$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof icon === 'string' && (icon.indexOf("".concat($41718d655488e1fe$var$config.cssPrefix, "-")) > -1 || icon.match($41718d655488e1fe$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            const canonicalIcon = $41718d655488e1fe$var$getCanonicalIcon(icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $41718d655488e1fe$var$getDefaultUsablePrefix(),
                iconName: $41718d655488e1fe$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof icon === 'string') {
            const prefix = $41718d655488e1fe$var$getDefaultUsablePrefix();
            return {
                prefix: prefix,
                iconName: $41718d655488e1fe$var$byAlias(prefix, icon) || icon
            };
        }
    }
};
const $41718d655488e1fe$export$644d8ea042df96a6 = {
    noAuto: $41718d655488e1fe$var$noAuto,
    config: $41718d655488e1fe$var$config,
    dom: $41718d655488e1fe$var$dom,
    parse: $41718d655488e1fe$var$parse,
    library: $41718d655488e1fe$var$library,
    findIconDefinition: $41718d655488e1fe$var$findIconDefinition,
    toHtml: $41718d655488e1fe$var$toHtml
};
const $41718d655488e1fe$var$autoReplace = function() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { autoReplaceSvgRoot: autoReplaceSvgRoot = $41718d655488e1fe$var$DOCUMENT } = params;
    if ((Object.keys($41718d655488e1fe$var$namespace.styles).length > 0 || $41718d655488e1fe$var$config.autoFetchSvg) && $41718d655488e1fe$var$IS_DOM && $41718d655488e1fe$var$config.autoReplaceSvg) $41718d655488e1fe$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $41718d655488e1fe$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function() {
            return val.abstract.map((a)=>$41718d655488e1fe$var$toHtml(a));
        }
    });
    Object.defineProperty(val, 'node', {
        get: function() {
            if (!$41718d655488e1fe$var$IS_DOM) return;
            const container = $41718d655488e1fe$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $41718d655488e1fe$var$asIcon(_ref) {
    let { children: children, main: main, mask: mask, attributes: attributes, styles: styles, transform: transform } = _ref;
    if ($41718d655488e1fe$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        const { width: width, height: height } = main;
        const offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $41718d655488e1fe$var$joinStyles($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $41718d655488e1fe$var$asSymbol(_ref) {
    let { prefix: prefix, iconName: iconName, children: children, attributes: attributes, symbol: symbol } = _ref;
    const id = symbol === true ? "".concat(prefix, "-").concat($41718d655488e1fe$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $41718d655488e1fe$var$makeInlineSvgAbstract(params) {
    const { icons: { main: main, mask: mask }, prefix: prefix, iconName: iconName, transform: transform, symbol: symbol, title: title, maskId: maskId, titleId: titleId, extra: extra, watchable: watchable = false } = params;
    const { width: width, height: height } = mask.found ? mask : main;
    const isUploadedIcon = $41718d655488e1fe$var$Lt.includes(prefix);
    const attrClass = [
        $41718d655488e1fe$var$config.replacementClass,
        iconName ? "".concat($41718d655488e1fe$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter((c$$1)=>extra.classes.indexOf(c$$1) === -1).filter((c$$1)=>c$$1 !== '' || !!c$$1).concat(extra.classes).join(' ');
    let content = {
        children: [],
        attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$41718d655488e1fe$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $41718d655488e1fe$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    const args = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    const { children: children, attributes: attributes } = mask.found && main.found ? $41718d655488e1fe$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $41718d655488e1fe$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    };
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $41718d655488e1fe$var$asSymbol(args);
    else return $41718d655488e1fe$var$asIcon(args);
}
function $41718d655488e1fe$var$makeLayersTextAbstract(params) {
    const { content: content, width: width, height: height, transform: transform, title: title, extra: extra, watchable: watchable = false } = params;
    const attributes = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$41718d655488e1fe$var$DATA_FA_I2SVG] = '';
    const styles = $41718d655488e1fe$var$_objectSpread2({}, extra.styles);
    if ($41718d655488e1fe$var$transformIsMeaningful(transform)) {
        styles['transform'] = $41718d655488e1fe$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    const styleString = $41718d655488e1fe$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $41718d655488e1fe$var$makeLayersCounterAbstract(params) {
    const { content: content, title: title, extra: extra } = params;
    const attributes = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    const styleString = $41718d655488e1fe$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
const { styles: $41718d655488e1fe$var$styles$1 } = $41718d655488e1fe$var$namespace;
function $41718d655488e1fe$var$asFoundIcon(icon) {
    const width = icon[0];
    const height = icon[1];
    const [vectorData] = icon.slice(4);
    let element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($41718d655488e1fe$var$config.cssPrefix, "-").concat($41718d655488e1fe$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($41718d655488e1fe$var$config.cssPrefix, "-").concat($41718d655488e1fe$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($41718d655488e1fe$var$config.cssPrefix, "-").concat($41718d655488e1fe$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
const $41718d655488e1fe$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $41718d655488e1fe$var$maybeNotifyMissing(iconName, prefix) {
    if (!$41718d655488e1fe$var$PRODUCTION && !$41718d655488e1fe$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $41718d655488e1fe$var$findIcon(iconName, prefix) {
    let givenPrefix = prefix;
    if (prefix === 'fa' && $41718d655488e1fe$var$config.styleDefault !== null) prefix = $41718d655488e1fe$var$getDefaultUsablePrefix();
    return new Promise((resolve, reject)=>{
        if (givenPrefix === 'fa') {
            const shim = $41718d655488e1fe$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $41718d655488e1fe$var$styles$1[prefix] && $41718d655488e1fe$var$styles$1[prefix][iconName]) {
            const icon = $41718d655488e1fe$var$styles$1[prefix][iconName];
            return resolve($41718d655488e1fe$var$asFoundIcon(icon));
        }
        $41718d655488e1fe$var$maybeNotifyMissing(iconName, prefix);
        resolve($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$missingIconResolutionMixin), {}, {
            icon: $41718d655488e1fe$var$config.showMissingIcons && iconName ? $41718d655488e1fe$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
const $41718d655488e1fe$var$noop$1 = ()=>{};
const $41718d655488e1fe$var$p$2 = $41718d655488e1fe$var$config.measurePerformance && $41718d655488e1fe$var$PERFORMANCE && $41718d655488e1fe$var$PERFORMANCE.mark && $41718d655488e1fe$var$PERFORMANCE.measure ? $41718d655488e1fe$var$PERFORMANCE : {
    mark: $41718d655488e1fe$var$noop$1,
    measure: $41718d655488e1fe$var$noop$1
};
const $41718d655488e1fe$var$preamble = "FA \"6.7.2\"";
const $41718d655488e1fe$var$begin = (name)=>{
    $41718d655488e1fe$var$p$2.mark("".concat($41718d655488e1fe$var$preamble, " ").concat(name, " begins"));
    return ()=>$41718d655488e1fe$var$end(name);
};
const $41718d655488e1fe$var$end = (name)=>{
    $41718d655488e1fe$var$p$2.mark("".concat($41718d655488e1fe$var$preamble, " ").concat(name, " ends"));
    $41718d655488e1fe$var$p$2.measure("".concat($41718d655488e1fe$var$preamble, " ").concat(name), "".concat($41718d655488e1fe$var$preamble, " ").concat(name, " begins"), "".concat($41718d655488e1fe$var$preamble, " ").concat(name, " ends"));
};
var $41718d655488e1fe$var$perf = {
    begin: $41718d655488e1fe$var$begin,
    end: $41718d655488e1fe$var$end
};
const $41718d655488e1fe$var$noop$2 = ()=>{};
function $41718d655488e1fe$var$isWatched(node) {
    const i2svg = node.getAttribute ? node.getAttribute($41718d655488e1fe$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $41718d655488e1fe$var$hasPrefixAndIcon(node) {
    const prefix = node.getAttribute ? node.getAttribute($41718d655488e1fe$var$DATA_PREFIX) : null;
    const icon = node.getAttribute ? node.getAttribute($41718d655488e1fe$var$DATA_ICON) : null;
    return prefix && icon;
}
function $41718d655488e1fe$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($41718d655488e1fe$var$config.replacementClass);
}
function $41718d655488e1fe$var$getMutator() {
    if ($41718d655488e1fe$var$config.autoReplaceSvg === true) return $41718d655488e1fe$var$mutators.replace;
    const mutator = $41718d655488e1fe$var$mutators[$41718d655488e1fe$var$config.autoReplaceSvg];
    return mutator || $41718d655488e1fe$var$mutators.replace;
}
function $41718d655488e1fe$var$createElementNS(tag) {
    return $41718d655488e1fe$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $41718d655488e1fe$var$createElement(tag) {
    return $41718d655488e1fe$var$DOCUMENT.createElement(tag);
}
function $41718d655488e1fe$var$convertSVG(abstractObj) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { ceFn: ceFn = abstractObj.tag === 'svg' ? $41718d655488e1fe$var$createElementNS : $41718d655488e1fe$var$createElement } = params;
    if (typeof abstractObj === 'string') return $41718d655488e1fe$var$DOCUMENT.createTextNode(abstractObj);
    const tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    const children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($41718d655488e1fe$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $41718d655488e1fe$var$nodeAsComment(node) {
    let comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
const $41718d655488e1fe$var$mutators = {
    replace: function(mutation) {
        const node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach((abstract)=>{
                node.parentNode.insertBefore($41718d655488e1fe$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($41718d655488e1fe$var$DATA_FA_I2SVG) === null && $41718d655488e1fe$var$config.keepOriginalSource) {
                let comment = $41718d655488e1fe$var$DOCUMENT.createComment($41718d655488e1fe$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function(mutation) {
        const node = mutation[0];
        const abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$41718d655488e1fe$var$classArray(node).indexOf($41718d655488e1fe$var$config.replacementClass)) return $41718d655488e1fe$var$mutators.replace(mutation);
        const forSvg = new RegExp("".concat($41718d655488e1fe$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            const splitClasses = abstract[0].attributes.class.split(' ').reduce((acc, cls)=>{
                if (cls === $41718d655488e1fe$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        const newInnerHTML = abstract.map((a)=>$41718d655488e1fe$var$toHtml(a)).join('\n');
        node.setAttribute($41718d655488e1fe$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $41718d655488e1fe$var$performOperationSync(op) {
    op();
}
function $41718d655488e1fe$var$perform(mutations, callback) {
    const callbackFunction = typeof callback === 'function' ? callback : $41718d655488e1fe$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        let frame = $41718d655488e1fe$var$performOperationSync;
        if ($41718d655488e1fe$var$config.mutateApproach === $41718d655488e1fe$var$MUTATION_APPROACH_ASYNC) frame = $41718d655488e1fe$var$WINDOW.requestAnimationFrame || $41718d655488e1fe$var$performOperationSync;
        frame(()=>{
            const mutator = $41718d655488e1fe$var$getMutator();
            const mark = $41718d655488e1fe$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
let $41718d655488e1fe$var$disabled = false;
function $41718d655488e1fe$var$disableObservation() {
    $41718d655488e1fe$var$disabled = true;
}
function $41718d655488e1fe$var$enableObservation() {
    $41718d655488e1fe$var$disabled = false;
}
let $41718d655488e1fe$var$mo = null;
function $41718d655488e1fe$var$observe(options) {
    if (!$41718d655488e1fe$var$MUTATION_OBSERVER) return;
    if (!$41718d655488e1fe$var$config.observeMutations) return;
    const { treeCallback: treeCallback = $41718d655488e1fe$var$noop$2, nodeCallback: nodeCallback = $41718d655488e1fe$var$noop$2, pseudoElementsCallback: pseudoElementsCallback = $41718d655488e1fe$var$noop$2, observeMutationsRoot: observeMutationsRoot = $41718d655488e1fe$var$DOCUMENT } = options;
    $41718d655488e1fe$var$mo = new $41718d655488e1fe$var$MUTATION_OBSERVER((objects)=>{
        if ($41718d655488e1fe$var$disabled) return;
        const defaultPrefix = $41718d655488e1fe$var$getDefaultUsablePrefix();
        $41718d655488e1fe$var$toArray(objects).forEach((mutationRecord)=>{
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$41718d655488e1fe$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($41718d655488e1fe$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $41718d655488e1fe$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $41718d655488e1fe$var$isWatched(mutationRecord.target) && ~$41718d655488e1fe$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $41718d655488e1fe$var$hasPrefixAndIcon(mutationRecord.target)) {
                    const { prefix: prefix, iconName: iconName } = $41718d655488e1fe$var$getCanonicalIcon($41718d655488e1fe$var$classArray(mutationRecord.target));
                    mutationRecord.target.setAttribute($41718d655488e1fe$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($41718d655488e1fe$var$DATA_ICON, iconName);
                } else if ($41718d655488e1fe$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$41718d655488e1fe$var$IS_DOM) return;
    $41718d655488e1fe$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $41718d655488e1fe$var$disconnect() {
    if (!$41718d655488e1fe$var$mo) return;
    $41718d655488e1fe$var$mo.disconnect();
}
function $41718d655488e1fe$var$styleParser(node) {
    const style = node.getAttribute('style');
    let val = [];
    if (style) val = style.split(';').reduce((acc, style)=>{
        const styles = style.split(':');
        const prop = styles[0];
        const value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $41718d655488e1fe$var$classParser(node) {
    const existingPrefix = node.getAttribute('data-prefix');
    const existingIconName = node.getAttribute('data-icon');
    const innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    let val = $41718d655488e1fe$var$getCanonicalIcon($41718d655488e1fe$var$classArray(node));
    if (!val.prefix) val.prefix = $41718d655488e1fe$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $41718d655488e1fe$var$byLigature(val.prefix, node.innerText) || $41718d655488e1fe$var$byUnicode(val.prefix, $41718d655488e1fe$var$toHex(node.innerText));
    if (!val.iconName && $41718d655488e1fe$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $41718d655488e1fe$var$attributesParser(node) {
    const extraAttributes = $41718d655488e1fe$var$toArray(node.attributes).reduce((acc, attr)=>{
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    const title = node.getAttribute('title');
    const titleId = node.getAttribute('data-fa-title-id');
    if ($41718d655488e1fe$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($41718d655488e1fe$var$config.replacementClass, "-title-").concat(titleId || $41718d655488e1fe$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $41718d655488e1fe$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $41718d655488e1fe$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $41718d655488e1fe$var$parseMeta(node) {
    let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    const { iconName: iconName, prefix: prefix, rest: extraClasses } = $41718d655488e1fe$var$classParser(node);
    const extraAttributes = $41718d655488e1fe$var$attributesParser(node);
    const pluginMeta = $41718d655488e1fe$var$chainHooks('parseNodeAttributes', {}, node);
    let extraStyles = parser.styleParser ? $41718d655488e1fe$var$styleParser(node) : [];
    return $41718d655488e1fe$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $41718d655488e1fe$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
const { styles: $41718d655488e1fe$var$styles$2 } = $41718d655488e1fe$var$namespace;
function $41718d655488e1fe$var$generateMutation(node) {
    const nodeMeta = $41718d655488e1fe$var$config.autoReplaceSvg === 'nest' ? $41718d655488e1fe$var$parseMeta(node, {
        styleParser: false
    }) : $41718d655488e1fe$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($41718d655488e1fe$var$LAYERS_TEXT_CLASSNAME)) return $41718d655488e1fe$var$callProvided('generateLayersText', node, nodeMeta);
    else return $41718d655488e1fe$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $41718d655488e1fe$var$getKnownPrefixes() {
    return [
        ...$41718d655488e1fe$var$Ft,
        ...$41718d655488e1fe$var$Ia
    ];
}
function $41718d655488e1fe$var$onTree(root) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$41718d655488e1fe$var$IS_DOM) return Promise.resolve();
    const htmlClassList = $41718d655488e1fe$var$DOCUMENT.documentElement.classList;
    const hclAdd = (suffix)=>htmlClassList.add("".concat($41718d655488e1fe$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const hclRemove = (suffix)=>htmlClassList.remove("".concat($41718d655488e1fe$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const prefixes = $41718d655488e1fe$var$config.autoFetchSvg ? $41718d655488e1fe$var$getKnownPrefixes() : $41718d655488e1fe$var$P.concat(Object.keys($41718d655488e1fe$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    const prefixesDomQuery = [
        ".".concat($41718d655488e1fe$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($41718d655488e1fe$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map((p$$1)=>".".concat(p$$1, ":not([").concat($41718d655488e1fe$var$DATA_FA_I2SVG, "])"))).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    let candidates = [];
    try {
        candidates = $41718d655488e1fe$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    const mark = $41718d655488e1fe$var$perf.begin('onTree');
    const mutations = candidates.reduce((acc, node)=>{
        try {
            const mutation = $41718d655488e1fe$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$41718d655488e1fe$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise((resolve, reject)=>{
        Promise.all(mutations).then((resolvedMutations)=>{
            $41718d655488e1fe$var$perform(resolvedMutations, ()=>{
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch((e$$1)=>{
            mark();
            reject(e$$1);
        });
    });
}
function $41718d655488e1fe$var$onNode(node) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $41718d655488e1fe$var$generateMutation(node).then((mutation)=>{
        if (mutation) $41718d655488e1fe$var$perform([
            mutation
        ], callback);
    });
}
function $41718d655488e1fe$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $41718d655488e1fe$var$findIconDefinition(maybeIconDefinition || {});
        let { mask: mask } = params;
        if (mask) mask = (mask || {}).icon ? mask : $41718d655488e1fe$var$findIconDefinition(mask || {});
        return next(iconDefinition, $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
const $41718d655488e1fe$var$render = function(iconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { transform: transform = $41718d655488e1fe$var$meaninglessTransform, symbol: symbol = false, mask: mask = null, maskId: maskId = null, title: title = null, titleId: titleId = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
    if (!iconDefinition) return;
    const { prefix: prefix, iconName: iconName, icon: icon } = iconDefinition;
    return $41718d655488e1fe$var$domVariants($41718d655488e1fe$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), ()=>{
        $41718d655488e1fe$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($41718d655488e1fe$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($41718d655488e1fe$var$config.replacementClass, "-title-").concat(titleId || $41718d655488e1fe$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $41718d655488e1fe$var$makeInlineSvgAbstract({
            icons: {
                main: $41718d655488e1fe$var$asFoundIcon(icon),
                mask: mask ? $41718d655488e1fe$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $41718d655488e1fe$var$ReplaceElements = {
    mixout () {
        return {
            icon: $41718d655488e1fe$var$resolveIcons($41718d655488e1fe$var$render)
        };
    },
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.treeCallback = $41718d655488e1fe$var$onTree;
                accumulator.nodeCallback = $41718d655488e1fe$var$onNode;
                return accumulator;
            }
        };
    },
    provides (providers$$1) {
        providers$$1.i2svg = function(params) {
            const { node: node = $41718d655488e1fe$var$DOCUMENT, callback: callback = ()=>{} } = params;
            return $41718d655488e1fe$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            const { iconName: iconName, title: title, titleId: titleId, prefix: prefix, transform: transform, symbol: symbol, mask: mask, maskId: maskId, extra: extra } = nodeMeta;
            return new Promise((resolve, reject)=>{
                Promise.all([
                    $41718d655488e1fe$var$findIcon(iconName, prefix),
                    mask.iconName ? $41718d655488e1fe$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((_ref)=>{
                    let [main, mask] = _ref;
                    resolve([
                        node,
                        $41718d655488e1fe$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref2) {
            let { children: children, attributes: attributes, main: main, transform: transform, styles: styles } = _ref2;
            const styleString = $41718d655488e1fe$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            let nextChild;
            if ($41718d655488e1fe$var$transformIsMeaningful(transform)) nextChild = $41718d655488e1fe$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $41718d655488e1fe$var$Layers = {
    mixout () {
        return {
            layer (assembler) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { classes: classes = [] } = params;
                return $41718d655488e1fe$var$domVariants({
                    type: 'layer'
                }, ()=>{
                    $41718d655488e1fe$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    let children = [];
                    assembler((args)=>{
                        Array.isArray(args) ? args.map((a)=>{
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($41718d655488e1fe$var$config.cssPrefix, "-layers"),
                                    ...classes
                                ].join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $41718d655488e1fe$var$LayersCounter = {
    mixout () {
        return {
            counter (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $41718d655488e1fe$var$domVariants({
                    type: 'counter',
                    content: content
                }, ()=>{
                    $41718d655488e1fe$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $41718d655488e1fe$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($41718d655488e1fe$var$config.cssPrefix, "-layers-counter"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    }
};
var $41718d655488e1fe$var$LayersText = {
    mixout () {
        return {
            text (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { transform: transform = $41718d655488e1fe$var$meaninglessTransform, title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $41718d655488e1fe$var$domVariants({
                    type: 'text',
                    content: content
                }, ()=>{
                    $41718d655488e1fe$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $41718d655488e1fe$var$makeLayersTextAbstract({
                        content: content,
                        transform: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($41718d655488e1fe$var$config.cssPrefix, "-layers-text"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    },
    provides (providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            const { title: title, transform: transform, extra: extra } = nodeMeta;
            let width = null;
            let height = null;
            if ($41718d655488e1fe$var$IS_IE) {
                const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                const boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($41718d655488e1fe$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $41718d655488e1fe$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
const $41718d655488e1fe$var$CLEAN_CONTENT_PATTERN = new RegExp('"', 'ug');
const $41718d655488e1fe$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
const $41718d655488e1fe$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $41718d655488e1fe$var$lt), $41718d655488e1fe$var$wa), $41718d655488e1fe$var$Yt);
const $41718d655488e1fe$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($41718d655488e1fe$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key)=>{
    acc[key.toLowerCase()] = $41718d655488e1fe$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
const $41718d655488e1fe$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($41718d655488e1fe$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily)=>{
    const weights = $41718d655488e1fe$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || [
        ...Object.entries(weights)
    ][0][1];
    return acc;
}, {});
function $41718d655488e1fe$var$hexValueFromContent(content) {
    const cleaned = content.replace($41718d655488e1fe$var$CLEAN_CONTENT_PATTERN, '');
    const codePoint = $41718d655488e1fe$var$codePointAt(cleaned, 0);
    const isPrependTen = codePoint >= $41718d655488e1fe$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $41718d655488e1fe$var$SECONDARY_UNICODE_RANGE[1];
    const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $41718d655488e1fe$var$toHex(cleaned[0]) : $41718d655488e1fe$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $41718d655488e1fe$var$getPrefix(fontFamily, fontWeight) {
    const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    const fontWeightInteger = parseInt(fontWeight);
    const fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($41718d655488e1fe$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $41718d655488e1fe$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $41718d655488e1fe$var$replaceForPosition(node, position) {
    const pendingAttribute = "".concat($41718d655488e1fe$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise((resolve, reject)=>{
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        const children = $41718d655488e1fe$var$toArray(node.children);
        const alreadyProcessedPseudoElement = children.filter((c$$1)=>c$$1.getAttribute($41718d655488e1fe$var$DATA_FA_PSEUDO_ELEMENT) === position)[0];
        const styles = $41718d655488e1fe$var$WINDOW.getComputedStyle(node, position);
        const fontFamily = styles.getPropertyValue('font-family');
        const fontFamilyMatch = fontFamily.match($41718d655488e1fe$var$FONT_FAMILY_PATTERN);
        const fontWeight = styles.getPropertyValue('font-weight');
        const content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            const content = styles.getPropertyValue('content');
            let prefix = $41718d655488e1fe$var$getPrefix(fontFamily, fontWeight);
            const { value: hexValue, isSecondary: isSecondary } = $41718d655488e1fe$var$hexValueFromContent(content);
            const isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            let iconName = $41718d655488e1fe$var$byUnicode(prefix, hexValue);
            let iconIdentifier = iconName;
            if (isV4) {
                const iconName4 = $41718d655488e1fe$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($41718d655488e1fe$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($41718d655488e1fe$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                const meta = $41718d655488e1fe$var$blankMeta();
                const { extra: extra } = meta;
                extra.attributes[$41718d655488e1fe$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $41718d655488e1fe$var$findIcon(iconName, prefix).then((main)=>{
                    const abstract = $41718d655488e1fe$var$makeInlineSvgAbstract($41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $41718d655488e1fe$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    const element = $41718d655488e1fe$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map((a$$1)=>$41718d655488e1fe$var$toHtml(a$$1)).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $41718d655488e1fe$var$replace(node) {
    return Promise.all([
        $41718d655488e1fe$var$replaceForPosition(node, '::before'),
        $41718d655488e1fe$var$replaceForPosition(node, '::after')
    ]);
}
function $41718d655488e1fe$var$processable(node) {
    return node.parentNode !== document.head && !~$41718d655488e1fe$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($41718d655488e1fe$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $41718d655488e1fe$var$searchPseudoElements(root) {
    if (!$41718d655488e1fe$var$IS_DOM) return;
    return new Promise((resolve, reject)=>{
        const operations = $41718d655488e1fe$var$toArray(root.querySelectorAll('*')).filter($41718d655488e1fe$var$processable).map($41718d655488e1fe$var$replace);
        const end = $41718d655488e1fe$var$perf.begin('searchPseudoElements');
        $41718d655488e1fe$var$disableObservation();
        Promise.all(operations).then(()=>{
            end();
            $41718d655488e1fe$var$enableObservation();
            resolve();
        }).catch(()=>{
            end();
            $41718d655488e1fe$var$enableObservation();
            reject();
        });
    });
}
var $41718d655488e1fe$var$PseudoElements = {
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.pseudoElementsCallback = $41718d655488e1fe$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.pseudoElements2svg = function(params) {
            const { node: node = $41718d655488e1fe$var$DOCUMENT } = params;
            if ($41718d655488e1fe$var$config.searchPseudoElements) $41718d655488e1fe$var$searchPseudoElements(node);
        };
    }
};
let $41718d655488e1fe$var$_unwatched = false;
var $41718d655488e1fe$var$MutationObserver$1 = {
    mixout () {
        return {
            dom: {
                unwatch () {
                    $41718d655488e1fe$var$disableObservation();
                    $41718d655488e1fe$var$_unwatched = true;
                }
            }
        };
    },
    hooks () {
        return {
            bootstrap () {
                $41718d655488e1fe$var$observe($41718d655488e1fe$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto () {
                $41718d655488e1fe$var$disconnect();
            },
            watch (params) {
                const { observeMutationsRoot: observeMutationsRoot } = params;
                if ($41718d655488e1fe$var$_unwatched) $41718d655488e1fe$var$enableObservation();
                else $41718d655488e1fe$var$observe($41718d655488e1fe$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
const $41718d655488e1fe$var$parseTransformString = (transformString)=>{
    let transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce((acc, n)=>{
        const parts = n.toLowerCase().split('-');
        const first = parts[0];
        let rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $41718d655488e1fe$var$PowerTransforms = {
    mixout () {
        return {
            parse: {
                transform: (transformString)=>{
                    return $41718d655488e1fe$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $41718d655488e1fe$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            let { main: main, transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
            const outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            const inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            const path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            const operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $41718d655488e1fe$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $41718d655488e1fe$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $41718d655488e1fe$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $41718d655488e1fe$var$fillBlack(abstract) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $41718d655488e1fe$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $41718d655488e1fe$var$Masks = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const maskData = node.getAttribute('data-fa-mask');
                const mask = !maskData ? $41718d655488e1fe$var$emptyCanonicalIcon() : $41718d655488e1fe$var$getCanonicalIcon(maskData.split(' ').map((i)=>i.trim()));
                if (!mask.prefix) mask.prefix = $41718d655488e1fe$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractMask = function(_ref) {
            let { children: children, attributes: attributes, main: main, mask: mask, maskId: explicitMaskId, transform: transform } = _ref;
            const { width: mainWidth, icon: mainPath } = main;
            const { width: maskWidth, icon: maskPath } = mask;
            const trans = $41718d655488e1fe$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            const maskRect = {
                tag: 'rect',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            const maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($41718d655488e1fe$var$fillBlack)
            } : {};
            const maskInnerGroup = {
                tag: 'g',
                attributes: $41718d655488e1fe$var$_objectSpread2({}, trans.inner),
                children: [
                    $41718d655488e1fe$var$fillBlack($41718d655488e1fe$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            const maskOuterGroup = {
                tag: 'g',
                attributes: $41718d655488e1fe$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            const maskId = "mask-".concat(explicitMaskId || $41718d655488e1fe$var$nextUniqueId());
            const clipId = "clip-".concat(explicitMaskId || $41718d655488e1fe$var$nextUniqueId());
            const maskTag = {
                tag: 'mask',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, $41718d655488e1fe$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            const defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $41718d655488e1fe$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $41718d655488e1fe$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $41718d655488e1fe$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $41718d655488e1fe$var$MissingIconIndicator = {
    provides (providers) {
        let reduceMotion = false;
        if ($41718d655488e1fe$var$WINDOW.matchMedia) reduceMotion = $41718d655488e1fe$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            const gChildren = [];
            const FILL = {
                fill: 'currentColor'
            };
            const ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            const OPACITY_ANIMATE = $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            const dot = {
                tag: 'circle',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $41718d655488e1fe$var$_objectSpread2($41718d655488e1fe$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $41718d655488e1fe$var$SvgSymbols = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const symbolData = node.getAttribute('data-fa-symbol');
                const symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $41718d655488e1fe$var$plugins = [
    $41718d655488e1fe$var$InjectCSS,
    $41718d655488e1fe$var$ReplaceElements,
    $41718d655488e1fe$var$Layers,
    $41718d655488e1fe$var$LayersCounter,
    $41718d655488e1fe$var$LayersText,
    $41718d655488e1fe$var$PseudoElements,
    $41718d655488e1fe$var$MutationObserver$1,
    $41718d655488e1fe$var$PowerTransforms,
    $41718d655488e1fe$var$Masks,
    $41718d655488e1fe$var$MissingIconIndicator,
    $41718d655488e1fe$var$SvgSymbols
];
$41718d655488e1fe$var$registerPlugins($41718d655488e1fe$var$plugins, {
    mixoutsTo: $41718d655488e1fe$export$644d8ea042df96a6
});
const $41718d655488e1fe$export$4f8e844b2782642c = $41718d655488e1fe$export$644d8ea042df96a6.noAuto;
const $41718d655488e1fe$export$e506a1d27d1eaa20 = $41718d655488e1fe$export$644d8ea042df96a6.config;
const $41718d655488e1fe$export$b839f963c7dc0e34 = $41718d655488e1fe$export$644d8ea042df96a6.library;
const $41718d655488e1fe$export$df3a06d6289f983e = $41718d655488e1fe$export$644d8ea042df96a6.dom;
const $41718d655488e1fe$export$98e6a39c04603d36 = $41718d655488e1fe$export$644d8ea042df96a6.parse;
const $41718d655488e1fe$export$221fed4a47f597a5 = $41718d655488e1fe$export$644d8ea042df96a6.findIconDefinition;
const $41718d655488e1fe$export$a10125c086a4df16 = $41718d655488e1fe$export$644d8ea042df96a6.toHtml;
const $41718d655488e1fe$export$1ca1ec8b29a4ce27 = $41718d655488e1fe$export$644d8ea042df96a6.icon;
const $41718d655488e1fe$export$50a222d9023da98b = $41718d655488e1fe$export$644d8ea042df96a6.layer;
const $41718d655488e1fe$export$6f093cfa640b7166 = $41718d655488e1fe$export$644d8ea042df96a6.text;
const $41718d655488e1fe$export$e575061ef2a070eb = $41718d655488e1fe$export$644d8ea042df96a6.counter;


var $9644b492f5164b95$exports = {};
'use strict';
Object.defineProperty($9644b492f5164b95$exports, '__esModule', {
    value: true
});
var $0bc520ea3cc85faf$exports = {};
'use strict';
Object.defineProperty($0bc520ea3cc85faf$exports, '__esModule', {
    value: true
});
var $0bc520ea3cc85faf$var$prefix = 'fasl';
var $0bc520ea3cc85faf$var$iconName = 'cart-shopping';
var $0bc520ea3cc85faf$var$width = 576;
var $0bc520ea3cc85faf$var$height = 512;
var $0bc520ea3cc85faf$var$aliases = [
    128722,
    "shopping-cart"
];
var $0bc520ea3cc85faf$var$unicode = 'f07a';
var $0bc520ea3cc85faf$var$svgPathData = 'M16 0L0 0 0 32l16 0 51.2 0 77.2 339.5 2.8 12.5 12.8 0 336 0 16 0 0-32-16 0-323.2 0-14.5-64L496 288 566 64l10-32-33.5 0L100 32 95.6 12.5 92.8 0 80 0 16 0zm91.3 64l425.2 0-60 192L151 256 107.3 64zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm248-56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z';
$0bc520ea3cc85faf$exports.definition = {
    prefix: $0bc520ea3cc85faf$var$prefix,
    iconName: $0bc520ea3cc85faf$var$iconName,
    icon: [
        $0bc520ea3cc85faf$var$width,
        $0bc520ea3cc85faf$var$height,
        $0bc520ea3cc85faf$var$aliases,
        $0bc520ea3cc85faf$var$unicode,
        $0bc520ea3cc85faf$var$svgPathData
    ]
};
$0bc520ea3cc85faf$exports.faCartShopping = $0bc520ea3cc85faf$exports.definition;
$0bc520ea3cc85faf$exports.prefix = $0bc520ea3cc85faf$var$prefix;
$0bc520ea3cc85faf$exports.iconName = $0bc520ea3cc85faf$var$iconName;
$0bc520ea3cc85faf$exports.width = $0bc520ea3cc85faf$var$width;
$0bc520ea3cc85faf$exports.height = $0bc520ea3cc85faf$var$height;
$0bc520ea3cc85faf$exports.ligatures = $0bc520ea3cc85faf$var$aliases;
$0bc520ea3cc85faf$exports.unicode = $0bc520ea3cc85faf$var$unicode;
$0bc520ea3cc85faf$exports.svgPathData = $0bc520ea3cc85faf$var$svgPathData;
$0bc520ea3cc85faf$exports.aliases = $0bc520ea3cc85faf$var$aliases;


$9644b492f5164b95$exports.definition = {
    prefix: $0bc520ea3cc85faf$exports.prefix,
    iconName: $0bc520ea3cc85faf$exports.iconName,
    icon: [
        $0bc520ea3cc85faf$exports.width,
        $0bc520ea3cc85faf$exports.height,
        $0bc520ea3cc85faf$exports.aliases,
        $0bc520ea3cc85faf$exports.unicode,
        $0bc520ea3cc85faf$exports.svgPathData
    ]
};
$9644b492f5164b95$exports.faShoppingCart = $9644b492f5164b95$exports.definition;
$9644b492f5164b95$exports.prefix = $0bc520ea3cc85faf$exports.prefix;
$9644b492f5164b95$exports.iconName = $0bc520ea3cc85faf$exports.iconName;
$9644b492f5164b95$exports.width = $0bc520ea3cc85faf$exports.width;
$9644b492f5164b95$exports.height = $0bc520ea3cc85faf$exports.height;
$9644b492f5164b95$exports.ligatures = $0bc520ea3cc85faf$exports.aliases;
$9644b492f5164b95$exports.unicode = $0bc520ea3cc85faf$exports.unicode;
$9644b492f5164b95$exports.svgPathData = $0bc520ea3cc85faf$exports.svgPathData;
$9644b492f5164b95$exports.aliases = $0bc520ea3cc85faf$exports.aliases;


var $3e281d7f16ce71b0$exports = {};
'use strict';
Object.defineProperty($3e281d7f16ce71b0$exports, '__esModule', {
    value: true
});
var $3e281d7f16ce71b0$var$prefix = 'fasl';
var $3e281d7f16ce71b0$var$iconName = 'user';
var $3e281d7f16ce71b0$var$width = 448;
var $3e281d7f16ce71b0$var$height = 512;
var $3e281d7f16ce71b0$var$aliases = [
    128100,
    62144
];
var $3e281d7f16ce71b0$var$unicode = 'f007';
var $3e281d7f16ce71b0$var$svgPathData = 'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM43.3 480l361.3 0L360.4 336 87.6 336 43.3 480zM64 304l320 0 54.2 176 9.8 32-33.5 0-381 0L0 512l9.8-32L64 304z';
$3e281d7f16ce71b0$exports.definition = {
    prefix: $3e281d7f16ce71b0$var$prefix,
    iconName: $3e281d7f16ce71b0$var$iconName,
    icon: [
        $3e281d7f16ce71b0$var$width,
        $3e281d7f16ce71b0$var$height,
        $3e281d7f16ce71b0$var$aliases,
        $3e281d7f16ce71b0$var$unicode,
        $3e281d7f16ce71b0$var$svgPathData
    ]
};
$3e281d7f16ce71b0$exports.faUser = $3e281d7f16ce71b0$exports.definition;
$3e281d7f16ce71b0$exports.prefix = $3e281d7f16ce71b0$var$prefix;
$3e281d7f16ce71b0$exports.iconName = $3e281d7f16ce71b0$var$iconName;
$3e281d7f16ce71b0$exports.width = $3e281d7f16ce71b0$var$width;
$3e281d7f16ce71b0$exports.height = $3e281d7f16ce71b0$var$height;
$3e281d7f16ce71b0$exports.ligatures = $3e281d7f16ce71b0$var$aliases;
$3e281d7f16ce71b0$exports.unicode = $3e281d7f16ce71b0$var$unicode;
$3e281d7f16ce71b0$exports.svgPathData = $3e281d7f16ce71b0$var$svgPathData;
$3e281d7f16ce71b0$exports.aliases = $3e281d7f16ce71b0$var$aliases;


var $e2cc4b9865f83dc5$exports = {};
'use strict';
Object.defineProperty($e2cc4b9865f83dc5$exports, '__esModule', {
    value: true
});
var $e2cc4b9865f83dc5$var$prefix = 'fasl';
var $e2cc4b9865f83dc5$var$iconName = 'envelope';
var $e2cc4b9865f83dc5$var$width = 512;
var $e2cc4b9865f83dc5$var$height = 512;
var $e2cc4b9865f83dc5$var$aliases = [
    128386,
    9993,
    61443
];
var $e2cc4b9865f83dc5$var$unicode = 'f0e0';
var $e2cc4b9865f83dc5$var$svgPathData = 'M32 159.2l224 154 224-154L480 96 32 96l0 63.2zM480 198L256 352 32 198l0 218 448 0 0-218zM0 416L0 176 0 96 0 64l32 0 448 0 32 0 0 32 0 80 0 240 0 32-32 0L32 448 0 448l0-32z';
$e2cc4b9865f83dc5$exports.definition = {
    prefix: $e2cc4b9865f83dc5$var$prefix,
    iconName: $e2cc4b9865f83dc5$var$iconName,
    icon: [
        $e2cc4b9865f83dc5$var$width,
        $e2cc4b9865f83dc5$var$height,
        $e2cc4b9865f83dc5$var$aliases,
        $e2cc4b9865f83dc5$var$unicode,
        $e2cc4b9865f83dc5$var$svgPathData
    ]
};
$e2cc4b9865f83dc5$exports.faEnvelope = $e2cc4b9865f83dc5$exports.definition;
$e2cc4b9865f83dc5$exports.prefix = $e2cc4b9865f83dc5$var$prefix;
$e2cc4b9865f83dc5$exports.iconName = $e2cc4b9865f83dc5$var$iconName;
$e2cc4b9865f83dc5$exports.width = $e2cc4b9865f83dc5$var$width;
$e2cc4b9865f83dc5$exports.height = $e2cc4b9865f83dc5$var$height;
$e2cc4b9865f83dc5$exports.ligatures = $e2cc4b9865f83dc5$var$aliases;
$e2cc4b9865f83dc5$exports.unicode = $e2cc4b9865f83dc5$var$unicode;
$e2cc4b9865f83dc5$exports.svgPathData = $e2cc4b9865f83dc5$var$svgPathData;
$e2cc4b9865f83dc5$exports.aliases = $e2cc4b9865f83dc5$var$aliases;


var $437d5b8059a75ba7$exports = {};
'use strict';
Object.defineProperty($437d5b8059a75ba7$exports, '__esModule', {
    value: true
});
var $437d5b8059a75ba7$var$prefix = 'fasl';
var $437d5b8059a75ba7$var$iconName = 'arrow-right';
var $437d5b8059a75ba7$var$width = 448;
var $437d5b8059a75ba7$var$height = 512;
var $437d5b8059a75ba7$var$aliases = [
    8594
];
var $437d5b8059a75ba7$var$unicode = 'f061';
var $437d5b8059a75ba7$var$svgPathData = 'M435.3 267.3L446.6 256l-11.3-11.3-168-168L256 65.4 233.4 88l11.3 11.3L385.4 240 16 240 0 240l0 32 16 0 369.4 0L244.7 412.7 233.4 424 256 446.6l11.3-11.3 168-168z';
$437d5b8059a75ba7$exports.definition = {
    prefix: $437d5b8059a75ba7$var$prefix,
    iconName: $437d5b8059a75ba7$var$iconName,
    icon: [
        $437d5b8059a75ba7$var$width,
        $437d5b8059a75ba7$var$height,
        $437d5b8059a75ba7$var$aliases,
        $437d5b8059a75ba7$var$unicode,
        $437d5b8059a75ba7$var$svgPathData
    ]
};
$437d5b8059a75ba7$exports.faArrowRight = $437d5b8059a75ba7$exports.definition;
$437d5b8059a75ba7$exports.prefix = $437d5b8059a75ba7$var$prefix;
$437d5b8059a75ba7$exports.iconName = $437d5b8059a75ba7$var$iconName;
$437d5b8059a75ba7$exports.width = $437d5b8059a75ba7$var$width;
$437d5b8059a75ba7$exports.height = $437d5b8059a75ba7$var$height;
$437d5b8059a75ba7$exports.ligatures = $437d5b8059a75ba7$var$aliases;
$437d5b8059a75ba7$exports.unicode = $437d5b8059a75ba7$var$unicode;
$437d5b8059a75ba7$exports.svgPathData = $437d5b8059a75ba7$var$svgPathData;
$437d5b8059a75ba7$exports.aliases = $437d5b8059a75ba7$var$aliases;


var $de6a410236883f47$exports = {};
'use strict';
Object.defineProperty($de6a410236883f47$exports, '__esModule', {
    value: true
});
var $de6a410236883f47$var$prefix = 'fasl';
var $de6a410236883f47$var$iconName = 'arrow-left';
var $de6a410236883f47$var$width = 448;
var $de6a410236883f47$var$height = 512;
var $de6a410236883f47$var$aliases = [
    8592
];
var $de6a410236883f47$var$unicode = 'f060';
var $de6a410236883f47$var$svgPathData = 'M12.7 244.7L1.4 256l11.3 11.3 168 168L192 446.6 214.6 424l-11.3-11.3L62.6 272 432 272l16 0 0-32-16 0L62.6 240 203.3 99.3 214.6 88 192 65.4 180.7 76.7l-168 168z';
$de6a410236883f47$exports.definition = {
    prefix: $de6a410236883f47$var$prefix,
    iconName: $de6a410236883f47$var$iconName,
    icon: [
        $de6a410236883f47$var$width,
        $de6a410236883f47$var$height,
        $de6a410236883f47$var$aliases,
        $de6a410236883f47$var$unicode,
        $de6a410236883f47$var$svgPathData
    ]
};
$de6a410236883f47$exports.faArrowLeft = $de6a410236883f47$exports.definition;
$de6a410236883f47$exports.prefix = $de6a410236883f47$var$prefix;
$de6a410236883f47$exports.iconName = $de6a410236883f47$var$iconName;
$de6a410236883f47$exports.width = $de6a410236883f47$var$width;
$de6a410236883f47$exports.height = $de6a410236883f47$var$height;
$de6a410236883f47$exports.ligatures = $de6a410236883f47$var$aliases;
$de6a410236883f47$exports.unicode = $de6a410236883f47$var$unicode;
$de6a410236883f47$exports.svgPathData = $de6a410236883f47$var$svgPathData;
$de6a410236883f47$exports.aliases = $de6a410236883f47$var$aliases;


var $2183f250c1603ef8$exports = {};
'use strict';
Object.defineProperty($2183f250c1603ef8$exports, '__esModule', {
    value: true
});
var $2183f250c1603ef8$var$prefix = 'fasl';
var $2183f250c1603ef8$var$iconName = 'badge-check';
var $2183f250c1603ef8$var$width = 512;
var $2183f250c1603ef8$var$height = 512;
var $2183f250c1603ef8$var$aliases = [];
var $2183f250c1603ef8$var$unicode = 'f336';
var $2183f250c1603ef8$var$svgPathData = 'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4l6.2 11.7 12.6-3.9c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1l-3.9 12.6 11.7 6.2C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4l-11.7 6.2 3.9 12.6c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4l-12.6-3.9-6.2 11.7C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4l-6.2-11.7-12.6 3.9c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1l3.9-12.6-11.7-6.2C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4l11.7-6.2-3.9-12.6c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4l12.6 3.9 6.2-11.7zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3L374.6 192 352 169.4l-11.3 11.3L224 297.4l-52.7-52.7L160 233.4 137.4 256l11.3 11.3 64 64L224 342.6l11.3-11.3 128-128z';
$2183f250c1603ef8$exports.definition = {
    prefix: $2183f250c1603ef8$var$prefix,
    iconName: $2183f250c1603ef8$var$iconName,
    icon: [
        $2183f250c1603ef8$var$width,
        $2183f250c1603ef8$var$height,
        $2183f250c1603ef8$var$aliases,
        $2183f250c1603ef8$var$unicode,
        $2183f250c1603ef8$var$svgPathData
    ]
};
$2183f250c1603ef8$exports.faBadgeCheck = $2183f250c1603ef8$exports.definition;
$2183f250c1603ef8$exports.prefix = $2183f250c1603ef8$var$prefix;
$2183f250c1603ef8$exports.iconName = $2183f250c1603ef8$var$iconName;
$2183f250c1603ef8$exports.width = $2183f250c1603ef8$var$width;
$2183f250c1603ef8$exports.height = $2183f250c1603ef8$var$height;
$2183f250c1603ef8$exports.ligatures = $2183f250c1603ef8$var$aliases;
$2183f250c1603ef8$exports.unicode = $2183f250c1603ef8$var$unicode;
$2183f250c1603ef8$exports.svgPathData = $2183f250c1603ef8$var$svgPathData;
$2183f250c1603ef8$exports.aliases = $2183f250c1603ef8$var$aliases;



var $8d7de1ecc6167bef$exports = {};
'use strict';
Object.defineProperty($8d7de1ecc6167bef$exports, '__esModule', {
    value: true
});
var $8d7de1ecc6167bef$var$prefix = 'fasl';
var $8d7de1ecc6167bef$var$iconName = 'check';
var $8d7de1ecc6167bef$var$width = 448;
var $8d7de1ecc6167bef$var$height = 512;
var $8d7de1ecc6167bef$var$aliases = [
    10003,
    10004
];
var $8d7de1ecc6167bef$var$unicode = 'f00c';
var $8d7de1ecc6167bef$var$svgPathData = 'M448.1 118.2L437 129.7 173.6 404l-11.5 12-11.5-12L11.1 258.8 0 247.2l23.1-22.2 11.1 11.5L162.1 369.8 414 107.5 425 96l23.1 22.2z';
$8d7de1ecc6167bef$exports.definition = {
    prefix: $8d7de1ecc6167bef$var$prefix,
    iconName: $8d7de1ecc6167bef$var$iconName,
    icon: [
        $8d7de1ecc6167bef$var$width,
        $8d7de1ecc6167bef$var$height,
        $8d7de1ecc6167bef$var$aliases,
        $8d7de1ecc6167bef$var$unicode,
        $8d7de1ecc6167bef$var$svgPathData
    ]
};
$8d7de1ecc6167bef$exports.faCheck = $8d7de1ecc6167bef$exports.definition;
$8d7de1ecc6167bef$exports.prefix = $8d7de1ecc6167bef$var$prefix;
$8d7de1ecc6167bef$exports.iconName = $8d7de1ecc6167bef$var$iconName;
$8d7de1ecc6167bef$exports.width = $8d7de1ecc6167bef$var$width;
$8d7de1ecc6167bef$exports.height = $8d7de1ecc6167bef$var$height;
$8d7de1ecc6167bef$exports.ligatures = $8d7de1ecc6167bef$var$aliases;
$8d7de1ecc6167bef$exports.unicode = $8d7de1ecc6167bef$var$unicode;
$8d7de1ecc6167bef$exports.svgPathData = $8d7de1ecc6167bef$var$svgPathData;
$8d7de1ecc6167bef$exports.aliases = $8d7de1ecc6167bef$var$aliases;


var $194f4493ef3f9b51$exports = {};
'use strict';
Object.defineProperty($194f4493ef3f9b51$exports, '__esModule', {
    value: true
});
var $194f4493ef3f9b51$var$prefix = 'fasl';
var $194f4493ef3f9b51$var$iconName = 'bars';
var $194f4493ef3f9b51$var$width = 448;
var $194f4493ef3f9b51$var$height = 512;
var $194f4493ef3f9b51$var$aliases = [
    "navicon"
];
var $194f4493ef3f9b51$var$unicode = 'f0c9';
var $194f4493ef3f9b51$var$svgPathData = 'M0 64l448 0 0 32L0 96 0 64zM0 224l448 0 0 32L0 256l0-32zM448 384l0 32L0 416l0-32 448 0z';
$194f4493ef3f9b51$exports.definition = {
    prefix: $194f4493ef3f9b51$var$prefix,
    iconName: $194f4493ef3f9b51$var$iconName,
    icon: [
        $194f4493ef3f9b51$var$width,
        $194f4493ef3f9b51$var$height,
        $194f4493ef3f9b51$var$aliases,
        $194f4493ef3f9b51$var$unicode,
        $194f4493ef3f9b51$var$svgPathData
    ]
};
$194f4493ef3f9b51$exports.faBars = $194f4493ef3f9b51$exports.definition;
$194f4493ef3f9b51$exports.prefix = $194f4493ef3f9b51$var$prefix;
$194f4493ef3f9b51$exports.iconName = $194f4493ef3f9b51$var$iconName;
$194f4493ef3f9b51$exports.width = $194f4493ef3f9b51$var$width;
$194f4493ef3f9b51$exports.height = $194f4493ef3f9b51$var$height;
$194f4493ef3f9b51$exports.ligatures = $194f4493ef3f9b51$var$aliases;
$194f4493ef3f9b51$exports.unicode = $194f4493ef3f9b51$var$unicode;
$194f4493ef3f9b51$exports.svgPathData = $194f4493ef3f9b51$var$svgPathData;
$194f4493ef3f9b51$exports.aliases = $194f4493ef3f9b51$var$aliases;


var $3972f7e8998cc1b5$exports = {};
'use strict';
Object.defineProperty($3972f7e8998cc1b5$exports, '__esModule', {
    value: true
});
var $5d3c6cf99f7450a6$exports = {};
'use strict';
Object.defineProperty($5d3c6cf99f7450a6$exports, '__esModule', {
    value: true
});
var $5d3c6cf99f7450a6$var$prefix = 'fasl';
var $5d3c6cf99f7450a6$var$iconName = 'magnifying-glass';
var $5d3c6cf99f7450a6$var$width = 512;
var $5d3c6cf99f7450a6$var$height = 512;
var $5d3c6cf99f7450a6$var$aliases = [
    128269,
    "search"
];
var $5d3c6cf99f7450a6$var$unicode = 'f002';
var $5d3c6cf99f7450a6$var$svgPathData = 'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L510.5 487.9l-22.6 22.6L343.3 366z';
$5d3c6cf99f7450a6$exports.definition = {
    prefix: $5d3c6cf99f7450a6$var$prefix,
    iconName: $5d3c6cf99f7450a6$var$iconName,
    icon: [
        $5d3c6cf99f7450a6$var$width,
        $5d3c6cf99f7450a6$var$height,
        $5d3c6cf99f7450a6$var$aliases,
        $5d3c6cf99f7450a6$var$unicode,
        $5d3c6cf99f7450a6$var$svgPathData
    ]
};
$5d3c6cf99f7450a6$exports.faMagnifyingGlass = $5d3c6cf99f7450a6$exports.definition;
$5d3c6cf99f7450a6$exports.prefix = $5d3c6cf99f7450a6$var$prefix;
$5d3c6cf99f7450a6$exports.iconName = $5d3c6cf99f7450a6$var$iconName;
$5d3c6cf99f7450a6$exports.width = $5d3c6cf99f7450a6$var$width;
$5d3c6cf99f7450a6$exports.height = $5d3c6cf99f7450a6$var$height;
$5d3c6cf99f7450a6$exports.ligatures = $5d3c6cf99f7450a6$var$aliases;
$5d3c6cf99f7450a6$exports.unicode = $5d3c6cf99f7450a6$var$unicode;
$5d3c6cf99f7450a6$exports.svgPathData = $5d3c6cf99f7450a6$var$svgPathData;
$5d3c6cf99f7450a6$exports.aliases = $5d3c6cf99f7450a6$var$aliases;


$3972f7e8998cc1b5$exports.definition = {
    prefix: $5d3c6cf99f7450a6$exports.prefix,
    iconName: $5d3c6cf99f7450a6$exports.iconName,
    icon: [
        $5d3c6cf99f7450a6$exports.width,
        $5d3c6cf99f7450a6$exports.height,
        $5d3c6cf99f7450a6$exports.aliases,
        $5d3c6cf99f7450a6$exports.unicode,
        $5d3c6cf99f7450a6$exports.svgPathData
    ]
};
$3972f7e8998cc1b5$exports.faSearch = $3972f7e8998cc1b5$exports.definition;
$3972f7e8998cc1b5$exports.prefix = $5d3c6cf99f7450a6$exports.prefix;
$3972f7e8998cc1b5$exports.iconName = $5d3c6cf99f7450a6$exports.iconName;
$3972f7e8998cc1b5$exports.width = $5d3c6cf99f7450a6$exports.width;
$3972f7e8998cc1b5$exports.height = $5d3c6cf99f7450a6$exports.height;
$3972f7e8998cc1b5$exports.ligatures = $5d3c6cf99f7450a6$exports.aliases;
$3972f7e8998cc1b5$exports.unicode = $5d3c6cf99f7450a6$exports.unicode;
$3972f7e8998cc1b5$exports.svgPathData = $5d3c6cf99f7450a6$exports.svgPathData;
$3972f7e8998cc1b5$exports.aliases = $5d3c6cf99f7450a6$exports.aliases;


var $e7d3361291756d02$exports = {};
'use strict';
Object.defineProperty($e7d3361291756d02$exports, '__esModule', {
    value: true
});
var $4941424251b85126$exports = {};
'use strict';
Object.defineProperty($4941424251b85126$exports, '__esModule', {
    value: true
});
var $4941424251b85126$var$prefix = 'fasl';
var $4941424251b85126$var$iconName = 'basket-shopping';
var $4941424251b85126$var$width = 576;
var $4941424251b85126$var$height = 512;
var $4941424251b85126$var$aliases = [
    "shopping-basket"
];
var $4941424251b85126$var$unicode = 'f291';
var $4941424251b85126$var$svgPathData = 'M253.8 17.9l-7.9 13.9L155.4 192l265.2 0L330.1 31.9l-7.9-13.9L350.1 2.2l7.9 13.9L457.3 192l53.7 0 33 0 32 0 0 32-40 0L464 512l-352 0L40 224 0 224l0-32 32 0 33 0 53.7 0L218.1 16.1l7.9-13.9 27.9 15.7zM73 224l64 256 302 0 64-256L73 224zm151 80l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16zm80-16l0 16 0 96 0 16-32 0 0-16 0-96 0-16 32 0zm80 16l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16z';
$4941424251b85126$exports.definition = {
    prefix: $4941424251b85126$var$prefix,
    iconName: $4941424251b85126$var$iconName,
    icon: [
        $4941424251b85126$var$width,
        $4941424251b85126$var$height,
        $4941424251b85126$var$aliases,
        $4941424251b85126$var$unicode,
        $4941424251b85126$var$svgPathData
    ]
};
$4941424251b85126$exports.faBasketShopping = $4941424251b85126$exports.definition;
$4941424251b85126$exports.prefix = $4941424251b85126$var$prefix;
$4941424251b85126$exports.iconName = $4941424251b85126$var$iconName;
$4941424251b85126$exports.width = $4941424251b85126$var$width;
$4941424251b85126$exports.height = $4941424251b85126$var$height;
$4941424251b85126$exports.ligatures = $4941424251b85126$var$aliases;
$4941424251b85126$exports.unicode = $4941424251b85126$var$unicode;
$4941424251b85126$exports.svgPathData = $4941424251b85126$var$svgPathData;
$4941424251b85126$exports.aliases = $4941424251b85126$var$aliases;


$e7d3361291756d02$exports.definition = {
    prefix: $4941424251b85126$exports.prefix,
    iconName: $4941424251b85126$exports.iconName,
    icon: [
        $4941424251b85126$exports.width,
        $4941424251b85126$exports.height,
        $4941424251b85126$exports.aliases,
        $4941424251b85126$exports.unicode,
        $4941424251b85126$exports.svgPathData
    ]
};
$e7d3361291756d02$exports.faShoppingBasket = $e7d3361291756d02$exports.definition;
$e7d3361291756d02$exports.prefix = $4941424251b85126$exports.prefix;
$e7d3361291756d02$exports.iconName = $4941424251b85126$exports.iconName;
$e7d3361291756d02$exports.width = $4941424251b85126$exports.width;
$e7d3361291756d02$exports.height = $4941424251b85126$exports.height;
$e7d3361291756d02$exports.ligatures = $4941424251b85126$exports.aliases;
$e7d3361291756d02$exports.unicode = $4941424251b85126$exports.unicode;
$e7d3361291756d02$exports.svgPathData = $4941424251b85126$exports.svgPathData;
$e7d3361291756d02$exports.aliases = $4941424251b85126$exports.aliases;


var $7fd256b5e47dcaab$exports = {};
'use strict';
Object.defineProperty($7fd256b5e47dcaab$exports, '__esModule', {
    value: true
});
var $7fd256b5e47dcaab$var$prefix = 'fasl';
var $7fd256b5e47dcaab$var$iconName = 'angle-down';
var $7fd256b5e47dcaab$var$width = 448;
var $7fd256b5e47dcaab$var$height = 512;
var $7fd256b5e47dcaab$var$aliases = [
    8964
];
var $7fd256b5e47dcaab$var$unicode = 'f107';
var $7fd256b5e47dcaab$var$svgPathData = 'M224 374.6l11.3-11.3 160-160L406.6 192 384 169.4l-11.3 11.3L224 329.4 75.3 180.7 64 169.4 41.4 192l11.3 11.3 160 160L224 374.6z';
$7fd256b5e47dcaab$exports.definition = {
    prefix: $7fd256b5e47dcaab$var$prefix,
    iconName: $7fd256b5e47dcaab$var$iconName,
    icon: [
        $7fd256b5e47dcaab$var$width,
        $7fd256b5e47dcaab$var$height,
        $7fd256b5e47dcaab$var$aliases,
        $7fd256b5e47dcaab$var$unicode,
        $7fd256b5e47dcaab$var$svgPathData
    ]
};
$7fd256b5e47dcaab$exports.faAngleDown = $7fd256b5e47dcaab$exports.definition;
$7fd256b5e47dcaab$exports.prefix = $7fd256b5e47dcaab$var$prefix;
$7fd256b5e47dcaab$exports.iconName = $7fd256b5e47dcaab$var$iconName;
$7fd256b5e47dcaab$exports.width = $7fd256b5e47dcaab$var$width;
$7fd256b5e47dcaab$exports.height = $7fd256b5e47dcaab$var$height;
$7fd256b5e47dcaab$exports.ligatures = $7fd256b5e47dcaab$var$aliases;
$7fd256b5e47dcaab$exports.unicode = $7fd256b5e47dcaab$var$unicode;
$7fd256b5e47dcaab$exports.svgPathData = $7fd256b5e47dcaab$var$svgPathData;
$7fd256b5e47dcaab$exports.aliases = $7fd256b5e47dcaab$var$aliases;


var $455527c9fcec973d$exports = {};
'use strict';
Object.defineProperty($455527c9fcec973d$exports, '__esModule', {
    value: true
});
var $455527c9fcec973d$var$prefix = 'fasl';
var $455527c9fcec973d$var$iconName = 'angle-up';
var $455527c9fcec973d$var$width = 448;
var $455527c9fcec973d$var$height = 512;
var $455527c9fcec973d$var$aliases = [
    8963
];
var $455527c9fcec973d$var$unicode = 'f106';
var $455527c9fcec973d$var$svgPathData = 'M224 137.4l11.3 11.3 160 160L406.6 320 384 342.6l-11.3-11.3L224 182.6 75.3 331.3 64 342.6 41.4 320l11.3-11.3 160-160L224 137.4z';
$455527c9fcec973d$exports.definition = {
    prefix: $455527c9fcec973d$var$prefix,
    iconName: $455527c9fcec973d$var$iconName,
    icon: [
        $455527c9fcec973d$var$width,
        $455527c9fcec973d$var$height,
        $455527c9fcec973d$var$aliases,
        $455527c9fcec973d$var$unicode,
        $455527c9fcec973d$var$svgPathData
    ]
};
$455527c9fcec973d$exports.faAngleUp = $455527c9fcec973d$exports.definition;
$455527c9fcec973d$exports.prefix = $455527c9fcec973d$var$prefix;
$455527c9fcec973d$exports.iconName = $455527c9fcec973d$var$iconName;
$455527c9fcec973d$exports.width = $455527c9fcec973d$var$width;
$455527c9fcec973d$exports.height = $455527c9fcec973d$var$height;
$455527c9fcec973d$exports.ligatures = $455527c9fcec973d$var$aliases;
$455527c9fcec973d$exports.unicode = $455527c9fcec973d$var$unicode;
$455527c9fcec973d$exports.svgPathData = $455527c9fcec973d$var$svgPathData;
$455527c9fcec973d$exports.aliases = $455527c9fcec973d$var$aliases;


var $9734e6c11ce24fb6$exports = {};
'use strict';
Object.defineProperty($9734e6c11ce24fb6$exports, '__esModule', {
    value: true
});
var $9a9bb37ccce10e75$exports = {};
'use strict';
Object.defineProperty($9a9bb37ccce10e75$exports, '__esModule', {
    value: true
});
var $9a9bb37ccce10e75$var$prefix = 'fasl';
var $9a9bb37ccce10e75$var$iconName = 'xmark';
var $9a9bb37ccce10e75$var$width = 384;
var $9a9bb37ccce10e75$var$height = 512;
var $9a9bb37ccce10e75$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $9a9bb37ccce10e75$var$unicode = 'f00d';
var $9a9bb37ccce10e75$var$svgPathData = 'M192 233.4L59.5 100.9 36.9 123.5 169.4 256 36.9 388.5l22.6 22.6L192 278.6 324.5 411.1l22.6-22.6L214.6 256 347.1 123.5l-22.6-22.6L192 233.4z';
$9a9bb37ccce10e75$exports.definition = {
    prefix: $9a9bb37ccce10e75$var$prefix,
    iconName: $9a9bb37ccce10e75$var$iconName,
    icon: [
        $9a9bb37ccce10e75$var$width,
        $9a9bb37ccce10e75$var$height,
        $9a9bb37ccce10e75$var$aliases,
        $9a9bb37ccce10e75$var$unicode,
        $9a9bb37ccce10e75$var$svgPathData
    ]
};
$9a9bb37ccce10e75$exports.faXmark = $9a9bb37ccce10e75$exports.definition;
$9a9bb37ccce10e75$exports.prefix = $9a9bb37ccce10e75$var$prefix;
$9a9bb37ccce10e75$exports.iconName = $9a9bb37ccce10e75$var$iconName;
$9a9bb37ccce10e75$exports.width = $9a9bb37ccce10e75$var$width;
$9a9bb37ccce10e75$exports.height = $9a9bb37ccce10e75$var$height;
$9a9bb37ccce10e75$exports.ligatures = $9a9bb37ccce10e75$var$aliases;
$9a9bb37ccce10e75$exports.unicode = $9a9bb37ccce10e75$var$unicode;
$9a9bb37ccce10e75$exports.svgPathData = $9a9bb37ccce10e75$var$svgPathData;
$9a9bb37ccce10e75$exports.aliases = $9a9bb37ccce10e75$var$aliases;


$9734e6c11ce24fb6$exports.definition = {
    prefix: $9a9bb37ccce10e75$exports.prefix,
    iconName: $9a9bb37ccce10e75$exports.iconName,
    icon: [
        $9a9bb37ccce10e75$exports.width,
        $9a9bb37ccce10e75$exports.height,
        $9a9bb37ccce10e75$exports.aliases,
        $9a9bb37ccce10e75$exports.unicode,
        $9a9bb37ccce10e75$exports.svgPathData
    ]
};
$9734e6c11ce24fb6$exports.faTimes = $9734e6c11ce24fb6$exports.definition;
$9734e6c11ce24fb6$exports.prefix = $9a9bb37ccce10e75$exports.prefix;
$9734e6c11ce24fb6$exports.iconName = $9a9bb37ccce10e75$exports.iconName;
$9734e6c11ce24fb6$exports.width = $9a9bb37ccce10e75$exports.width;
$9734e6c11ce24fb6$exports.height = $9a9bb37ccce10e75$exports.height;
$9734e6c11ce24fb6$exports.ligatures = $9a9bb37ccce10e75$exports.aliases;
$9734e6c11ce24fb6$exports.unicode = $9a9bb37ccce10e75$exports.unicode;
$9734e6c11ce24fb6$exports.svgPathData = $9a9bb37ccce10e75$exports.svgPathData;
$9734e6c11ce24fb6$exports.aliases = $9a9bb37ccce10e75$exports.aliases;


var $403e79f85990d392$exports = {};
'use strict';
Object.defineProperty($403e79f85990d392$exports, '__esModule', {
    value: true
});
var $403e79f85990d392$var$prefix = 'fasl';
var $403e79f85990d392$var$iconName = 'badge-percent';
var $403e79f85990d392$var$width = 512;
var $403e79f85990d392$var$height = 512;
var $403e79f85990d392$var$aliases = [];
var $403e79f85990d392$var$unicode = 'f646';
var $403e79f85990d392$var$svgPathData = 'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4l6.2 11.7 12.6-3.9c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1l-3.9 12.6 11.7 6.2C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4l-11.7 6.2 3.9 12.6c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4l-12.6-3.9-6.2 11.7C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4l-6.2-11.7-12.6 3.9c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1l3.9-12.6-11.7-6.2C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4l11.7-6.2-3.9-12.6c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4l12.6 3.9 6.2-11.7zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM358.6 176L336 153.4l-11.3 11.3-160 160L153.4 336 176 358.6l11.3-11.3 160-160L358.6 176zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';
$403e79f85990d392$exports.definition = {
    prefix: $403e79f85990d392$var$prefix,
    iconName: $403e79f85990d392$var$iconName,
    icon: [
        $403e79f85990d392$var$width,
        $403e79f85990d392$var$height,
        $403e79f85990d392$var$aliases,
        $403e79f85990d392$var$unicode,
        $403e79f85990d392$var$svgPathData
    ]
};
$403e79f85990d392$exports.faBadgePercent = $403e79f85990d392$exports.definition;
$403e79f85990d392$exports.prefix = $403e79f85990d392$var$prefix;
$403e79f85990d392$exports.iconName = $403e79f85990d392$var$iconName;
$403e79f85990d392$exports.width = $403e79f85990d392$var$width;
$403e79f85990d392$exports.height = $403e79f85990d392$var$height;
$403e79f85990d392$exports.ligatures = $403e79f85990d392$var$aliases;
$403e79f85990d392$exports.unicode = $403e79f85990d392$var$unicode;
$403e79f85990d392$exports.svgPathData = $403e79f85990d392$var$svgPathData;
$403e79f85990d392$exports.aliases = $403e79f85990d392$var$aliases;


var $3967d5084e7a6291$exports = {};
'use strict';
Object.defineProperty($3967d5084e7a6291$exports, '__esModule', {
    value: true
});
var $3967d5084e7a6291$var$prefix = 'fasl';
var $3967d5084e7a6291$var$iconName = 'plus';
var $3967d5084e7a6291$var$width = 448;
var $3967d5084e7a6291$var$height = 512;
var $3967d5084e7a6291$var$aliases = [
    10133,
    61543,
    "add"
];
var $3967d5084e7a6291$var$unicode = '2b';
var $3967d5084e7a6291$var$svgPathData = 'M240 64l0-16-32 0 0 16 0 176L32 240l-16 0 0 32 16 0 176 0 0 176 0 16 32 0 0-16 0-176 176 0 16 0 0-32-16 0-176 0 0-176z';
$3967d5084e7a6291$exports.definition = {
    prefix: $3967d5084e7a6291$var$prefix,
    iconName: $3967d5084e7a6291$var$iconName,
    icon: [
        $3967d5084e7a6291$var$width,
        $3967d5084e7a6291$var$height,
        $3967d5084e7a6291$var$aliases,
        $3967d5084e7a6291$var$unicode,
        $3967d5084e7a6291$var$svgPathData
    ]
};
$3967d5084e7a6291$exports.faPlus = $3967d5084e7a6291$exports.definition;
$3967d5084e7a6291$exports.prefix = $3967d5084e7a6291$var$prefix;
$3967d5084e7a6291$exports.iconName = $3967d5084e7a6291$var$iconName;
$3967d5084e7a6291$exports.width = $3967d5084e7a6291$var$width;
$3967d5084e7a6291$exports.height = $3967d5084e7a6291$var$height;
$3967d5084e7a6291$exports.ligatures = $3967d5084e7a6291$var$aliases;
$3967d5084e7a6291$exports.unicode = $3967d5084e7a6291$var$unicode;
$3967d5084e7a6291$exports.svgPathData = $3967d5084e7a6291$var$svgPathData;
$3967d5084e7a6291$exports.aliases = $3967d5084e7a6291$var$aliases;


var $40f149ed6a241035$exports = {};
'use strict';
Object.defineProperty($40f149ed6a241035$exports, '__esModule', {
    value: true
});
var $40f149ed6a241035$var$prefix = 'fasl';
var $40f149ed6a241035$var$iconName = 'minus';
var $40f149ed6a241035$var$width = 448;
var $40f149ed6a241035$var$height = 512;
var $40f149ed6a241035$var$aliases = [
    8211,
    8722,
    10134,
    "subtract"
];
var $40f149ed6a241035$var$unicode = 'f068';
var $40f149ed6a241035$var$svgPathData = 'M432 272l-16 0L32 272l-16 0 0-32 16 0 384 0 16 0 0 32z';
$40f149ed6a241035$exports.definition = {
    prefix: $40f149ed6a241035$var$prefix,
    iconName: $40f149ed6a241035$var$iconName,
    icon: [
        $40f149ed6a241035$var$width,
        $40f149ed6a241035$var$height,
        $40f149ed6a241035$var$aliases,
        $40f149ed6a241035$var$unicode,
        $40f149ed6a241035$var$svgPathData
    ]
};
$40f149ed6a241035$exports.faMinus = $40f149ed6a241035$exports.definition;
$40f149ed6a241035$exports.prefix = $40f149ed6a241035$var$prefix;
$40f149ed6a241035$exports.iconName = $40f149ed6a241035$var$iconName;
$40f149ed6a241035$exports.width = $40f149ed6a241035$var$width;
$40f149ed6a241035$exports.height = $40f149ed6a241035$var$height;
$40f149ed6a241035$exports.ligatures = $40f149ed6a241035$var$aliases;
$40f149ed6a241035$exports.unicode = $40f149ed6a241035$var$unicode;
$40f149ed6a241035$exports.svgPathData = $40f149ed6a241035$var$svgPathData;
$40f149ed6a241035$exports.aliases = $40f149ed6a241035$var$aliases;


var $2aeda45b73ab5103$exports = {};
'use strict';
Object.defineProperty($2aeda45b73ab5103$exports, '__esModule', {
    value: true
});
var $2aeda45b73ab5103$var$prefix = 'fasl';
var $2aeda45b73ab5103$var$iconName = 'chevron-down';
var $2aeda45b73ab5103$var$width = 512;
var $2aeda45b73ab5103$var$height = 512;
var $2aeda45b73ab5103$var$aliases = [];
var $2aeda45b73ab5103$var$unicode = 'f078';
var $2aeda45b73ab5103$var$svgPathData = 'M256 406.6l11.3-11.3 192-192L470.6 192 448 169.4l-11.3 11.3L256 361.4 75.3 180.7 64 169.4 41.4 192l11.3 11.3 192 192L256 406.6z';
$2aeda45b73ab5103$exports.definition = {
    prefix: $2aeda45b73ab5103$var$prefix,
    iconName: $2aeda45b73ab5103$var$iconName,
    icon: [
        $2aeda45b73ab5103$var$width,
        $2aeda45b73ab5103$var$height,
        $2aeda45b73ab5103$var$aliases,
        $2aeda45b73ab5103$var$unicode,
        $2aeda45b73ab5103$var$svgPathData
    ]
};
$2aeda45b73ab5103$exports.faChevronDown = $2aeda45b73ab5103$exports.definition;
$2aeda45b73ab5103$exports.prefix = $2aeda45b73ab5103$var$prefix;
$2aeda45b73ab5103$exports.iconName = $2aeda45b73ab5103$var$iconName;
$2aeda45b73ab5103$exports.width = $2aeda45b73ab5103$var$width;
$2aeda45b73ab5103$exports.height = $2aeda45b73ab5103$var$height;
$2aeda45b73ab5103$exports.ligatures = $2aeda45b73ab5103$var$aliases;
$2aeda45b73ab5103$exports.unicode = $2aeda45b73ab5103$var$unicode;
$2aeda45b73ab5103$exports.svgPathData = $2aeda45b73ab5103$var$svgPathData;
$2aeda45b73ab5103$exports.aliases = $2aeda45b73ab5103$var$aliases;


var $b0a43adb2ac34c90$exports = {};
'use strict';
Object.defineProperty($b0a43adb2ac34c90$exports, '__esModule', {
    value: true
});
var $b0a43adb2ac34c90$var$prefix = 'fasl';
var $b0a43adb2ac34c90$var$iconName = 'sort';
var $b0a43adb2ac34c90$var$width = 320;
var $b0a43adb2ac34c90$var$height = 512;
var $b0a43adb2ac34c90$var$aliases = [
    "unsorted"
];
var $b0a43adb2ac34c90$var$unicode = 'f0dc';
var $b0a43adb2ac34c90$var$svgPathData = 'M32 190.2L160 75 288 190.2l0 1.7L32 192l0-1.7zM0 224l32 0 256 0 32 0 0-32 0-16L160 32 0 176l0 16 0 32zm32 97.8l0-1.8 256 0 0 1.8L160 437 32 321.8zM0 288l0 32 0 16L160 480 320 336l0-16 0-32-32 0L32 288 0 288z';
$b0a43adb2ac34c90$exports.definition = {
    prefix: $b0a43adb2ac34c90$var$prefix,
    iconName: $b0a43adb2ac34c90$var$iconName,
    icon: [
        $b0a43adb2ac34c90$var$width,
        $b0a43adb2ac34c90$var$height,
        $b0a43adb2ac34c90$var$aliases,
        $b0a43adb2ac34c90$var$unicode,
        $b0a43adb2ac34c90$var$svgPathData
    ]
};
$b0a43adb2ac34c90$exports.faSort = $b0a43adb2ac34c90$exports.definition;
$b0a43adb2ac34c90$exports.prefix = $b0a43adb2ac34c90$var$prefix;
$b0a43adb2ac34c90$exports.iconName = $b0a43adb2ac34c90$var$iconName;
$b0a43adb2ac34c90$exports.width = $b0a43adb2ac34c90$var$width;
$b0a43adb2ac34c90$exports.height = $b0a43adb2ac34c90$var$height;
$b0a43adb2ac34c90$exports.ligatures = $b0a43adb2ac34c90$var$aliases;
$b0a43adb2ac34c90$exports.unicode = $b0a43adb2ac34c90$var$unicode;
$b0a43adb2ac34c90$exports.svgPathData = $b0a43adb2ac34c90$var$svgPathData;
$b0a43adb2ac34c90$exports.aliases = $b0a43adb2ac34c90$var$aliases;


var $861c519f832e64a1$exports = {};
'use strict';
Object.defineProperty($861c519f832e64a1$exports, '__esModule', {
    value: true
});
var $861c519f832e64a1$var$prefix = 'fasl';
var $861c519f832e64a1$var$iconName = 'star';
var $861c519f832e64a1$var$width = 576;
var $861c519f832e64a1$var$height = 512;
var $861c519f832e64a1$var$aliases = [
    11088,
    61446
];
var $861c519f832e64a1$var$unicode = 'f005';
var $861c519f832e64a1$var$svgPathData = 'M374.6 164L306.1 34.3 288.1 0 270 34.3 201.5 164 57.1 189l-38.2 6.6 27 27.8L148.1 328.5 127.2 473.6 121.7 512l34.8-17.1 131.6-64.7 131.6 64.7L454.4 512l-5.5-38.4L428 328.5 530.2 223.4l27-27.8L519 189 374.6 164zM492 216.8l-86.9 89.4-11 11.3 2.2 15.6 17.8 123.5-111.9-55-14.1-6.9-14.1 6.9L162 456.5l17.8-123.5 2.2-15.6-11-11.3L84.1 216.8 207 195.5l15.5-2.7 7.3-13.9L288.1 68.6l58.2 110.3 7.3 13.9 15.5 2.7L492 216.8z';
$861c519f832e64a1$exports.definition = {
    prefix: $861c519f832e64a1$var$prefix,
    iconName: $861c519f832e64a1$var$iconName,
    icon: [
        $861c519f832e64a1$var$width,
        $861c519f832e64a1$var$height,
        $861c519f832e64a1$var$aliases,
        $861c519f832e64a1$var$unicode,
        $861c519f832e64a1$var$svgPathData
    ]
};
$861c519f832e64a1$exports.faStar = $861c519f832e64a1$exports.definition;
$861c519f832e64a1$exports.prefix = $861c519f832e64a1$var$prefix;
$861c519f832e64a1$exports.iconName = $861c519f832e64a1$var$iconName;
$861c519f832e64a1$exports.width = $861c519f832e64a1$var$width;
$861c519f832e64a1$exports.height = $861c519f832e64a1$var$height;
$861c519f832e64a1$exports.ligatures = $861c519f832e64a1$var$aliases;
$861c519f832e64a1$exports.unicode = $861c519f832e64a1$var$unicode;
$861c519f832e64a1$exports.svgPathData = $861c519f832e64a1$var$svgPathData;
$861c519f832e64a1$exports.aliases = $861c519f832e64a1$var$aliases;


var $09f6307810186e53$exports = {};
'use strict';
Object.defineProperty($09f6307810186e53$exports, '__esModule', {
    value: true
});
var $bfc2654b2effb9b9$exports = {};
'use strict';
Object.defineProperty($bfc2654b2effb9b9$exports, '__esModule', {
    value: true
});
var $bfc2654b2effb9b9$var$prefix = 'fasl';
var $bfc2654b2effb9b9$var$iconName = 'circle-info';
var $bfc2654b2effb9b9$var$width = 512;
var $bfc2654b2effb9b9$var$height = 512;
var $bfc2654b2effb9b9$var$aliases = [
    "info-circle"
];
var $bfc2654b2effb9b9$var$unicode = 'f05a';
var $bfc2654b2effb9b9$var$svgPathData = 'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 352l0 32 16 0 96 0 16 0 0-32-16 0-32 0 0-112 0-16-16 0-40 0-16 0 0 32 16 0 24 0 0 96-32 0-16 0zm88-168l0-48-48 0 0 48 48 0z';
$bfc2654b2effb9b9$exports.definition = {
    prefix: $bfc2654b2effb9b9$var$prefix,
    iconName: $bfc2654b2effb9b9$var$iconName,
    icon: [
        $bfc2654b2effb9b9$var$width,
        $bfc2654b2effb9b9$var$height,
        $bfc2654b2effb9b9$var$aliases,
        $bfc2654b2effb9b9$var$unicode,
        $bfc2654b2effb9b9$var$svgPathData
    ]
};
$bfc2654b2effb9b9$exports.faCircleInfo = $bfc2654b2effb9b9$exports.definition;
$bfc2654b2effb9b9$exports.prefix = $bfc2654b2effb9b9$var$prefix;
$bfc2654b2effb9b9$exports.iconName = $bfc2654b2effb9b9$var$iconName;
$bfc2654b2effb9b9$exports.width = $bfc2654b2effb9b9$var$width;
$bfc2654b2effb9b9$exports.height = $bfc2654b2effb9b9$var$height;
$bfc2654b2effb9b9$exports.ligatures = $bfc2654b2effb9b9$var$aliases;
$bfc2654b2effb9b9$exports.unicode = $bfc2654b2effb9b9$var$unicode;
$bfc2654b2effb9b9$exports.svgPathData = $bfc2654b2effb9b9$var$svgPathData;
$bfc2654b2effb9b9$exports.aliases = $bfc2654b2effb9b9$var$aliases;


$09f6307810186e53$exports.definition = {
    prefix: $bfc2654b2effb9b9$exports.prefix,
    iconName: $bfc2654b2effb9b9$exports.iconName,
    icon: [
        $bfc2654b2effb9b9$exports.width,
        $bfc2654b2effb9b9$exports.height,
        $bfc2654b2effb9b9$exports.aliases,
        $bfc2654b2effb9b9$exports.unicode,
        $bfc2654b2effb9b9$exports.svgPathData
    ]
};
$09f6307810186e53$exports.faInfoCircle = $09f6307810186e53$exports.definition;
$09f6307810186e53$exports.prefix = $bfc2654b2effb9b9$exports.prefix;
$09f6307810186e53$exports.iconName = $bfc2654b2effb9b9$exports.iconName;
$09f6307810186e53$exports.width = $bfc2654b2effb9b9$exports.width;
$09f6307810186e53$exports.height = $bfc2654b2effb9b9$exports.height;
$09f6307810186e53$exports.ligatures = $bfc2654b2effb9b9$exports.aliases;
$09f6307810186e53$exports.unicode = $bfc2654b2effb9b9$exports.unicode;
$09f6307810186e53$exports.svgPathData = $bfc2654b2effb9b9$exports.svgPathData;
$09f6307810186e53$exports.aliases = $bfc2654b2effb9b9$exports.aliases;


var $967040f864bbb128$exports = {};
'use strict';
Object.defineProperty($967040f864bbb128$exports, '__esModule', {
    value: true
});
var $967040f864bbb128$var$prefix = 'fasl';
var $967040f864bbb128$var$iconName = 'bell';
var $967040f864bbb128$var$width = 448;
var $967040f864bbb128$var$height = 512;
var $967040f864bbb128$var$aliases = [
    128276,
    61602
];
var $967040f864bbb128$var$unicode = 'f0f3';
var $967040f864bbb128$var$svgPathData = 'M208 0l32 0 0 32.8c80.9 8 144 76.2 144 159.2l0 97.4 59.3 59.3 4.7 4.7 0 6.6 0 40 0 16-16 0L16 416 0 416l0-16 0-40 0-6.6 4.7-4.7L64 289.4 64 192c0-83 63.1-151.2 144-159.2L208 0zm16 64C153.3 64 96 121.3 96 192l0 104 0 6.6-4.7 4.7L32 366.6 32 384l384 0 0-17.4-59.3-59.3-4.7-4.7 0-6.6 0-104c0-70.7-57.3-128-128-128zM160 448l32 0c0 17.7 14.3 32 32 32s32-14.3 32-32l32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64z';
$967040f864bbb128$exports.definition = {
    prefix: $967040f864bbb128$var$prefix,
    iconName: $967040f864bbb128$var$iconName,
    icon: [
        $967040f864bbb128$var$width,
        $967040f864bbb128$var$height,
        $967040f864bbb128$var$aliases,
        $967040f864bbb128$var$unicode,
        $967040f864bbb128$var$svgPathData
    ]
};
$967040f864bbb128$exports.faBell = $967040f864bbb128$exports.definition;
$967040f864bbb128$exports.prefix = $967040f864bbb128$var$prefix;
$967040f864bbb128$exports.iconName = $967040f864bbb128$var$iconName;
$967040f864bbb128$exports.width = $967040f864bbb128$var$width;
$967040f864bbb128$exports.height = $967040f864bbb128$var$height;
$967040f864bbb128$exports.ligatures = $967040f864bbb128$var$aliases;
$967040f864bbb128$exports.unicode = $967040f864bbb128$var$unicode;
$967040f864bbb128$exports.svgPathData = $967040f864bbb128$var$svgPathData;
$967040f864bbb128$exports.aliases = $967040f864bbb128$var$aliases;


var $314c90cd1de39325$exports = {};
'use strict';
Object.defineProperty($314c90cd1de39325$exports, '__esModule', {
    value: true
});
var $314c90cd1de39325$var$prefix = 'fasl';
var $314c90cd1de39325$var$iconName = 'sliders';
var $314c90cd1de39325$var$width = 512;
var $314c90cd1de39325$var$height = 512;
var $314c90cd1de39325$var$aliases = [
    "sliders-h"
];
var $314c90cd1de39325$var$unicode = 'f1de';
var $314c90cd1de39325$var$svgPathData = 'M0 400l0 32 16 0 64 0 0 32 0 32 32 0 96 0 32 0 0-32 0-32 256 0 16 0 0-32-16 0-256 0 0-32 0-32-32 0-96 0-32 0 0 32 0 32-64 0L0 400zm208 32l0 32-96 0 0-32 0-32 0-32 96 0 0 32 0 32zM0 240l0 32 16 0 256 0 0 32 0 32 32 0 96 0 32 0 0-32 0-32 64 0 16 0 0-32-16 0-64 0 0-32 0-32-32 0-96 0-32 0 0 32 0 32L16 240 0 240zM112 112l0 32 0 32 32 0 96 0 32 0 0-32 0-32 224 0 16 0 0-32-16 0L272 80l0-32 0-32-32 0-96 0-32 0 0 32 0 32L16 80 0 80l0 32 16 0 96 0zm32 0l0-32 0-32 96 0 0 32 0 32 0 32-96 0 0-32zM400 240l0 32 0 32-96 0 0-32 0-32 0-32 96 0 0 32z';
$314c90cd1de39325$exports.definition = {
    prefix: $314c90cd1de39325$var$prefix,
    iconName: $314c90cd1de39325$var$iconName,
    icon: [
        $314c90cd1de39325$var$width,
        $314c90cd1de39325$var$height,
        $314c90cd1de39325$var$aliases,
        $314c90cd1de39325$var$unicode,
        $314c90cd1de39325$var$svgPathData
    ]
};
$314c90cd1de39325$exports.faSliders = $314c90cd1de39325$exports.definition;
$314c90cd1de39325$exports.prefix = $314c90cd1de39325$var$prefix;
$314c90cd1de39325$exports.iconName = $314c90cd1de39325$var$iconName;
$314c90cd1de39325$exports.width = $314c90cd1de39325$var$width;
$314c90cd1de39325$exports.height = $314c90cd1de39325$var$height;
$314c90cd1de39325$exports.ligatures = $314c90cd1de39325$var$aliases;
$314c90cd1de39325$exports.unicode = $314c90cd1de39325$var$unicode;
$314c90cd1de39325$exports.svgPathData = $314c90cd1de39325$var$svgPathData;
$314c90cd1de39325$exports.aliases = $314c90cd1de39325$var$aliases;


var $0b11c4546ba64deb$exports = {};
'use strict';
Object.defineProperty($0b11c4546ba64deb$exports, '__esModule', {
    value: true
});
var $0b11c4546ba64deb$var$prefix = 'fasl';
var $0b11c4546ba64deb$var$iconName = 'truck';
var $0b11c4546ba64deb$var$width = 640;
var $0b11c4546ba64deb$var$height = 512;
var $0b11c4546ba64deb$var$aliases = [
    128666,
    9951
];
var $0b11c4546ba64deb$var$unicode = 'f0d1';
var $0b11c4546ba64deb$var$svgPathData = 'M32 32l0 352 37.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64L384 384l0-352L32 32zM64 416l-32 0L0 416l0-32L0 32 0 0 32 0 384 0l32 0 0 32 0 64 80 0 7.4 0 4.8 5.6 96 112 3.9 4.5 0 5.9 0 160 16 0 16 0 0 32-16 0-16 0-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96zM416 224l154.9 0-82.3-96L416 128l0 96zm0 32l0 88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64l5.5 0 0-128-160 0zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z';
$0b11c4546ba64deb$exports.definition = {
    prefix: $0b11c4546ba64deb$var$prefix,
    iconName: $0b11c4546ba64deb$var$iconName,
    icon: [
        $0b11c4546ba64deb$var$width,
        $0b11c4546ba64deb$var$height,
        $0b11c4546ba64deb$var$aliases,
        $0b11c4546ba64deb$var$unicode,
        $0b11c4546ba64deb$var$svgPathData
    ]
};
$0b11c4546ba64deb$exports.faTruck = $0b11c4546ba64deb$exports.definition;
$0b11c4546ba64deb$exports.prefix = $0b11c4546ba64deb$var$prefix;
$0b11c4546ba64deb$exports.iconName = $0b11c4546ba64deb$var$iconName;
$0b11c4546ba64deb$exports.width = $0b11c4546ba64deb$var$width;
$0b11c4546ba64deb$exports.height = $0b11c4546ba64deb$var$height;
$0b11c4546ba64deb$exports.ligatures = $0b11c4546ba64deb$var$aliases;
$0b11c4546ba64deb$exports.unicode = $0b11c4546ba64deb$var$unicode;
$0b11c4546ba64deb$exports.svgPathData = $0b11c4546ba64deb$var$svgPathData;
$0b11c4546ba64deb$exports.aliases = $0b11c4546ba64deb$var$aliases;


var $0ac021a5f65eab19$exports = {};
'use strict';
Object.defineProperty($0ac021a5f65eab19$exports, '__esModule', {
    value: true
});
var $0ac021a5f65eab19$var$prefix = 'fasl';
var $0ac021a5f65eab19$var$iconName = 'boxes-stacked';
var $0ac021a5f65eab19$var$width = 576;
var $0ac021a5f65eab19$var$height = 512;
var $0ac021a5f65eab19$var$aliases = [
    62625,
    "boxes",
    "boxes-alt"
];
var $0ac021a5f65eab19$var$unicode = 'f468';
var $0ac021a5f65eab19$var$svgPathData = 'M416 32l0 160 32 0 0-160 0-32L416 0 352 0 320 0 256 0 224 0 160 0 128 0l0 32 0 160 32 0 0-160 64 0 0 64 0 32 32 0 64 0 32 0 0-32 0-64 64 0zM256 32l64 0 0 64-64 0 0-64zm96 480l192 0 32 0 0-32 0-224 0-32-32 0-64 0-32 0-64 0-32 0 0 32 0 64 0 32 32 0 64 0 32 0 0-32 0-64 64 0 0 224-192 0 0 32zm32-256l64 0 0 64-64 0 0-64zM288 480L32 480l0-224 64 0 0 64 0 32 32 0 64 0 32 0 0-32 0-64 64 0 0 224zM128 320l0-64 64 0 0 64-64 0zm160-96l-64 0-32 0-64 0-32 0-64 0L0 224l0 32L0 480l0 32 32 0 256 0 32 0 0-32 0-224 0-32-32 0z';
$0ac021a5f65eab19$exports.definition = {
    prefix: $0ac021a5f65eab19$var$prefix,
    iconName: $0ac021a5f65eab19$var$iconName,
    icon: [
        $0ac021a5f65eab19$var$width,
        $0ac021a5f65eab19$var$height,
        $0ac021a5f65eab19$var$aliases,
        $0ac021a5f65eab19$var$unicode,
        $0ac021a5f65eab19$var$svgPathData
    ]
};
$0ac021a5f65eab19$exports.faBoxesStacked = $0ac021a5f65eab19$exports.definition;
$0ac021a5f65eab19$exports.prefix = $0ac021a5f65eab19$var$prefix;
$0ac021a5f65eab19$exports.iconName = $0ac021a5f65eab19$var$iconName;
$0ac021a5f65eab19$exports.width = $0ac021a5f65eab19$var$width;
$0ac021a5f65eab19$exports.height = $0ac021a5f65eab19$var$height;
$0ac021a5f65eab19$exports.ligatures = $0ac021a5f65eab19$var$aliases;
$0ac021a5f65eab19$exports.unicode = $0ac021a5f65eab19$var$unicode;
$0ac021a5f65eab19$exports.svgPathData = $0ac021a5f65eab19$var$svgPathData;
$0ac021a5f65eab19$exports.aliases = $0ac021a5f65eab19$var$aliases;


var $aceef68ea9c54150$exports = {};
'use strict';
Object.defineProperty($aceef68ea9c54150$exports, '__esModule', {
    value: true
});
var $aceef68ea9c54150$var$prefix = 'fasl';
var $aceef68ea9c54150$var$iconName = 'phone';
var $aceef68ea9c54150$var$width = 512;
var $aceef68ea9c54150$var$height = 512;
var $aceef68ea9c54150$var$aliases = [
    128222,
    128379
];
var $aceef68ea9c54150$var$unicode = 'f095';
var $aceef68ea9c54150$var$svgPathData = 'M301.7 367.6l-21.3-12.3c-51.4-29.6-94.1-72.4-123.7-123.7l-12.3-21.3 17.3-17.3 40.7-40.7L156 36.2 32 58.7 32 64c0 229.7 186.3 416 416 416l5.3 0 22.5-124L359.7 309.5 319 350.2l-17.3 17.4zM352 272l160 64L480 512l-32 0C200.6 512 0 311.4 0 64L0 32 176 0l64 160-55.6 55.6c26.8 46.5 65.5 85.2 112 112L352 272z';
$aceef68ea9c54150$exports.definition = {
    prefix: $aceef68ea9c54150$var$prefix,
    iconName: $aceef68ea9c54150$var$iconName,
    icon: [
        $aceef68ea9c54150$var$width,
        $aceef68ea9c54150$var$height,
        $aceef68ea9c54150$var$aliases,
        $aceef68ea9c54150$var$unicode,
        $aceef68ea9c54150$var$svgPathData
    ]
};
$aceef68ea9c54150$exports.faPhone = $aceef68ea9c54150$exports.definition;
$aceef68ea9c54150$exports.prefix = $aceef68ea9c54150$var$prefix;
$aceef68ea9c54150$exports.iconName = $aceef68ea9c54150$var$iconName;
$aceef68ea9c54150$exports.width = $aceef68ea9c54150$var$width;
$aceef68ea9c54150$exports.height = $aceef68ea9c54150$var$height;
$aceef68ea9c54150$exports.ligatures = $aceef68ea9c54150$var$aliases;
$aceef68ea9c54150$exports.unicode = $aceef68ea9c54150$var$unicode;
$aceef68ea9c54150$exports.svgPathData = $aceef68ea9c54150$var$svgPathData;
$aceef68ea9c54150$exports.aliases = $aceef68ea9c54150$var$aliases;


var $0901c87fb8ab5904$exports = {};
'use strict';
Object.defineProperty($0901c87fb8ab5904$exports, '__esModule', {
    value: true
});
var $0901c87fb8ab5904$var$prefix = 'fasl';
var $0901c87fb8ab5904$var$iconName = 'tag';
var $0901c87fb8ab5904$var$width = 448;
var $0901c87fb8ab5904$var$height = 512;
var $0901c87fb8ab5904$var$aliases = [
    127991
];
var $0901c87fb8ab5904$var$unicode = 'f02b';
var $0901c87fb8ab5904$var$svgPathData = 'M224 434.7L32 242.7 32 64l178.7 0 192 192L224 434.7zM425.4 233.4L224 32 32 32 0 32 0 64 0 256 201.4 457.4 224 480l22.6-22.6L425.4 278.6 448 256l-22.6-22.6zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';
$0901c87fb8ab5904$exports.definition = {
    prefix: $0901c87fb8ab5904$var$prefix,
    iconName: $0901c87fb8ab5904$var$iconName,
    icon: [
        $0901c87fb8ab5904$var$width,
        $0901c87fb8ab5904$var$height,
        $0901c87fb8ab5904$var$aliases,
        $0901c87fb8ab5904$var$unicode,
        $0901c87fb8ab5904$var$svgPathData
    ]
};
$0901c87fb8ab5904$exports.faTag = $0901c87fb8ab5904$exports.definition;
$0901c87fb8ab5904$exports.prefix = $0901c87fb8ab5904$var$prefix;
$0901c87fb8ab5904$exports.iconName = $0901c87fb8ab5904$var$iconName;
$0901c87fb8ab5904$exports.width = $0901c87fb8ab5904$var$width;
$0901c87fb8ab5904$exports.height = $0901c87fb8ab5904$var$height;
$0901c87fb8ab5904$exports.ligatures = $0901c87fb8ab5904$var$aliases;
$0901c87fb8ab5904$exports.unicode = $0901c87fb8ab5904$var$unicode;
$0901c87fb8ab5904$exports.svgPathData = $0901c87fb8ab5904$var$svgPathData;
$0901c87fb8ab5904$exports.aliases = $0901c87fb8ab5904$var$aliases;


var $2fbcd097042f8130$exports = {};
'use strict';
Object.defineProperty($2fbcd097042f8130$exports, '__esModule', {
    value: true
});
var $2fbcd097042f8130$var$prefix = 'fasl';
var $2fbcd097042f8130$var$iconName = 'language';
var $2fbcd097042f8130$var$width = 640;
var $2fbcd097042f8130$var$height = 512;
var $2fbcd097042f8130$var$aliases = [];
var $2fbcd097042f8130$var$unicode = 'f1ab';
var $2fbcd097042f8130$var$svgPathData = 'M32 96l0 320 272 0 0-320L32 96zM336 416l272 0 0-320L336 96l0 320zM608 64l32 0 0 32 0 320 0 32-32 0L32 448 0 448l0-32L0 96 0 64l32 0 576 0zM496 160l0 16 0 16 48 0 16 0 16 0 0 32-16 0-6.1 0-41.8 83.7c1.7 1.1 3.5 2.2 5.3 3.3l18.9 11.3 13.7 8.2L533.5 358l-13.7-8.2-18.9-11.3c-5.6-3.4-11-7-16.3-10.8l-45.4 22.7-14.3 7.2-14.3-28.6 14.3-7.2L458.3 305l-21.6-21.6L425.4 272 448 249.4l11.3 11.3 22.6 22.6c1.5 1.5 2.9 2.9 4.4 4.3L518.1 224 480 224l-80 0-16 0 0-32 16 0 64 0 0-16 0-16 32 0zm-346.7 0l21.5 0 4.1 9.9 72 176 2.5 6.1-34.6 0-13.1-32.1c-.5 .1-1.1 .1-1.6 .1l-80 0c-.5 0-1.1 0-1.6-.1L105.3 352l-34.6 0 2.5-6.1 72-176 4.1-9.9zM160 218.3L131.5 288l57.1 0L160 218.3z';
$2fbcd097042f8130$exports.definition = {
    prefix: $2fbcd097042f8130$var$prefix,
    iconName: $2fbcd097042f8130$var$iconName,
    icon: [
        $2fbcd097042f8130$var$width,
        $2fbcd097042f8130$var$height,
        $2fbcd097042f8130$var$aliases,
        $2fbcd097042f8130$var$unicode,
        $2fbcd097042f8130$var$svgPathData
    ]
};
$2fbcd097042f8130$exports.faLanguage = $2fbcd097042f8130$exports.definition;
$2fbcd097042f8130$exports.prefix = $2fbcd097042f8130$var$prefix;
$2fbcd097042f8130$exports.iconName = $2fbcd097042f8130$var$iconName;
$2fbcd097042f8130$exports.width = $2fbcd097042f8130$var$width;
$2fbcd097042f8130$exports.height = $2fbcd097042f8130$var$height;
$2fbcd097042f8130$exports.ligatures = $2fbcd097042f8130$var$aliases;
$2fbcd097042f8130$exports.unicode = $2fbcd097042f8130$var$unicode;
$2fbcd097042f8130$exports.svgPathData = $2fbcd097042f8130$var$svgPathData;
$2fbcd097042f8130$exports.aliases = $2fbcd097042f8130$var$aliases;


var $a8d89ffdd07efafc$exports = {};
'use strict';
Object.defineProperty($a8d89ffdd07efafc$exports, '__esModule', {
    value: true
});
var $a8d89ffdd07efafc$var$prefix = 'fasl';
var $a8d89ffdd07efafc$var$iconName = 'euro-sign';
var $a8d89ffdd07efafc$var$width = 320;
var $a8d89ffdd07efafc$var$height = 512;
var $a8d89ffdd07efafc$var$aliases = [
    8364,
    "eur",
    "euro"
];
var $a8d89ffdd07efafc$var$unicode = 'f153';
var $a8d89ffdd07efafc$var$svgPathData = 'M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32L0 288l0 32 41.3 0C68.8 412.5 154.5 480 256 480l49 0 16 0 0-32-16 0-49 0c-83.6 0-154.7-53.4-181.1-128L288 320l0-32L66.7 288c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32L288 224l0-32L74.9 192C101.3 117.4 172.4 64 256 64l49 0 16 0 0-32-16 0-49 0C154.5 32 68.8 99.5 41.3 192L0 192l0 32 34.3 0z';
$a8d89ffdd07efafc$exports.definition = {
    prefix: $a8d89ffdd07efafc$var$prefix,
    iconName: $a8d89ffdd07efafc$var$iconName,
    icon: [
        $a8d89ffdd07efafc$var$width,
        $a8d89ffdd07efafc$var$height,
        $a8d89ffdd07efafc$var$aliases,
        $a8d89ffdd07efafc$var$unicode,
        $a8d89ffdd07efafc$var$svgPathData
    ]
};
$a8d89ffdd07efafc$exports.faEuroSign = $a8d89ffdd07efafc$exports.definition;
$a8d89ffdd07efafc$exports.prefix = $a8d89ffdd07efafc$var$prefix;
$a8d89ffdd07efafc$exports.iconName = $a8d89ffdd07efafc$var$iconName;
$a8d89ffdd07efafc$exports.width = $a8d89ffdd07efafc$var$width;
$a8d89ffdd07efafc$exports.height = $a8d89ffdd07efafc$var$height;
$a8d89ffdd07efafc$exports.ligatures = $a8d89ffdd07efafc$var$aliases;
$a8d89ffdd07efafc$exports.unicode = $a8d89ffdd07efafc$var$unicode;
$a8d89ffdd07efafc$exports.svgPathData = $a8d89ffdd07efafc$var$svgPathData;
$a8d89ffdd07efafc$exports.aliases = $a8d89ffdd07efafc$var$aliases;


var $3a6847e05772cce7$exports = {};
'use strict';
Object.defineProperty($3a6847e05772cce7$exports, '__esModule', {
    value: true
});
var $3a6847e05772cce7$var$prefix = 'fab';
var $3a6847e05772cce7$var$iconName = 'facebook-f';
var $3a6847e05772cce7$var$width = 320;
var $3a6847e05772cce7$var$height = 512;
var $3a6847e05772cce7$var$aliases = [];
var $3a6847e05772cce7$var$unicode = 'f39e';
var $3a6847e05772cce7$var$svgPathData = 'M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z';
$3a6847e05772cce7$exports.definition = {
    prefix: $3a6847e05772cce7$var$prefix,
    iconName: $3a6847e05772cce7$var$iconName,
    icon: [
        $3a6847e05772cce7$var$width,
        $3a6847e05772cce7$var$height,
        $3a6847e05772cce7$var$aliases,
        $3a6847e05772cce7$var$unicode,
        $3a6847e05772cce7$var$svgPathData
    ]
};
$3a6847e05772cce7$exports.faFacebookF = $3a6847e05772cce7$exports.definition;
$3a6847e05772cce7$exports.prefix = $3a6847e05772cce7$var$prefix;
$3a6847e05772cce7$exports.iconName = $3a6847e05772cce7$var$iconName;
$3a6847e05772cce7$exports.width = $3a6847e05772cce7$var$width;
$3a6847e05772cce7$exports.height = $3a6847e05772cce7$var$height;
$3a6847e05772cce7$exports.ligatures = $3a6847e05772cce7$var$aliases;
$3a6847e05772cce7$exports.unicode = $3a6847e05772cce7$var$unicode;
$3a6847e05772cce7$exports.svgPathData = $3a6847e05772cce7$var$svgPathData;
$3a6847e05772cce7$exports.aliases = $3a6847e05772cce7$var$aliases;


var $9186f29e009cc3a0$exports = {};
'use strict';
Object.defineProperty($9186f29e009cc3a0$exports, '__esModule', {
    value: true
});
var $9186f29e009cc3a0$var$prefix = 'fab';
var $9186f29e009cc3a0$var$iconName = 'tiktok';
var $9186f29e009cc3a0$var$width = 448;
var $9186f29e009cc3a0$var$height = 512;
var $9186f29e009cc3a0$var$aliases = [];
var $9186f29e009cc3a0$var$unicode = 'e07b';
var $9186f29e009cc3a0$var$svgPathData = 'M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z';
$9186f29e009cc3a0$exports.definition = {
    prefix: $9186f29e009cc3a0$var$prefix,
    iconName: $9186f29e009cc3a0$var$iconName,
    icon: [
        $9186f29e009cc3a0$var$width,
        $9186f29e009cc3a0$var$height,
        $9186f29e009cc3a0$var$aliases,
        $9186f29e009cc3a0$var$unicode,
        $9186f29e009cc3a0$var$svgPathData
    ]
};
$9186f29e009cc3a0$exports.faTiktok = $9186f29e009cc3a0$exports.definition;
$9186f29e009cc3a0$exports.prefix = $9186f29e009cc3a0$var$prefix;
$9186f29e009cc3a0$exports.iconName = $9186f29e009cc3a0$var$iconName;
$9186f29e009cc3a0$exports.width = $9186f29e009cc3a0$var$width;
$9186f29e009cc3a0$exports.height = $9186f29e009cc3a0$var$height;
$9186f29e009cc3a0$exports.ligatures = $9186f29e009cc3a0$var$aliases;
$9186f29e009cc3a0$exports.unicode = $9186f29e009cc3a0$var$unicode;
$9186f29e009cc3a0$exports.svgPathData = $9186f29e009cc3a0$var$svgPathData;
$9186f29e009cc3a0$exports.aliases = $9186f29e009cc3a0$var$aliases;


var $746273076b4acb8b$exports = {};
'use strict';
Object.defineProperty($746273076b4acb8b$exports, '__esModule', {
    value: true
});
var $746273076b4acb8b$var$prefix = 'fab';
var $746273076b4acb8b$var$iconName = 'instagram';
var $746273076b4acb8b$var$width = 448;
var $746273076b4acb8b$var$height = 512;
var $746273076b4acb8b$var$aliases = [];
var $746273076b4acb8b$var$unicode = 'f16d';
var $746273076b4acb8b$var$svgPathData = 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z';
$746273076b4acb8b$exports.definition = {
    prefix: $746273076b4acb8b$var$prefix,
    iconName: $746273076b4acb8b$var$iconName,
    icon: [
        $746273076b4acb8b$var$width,
        $746273076b4acb8b$var$height,
        $746273076b4acb8b$var$aliases,
        $746273076b4acb8b$var$unicode,
        $746273076b4acb8b$var$svgPathData
    ]
};
$746273076b4acb8b$exports.faInstagram = $746273076b4acb8b$exports.definition;
$746273076b4acb8b$exports.prefix = $746273076b4acb8b$var$prefix;
$746273076b4acb8b$exports.iconName = $746273076b4acb8b$var$iconName;
$746273076b4acb8b$exports.width = $746273076b4acb8b$var$width;
$746273076b4acb8b$exports.height = $746273076b4acb8b$var$height;
$746273076b4acb8b$exports.ligatures = $746273076b4acb8b$var$aliases;
$746273076b4acb8b$exports.unicode = $746273076b4acb8b$var$unicode;
$746273076b4acb8b$exports.svgPathData = $746273076b4acb8b$var$svgPathData;
$746273076b4acb8b$exports.aliases = $746273076b4acb8b$var$aliases;


var $77b6be61db3b933c$exports = {};
'use strict';
Object.defineProperty($77b6be61db3b933c$exports, '__esModule', {
    value: true
});
var $77b6be61db3b933c$var$prefix = 'fab';
var $77b6be61db3b933c$var$iconName = 'facebook-messenger';
var $77b6be61db3b933c$var$width = 512;
var $77b6be61db3b933c$var$height = 512;
var $77b6be61db3b933c$var$aliases = [];
var $77b6be61db3b933c$var$unicode = 'f39f';
var $77b6be61db3b933c$var$svgPathData = 'M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z';
$77b6be61db3b933c$exports.definition = {
    prefix: $77b6be61db3b933c$var$prefix,
    iconName: $77b6be61db3b933c$var$iconName,
    icon: [
        $77b6be61db3b933c$var$width,
        $77b6be61db3b933c$var$height,
        $77b6be61db3b933c$var$aliases,
        $77b6be61db3b933c$var$unicode,
        $77b6be61db3b933c$var$svgPathData
    ]
};
$77b6be61db3b933c$exports.faFacebookMessenger = $77b6be61db3b933c$exports.definition;
$77b6be61db3b933c$exports.prefix = $77b6be61db3b933c$var$prefix;
$77b6be61db3b933c$exports.iconName = $77b6be61db3b933c$var$iconName;
$77b6be61db3b933c$exports.width = $77b6be61db3b933c$var$width;
$77b6be61db3b933c$exports.height = $77b6be61db3b933c$var$height;
$77b6be61db3b933c$exports.ligatures = $77b6be61db3b933c$var$aliases;
$77b6be61db3b933c$exports.unicode = $77b6be61db3b933c$var$unicode;
$77b6be61db3b933c$exports.svgPathData = $77b6be61db3b933c$var$svgPathData;
$77b6be61db3b933c$exports.aliases = $77b6be61db3b933c$var$aliases;


var $ae0f9f5d26940a27$exports = {};
'use strict';
Object.defineProperty($ae0f9f5d26940a27$exports, '__esModule', {
    value: true
});
var $ae0f9f5d26940a27$var$prefix = 'fab';
var $ae0f9f5d26940a27$var$iconName = 'linkedin-in';
var $ae0f9f5d26940a27$var$width = 448;
var $ae0f9f5d26940a27$var$height = 512;
var $ae0f9f5d26940a27$var$aliases = [];
var $ae0f9f5d26940a27$var$unicode = 'f0e1';
var $ae0f9f5d26940a27$var$svgPathData = 'M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z';
$ae0f9f5d26940a27$exports.definition = {
    prefix: $ae0f9f5d26940a27$var$prefix,
    iconName: $ae0f9f5d26940a27$var$iconName,
    icon: [
        $ae0f9f5d26940a27$var$width,
        $ae0f9f5d26940a27$var$height,
        $ae0f9f5d26940a27$var$aliases,
        $ae0f9f5d26940a27$var$unicode,
        $ae0f9f5d26940a27$var$svgPathData
    ]
};
$ae0f9f5d26940a27$exports.faLinkedinIn = $ae0f9f5d26940a27$exports.definition;
$ae0f9f5d26940a27$exports.prefix = $ae0f9f5d26940a27$var$prefix;
$ae0f9f5d26940a27$exports.iconName = $ae0f9f5d26940a27$var$iconName;
$ae0f9f5d26940a27$exports.width = $ae0f9f5d26940a27$var$width;
$ae0f9f5d26940a27$exports.height = $ae0f9f5d26940a27$var$height;
$ae0f9f5d26940a27$exports.ligatures = $ae0f9f5d26940a27$var$aliases;
$ae0f9f5d26940a27$exports.unicode = $ae0f9f5d26940a27$var$unicode;
$ae0f9f5d26940a27$exports.svgPathData = $ae0f9f5d26940a27$var$svgPathData;
$ae0f9f5d26940a27$exports.aliases = $ae0f9f5d26940a27$var$aliases;


var $6400805a40544091$exports = {};
'use strict';
Object.defineProperty($6400805a40544091$exports, '__esModule', {
    value: true
});
var $6400805a40544091$var$prefix = 'fab';
var $6400805a40544091$var$iconName = 'youtube';
var $6400805a40544091$var$width = 576;
var $6400805a40544091$var$height = 512;
var $6400805a40544091$var$aliases = [
    61802
];
var $6400805a40544091$var$unicode = 'f167';
var $6400805a40544091$var$svgPathData = 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z';
$6400805a40544091$exports.definition = {
    prefix: $6400805a40544091$var$prefix,
    iconName: $6400805a40544091$var$iconName,
    icon: [
        $6400805a40544091$var$width,
        $6400805a40544091$var$height,
        $6400805a40544091$var$aliases,
        $6400805a40544091$var$unicode,
        $6400805a40544091$var$svgPathData
    ]
};
$6400805a40544091$exports.faYoutube = $6400805a40544091$exports.definition;
$6400805a40544091$exports.prefix = $6400805a40544091$var$prefix;
$6400805a40544091$exports.iconName = $6400805a40544091$var$iconName;
$6400805a40544091$exports.width = $6400805a40544091$var$width;
$6400805a40544091$exports.height = $6400805a40544091$var$height;
$6400805a40544091$exports.ligatures = $6400805a40544091$var$aliases;
$6400805a40544091$exports.unicode = $6400805a40544091$var$unicode;
$6400805a40544091$exports.svgPathData = $6400805a40544091$var$svgPathData;
$6400805a40544091$exports.aliases = $6400805a40544091$var$aliases;


const $223e7c118c6045b6$var$lightSharpcons = [
    (0, $9644b492f5164b95$exports.faShoppingCart),
    (0, $3e281d7f16ce71b0$exports.faUser),
    (0, $e2cc4b9865f83dc5$exports.faEnvelope),
    (0, $437d5b8059a75ba7$exports.faArrowRight),
    (0, $de6a410236883f47$exports.faArrowLeft),
    (0, $2183f250c1603ef8$exports.faBadgeCheck),
    (0, $0bc520ea3cc85faf$exports.faCartShopping),
    (0, $8d7de1ecc6167bef$exports.faCheck),
    (0, $194f4493ef3f9b51$exports.faBars),
    (0, $3972f7e8998cc1b5$exports.faSearch),
    (0, $e7d3361291756d02$exports.faShoppingBasket),
    (0, $7fd256b5e47dcaab$exports.faAngleDown),
    (0, $455527c9fcec973d$exports.faAngleUp),
    (0, $9734e6c11ce24fb6$exports.faTimes),
    (0, $403e79f85990d392$exports.faBadgePercent),
    (0, $3967d5084e7a6291$exports.faPlus),
    (0, $40f149ed6a241035$exports.faMinus),
    (0, $2aeda45b73ab5103$exports.faChevronDown),
    (0, $b0a43adb2ac34c90$exports.faSort),
    (0, $09f6307810186e53$exports.faInfoCircle),
    (0, $861c519f832e64a1$exports.faStar),
    (0, $967040f864bbb128$exports.faBell),
    (0, $314c90cd1de39325$exports.faSliders),
    (0, $aceef68ea9c54150$exports.faPhone),
    (0, $0b11c4546ba64deb$exports.faTruck),
    (0, $0ac021a5f65eab19$exports.faBoxesStacked),
    (0, $0901c87fb8ab5904$exports.faTag),
    (0, $2fbcd097042f8130$exports.faLanguage),
    (0, $a8d89ffdd07efafc$exports.faEuroSign)
];
const $223e7c118c6045b6$var$socialIcons = [
    (0, $3a6847e05772cce7$exports.faFacebookF),
    (0, $9186f29e009cc3a0$exports.faTiktok),
    (0, $6400805a40544091$exports.faYoutube),
    (0, $746273076b4acb8b$exports.faInstagram),
    (0, $77b6be61db3b933c$exports.faFacebookMessenger),
    (0, $ae0f9f5d26940a27$exports.faLinkedinIn)
];
(0, $41718d655488e1fe$export$b839f963c7dc0e34).add([
    ...$223e7c118c6045b6$var$lightSharpcons,
    ...$223e7c118c6045b6$var$socialIcons
]);
(0, $41718d655488e1fe$export$e506a1d27d1eaa20).searchPseudoElements = true;
(0, $41718d655488e1fe$export$df3a06d6289f983e).i2svg();
window.dom = (0, $41718d655488e1fe$export$df3a06d6289f983e); //dom.watch(); // dont use this in production, really heave


const $0794137f27c59179$var$menuToggle = document.querySelector("#header-menu-toggle");
$0794137f27c59179$var$menuToggle && $0794137f27c59179$var$menuToggle.addEventListener("click", ()=>{
    document.querySelector("#header-menu-aside").classList.remove("hidden");
    document.querySelector(".overlay-screen").classList.remove("hidden");
});
document.querySelector("#header-menu-aside-close").addEventListener("click", ()=>{
    document.querySelector("#header-menu-aside").classList.add("hidden");
    document.querySelector(".overlay-screen").classList.add("hidden");
    document.querySelector(".overlay-screen").style.removeProperty("z-index");
});
const $0794137f27c59179$var$headerMenusAside = document.querySelectorAll(".header-menu-aside-toggle");
$0794137f27c59179$var$headerMenusAside.forEach(function(elem) {
    elem && elem.addEventListener("click", (e)=>{
        e.preventDefault();
        const list = document.querySelector("#header-menu-aside-list" + elem.id);
        const svg = elem.querySelector("svg");
        if (list.classList.contains("hidden")) {
            list.classList.remove("hidden");
            svg.style.transform = "rotate(180deg)";
        } else {
            list.classList.add("hidden");
            svg.style.transform = "rotate(0deg)";
        }
    });
});
const $0794137f27c59179$var$headerMenus = document.querySelectorAll(".header-menu-toggle");
const $0794137f27c59179$var$dropdown = document.querySelector(".header-menus-dropdown");
let $0794137f27c59179$var$timer;
// const menuSingleLinks = document.querySelectorAll(".header-menu-single");
// menuSingleLinks.forEach((elem) => {
//     elem &&
//         elem.addEventListener("mouseenter", () => {
//             if (!dropdown.classList.contains("hidden")) {
//                 dropdown.classList.add("hidden");
//             }
//             headerMenus.forEach((menu) => {
//                 menu.classList.remove("active");
//             });
//             document.querySelector(".overlay-screen").classList.add("hidden");
//         });
// });
$0794137f27c59179$var$headerMenus.forEach(function(elem) {
    elem && elem.addEventListener("mouseenter", ()=>{
        clearTimeout($0794137f27c59179$var$timer);
        $0794137f27c59179$var$dropdown.classList.remove("hidden");
        document.querySelectorAll(".header-menu-dropdown").forEach((menu)=>{
            if (menu.id != elem.id) menu.classList.add("hidden");
        });
        $0794137f27c59179$var$resetHeaderMenuTitles();
        elem.classList.add("active");
        document.querySelector("#header-menu-dropdown-" + elem.id).classList.remove("hidden");
        document.querySelector(".overlay-screen").classList.remove("hidden");
        document.querySelector("#header-menu-toggle-icon-" + elem.id).children[0].style.transform = "rotate(180deg)";
    });
    elem && elem.addEventListener("mouseleave", ()=>{
        $0794137f27c59179$var$timer = setTimeout(()=>{
            $0794137f27c59179$var$onMouseLeaveMenu();
        }, 300);
    });
});
function $0794137f27c59179$var$onMouseLeaveMenu() {
    $0794137f27c59179$var$dropdown.classList.add("hidden");
    document.querySelector(".overlay-screen").classList.add("hidden");
    $0794137f27c59179$var$resetHeaderMenuTitles();
}
function $0794137f27c59179$var$onMouseEnterMenu() {
    $0794137f27c59179$var$dropdown.classList.remove("hidden");
    document.querySelector(".overlay-screen").classList.remove("hidden");
    document.querySelectorAll(".header-menu-dropdown").forEach((menu)=>{
        if (!menu.classList.contains("hidden")) {
            const split = menu.id.split("-");
            const i = split[split.length - 1];
            document.querySelector("#header-menu-toggle-icon-" + i).children[0].style.transform = "rotate(180deg)";
            $0794137f27c59179$var$headerMenus.forEach((menu)=>{
                if (menu.id == i) menu.classList.add("active");
            });
        }
    });
}
$0794137f27c59179$var$dropdown && $0794137f27c59179$var$dropdown.addEventListener("mouseleave", ()=>{
    $0794137f27c59179$var$timer = setTimeout(()=>{
        $0794137f27c59179$var$onMouseLeaveMenu();
    }, 300);
});
$0794137f27c59179$var$dropdown && $0794137f27c59179$var$dropdown.addEventListener("mouseenter", ()=>{
    $0794137f27c59179$var$onMouseEnterMenu();
    clearTimeout($0794137f27c59179$var$timer);
});
// Close aside menu on outside click
document.addEventListener("click", (e)=>{
    // Medium screen
    if (window.innerWidth >= 768) return;
    if (!document.querySelector("#header-menu-aside").contains(e.target) && !document.querySelector("#header-menu-toggle").contains(e.target)) {
        document.querySelector("#header-menu-aside").classList.add("hidden");
        document.querySelector(".overlay-screen").classList.add("hidden");
        document.querySelector(".overlay-screen").style.removeProperty("z-index");
    }
});
function $0794137f27c59179$var$resetHeaderMenuTitles() {
    document.querySelectorAll(".header-menu-toggle-icon").forEach((icon)=>{
        icon.children[0].style.transform = "rotate(0deg)";
    });
    $0794137f27c59179$var$headerMenus.forEach((menu)=>{
        menu.classList.remove("active");
    });
}


if (!HTMLElement.prototype.once) HTMLElement.prototype.once = function() {
    if (!this.dataset.once) {
        this.dataset.once = true;
        return this;
    }
    // otherwise return a new unattached element to prevent failing
    return document.createElement('div');
};
if (!String.prototype.getDecimals) String.prototype.getDecimals = function() {
    var num = this, match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) return 0;
    return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
};


/*!
 * swiped-events.js - v@version@
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/swiped-events
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */ (function(window1, document1) {
    "use strict";
    // patch CustomEvent to allow constructor creation (IE/Chrome)
    if (typeof window1.CustomEvent !== "function") {
        window1.CustomEvent = function(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document1.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };
        window1.CustomEvent.prototype = window1.Event.prototype;
    }
    document1.addEventListener("touchstart", handleTouchStart, false);
    document1.addEventListener("touchmove", handleTouchMove, false);
    document1.addEventListener("touchend", handleTouchEnd, false);
    var xDown = null;
    var yDown = null;
    var xDiff = null;
    var yDiff = null;
    var timeDown = null;
    var startEl = null;
    var touchCount = 0;
    /**
     * Fires swiped event if swipe detected on touchend
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchEnd(e) {
        // if the user released on a different target, cancel!
        if (startEl !== e.target) return;
        var swipeThreshold = parseInt(getNearestAttribute(startEl, "data-swipe-threshold", "20"), 10); // default 20 units
        var swipeUnit = getNearestAttribute(startEl, "data-swipe-unit", "px"); // default px
        var swipeTimeout = parseInt(getNearestAttribute(startEl, "data-swipe-timeout", "500"), 10); // default 500ms
        var timeDiff = Date.now() - timeDown;
        var eventType = "";
        var changedTouches = e.changedTouches || e.touches || [];
        if (swipeUnit === "vh") swipeThreshold = Math.round(swipeThreshold / 100 * document1.documentElement.clientHeight); // get percentage of viewport height in pixels
        if (swipeUnit === "vw") swipeThreshold = Math.round(swipeThreshold / 100 * document1.documentElement.clientWidth); // get percentage of viewport height in pixels
        if (Math.abs(xDiff) > Math.abs(yDiff)) // most significant
        {
            if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                if (xDiff > 0) eventType = "swiped-left";
                else eventType = "swiped-right";
            }
        } else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
            if (yDiff > 0) eventType = "swiped-up";
            else eventType = "swiped-down";
        }
        if (eventType !== "") {
            var eventData = {
                dir: eventType.replace(/swiped-/, ""),
                touchType: (changedTouches[0] || {}).touchType || "direct",
                fingers: touchCount,
                xStart: parseInt(xDown, 10),
                xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
                yStart: parseInt(yDown, 10),
                yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10)
            };
            // fire `swiped` event event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent("swiped", {
                bubbles: true,
                cancelable: true,
                detail: eventData
            }));
            // fire `swiped-dir` event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent(eventType, {
                bubbles: true,
                cancelable: true,
                detail: eventData
            }));
        }
        // reset values
        xDown = null;
        yDown = null;
        timeDown = null;
    }
    /**
     * Records current location on touchstart event
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchStart(e) {
        // if the element has data-swipe-ignore="true" we stop listening for swipe events
        if (e.target.getAttribute("data-swipe-ignore") === "true") return;
        startEl = e.target;
        timeDown = Date.now();
        xDown = e.touches[0].clientX;
        yDown = e.touches[0].clientY;
        xDiff = 0;
        yDiff = 0;
        touchCount = e.touches.length;
    }
    /**
     * Records location diff in px on touchmove event
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchMove(e) {
        if (!xDown || !yDown) return;
        var xUp = e.touches[0].clientX;
        var yUp = e.touches[0].clientY;
        xDiff = xDown - xUp;
        yDiff = yDown - yUp;
    }
    /**
     * Gets attribute off HTML element or nearest parent
     * @param {object} el - HTML element to retrieve attribute from
     * @param {string} attributeName - name of the attribute
     * @param {any} defaultValue - default value to return if no match found
     * @returns {any} attribute value or defaultValue
     */ function getNearestAttribute(el, attributeName, defaultValue) {
        // walk up the dom tree looking for attributeName
        while(el && el !== document1.documentElement){
            var attributeValue = el.getAttribute(attributeName);
            if (attributeValue) return attributeValue;
            el = el.parentNode;
        }
        return defaultValue;
    }
})(window, document);


const $341eeff2183d8aef$var$accordionItem = document.querySelectorAll(".bm-accordion-item");
const $341eeff2183d8aef$var$accordionTitles = document.querySelectorAll(".bm-accordion-title");
const $341eeff2183d8aef$var$accordionContents = document.querySelectorAll(".bm-accordion-content");
$341eeff2183d8aef$var$accordionItem.forEach((item)=>{
    item.querySelector(".bm-accordion-title").addEventListener("click", ()=>{
        $341eeff2183d8aef$var$accordionItem.forEach((otherItem)=>{
            if (otherItem !== item) otherItem.classList.remove("active");
        });
        item.classList.toggle("active");
    });
});


// Error messages by error type
var $37f38e07ede14368$export$2e2bcd8739ae039 = validationMessages = {
    missingValue: {
        checkbox: 'Dit veld is verplicht.',
        radio: 'Gelieve een waarde te selecteren.',
        select: 'Gelieve een waarde te selecteren.',
        'select-multiple': "Gelieve ten minste \xe9\xe9n waarde te selecteren.",
        default: 'Vul dit veld in a.u.b.'
    },
    patternMismatch: {
        email: 'Gelieve een geldig e-mailadres in te voeren.',
        url: 'Gelieve een URL in te voeren.',
        number: 'Gelieve een getal in te voeren',
        color: 'Gelieve het volgende formaat te gebruiken: #rrggbb',
        date: 'Gelieve het formaat JJJJ-MM-DD te gebruiken',
        time: 'Gelieve het 24-uurs tijdformaat te gebruiken. Bv. 23:00',
        month: 'Gelieve het formaat JJJJ-MM te gebruiken',
        default: 'Gelieve het gevraagde formaat te gebruiken.'
    },
    outOfRange: {
        over: 'Gelieve een waarde te selecteren die niet meer is dan {max}.',
        under: 'Gelieve een waarde te selecteren die niet minder is dan {min}.'
    },
    wrongLength: {
        over: 'Gelieve deze tekst in te korten tot niet meer dan {maxLength} tekens. U gebruikt momenteel {length} tekens.',
        under: 'Gelieve deze tekst te verlengen tot {minLength} tekens of meer. U gebruikt momenteel {length} tekens.'
    }
};


var $8ff1efb0b0992627$exports = {};
/*! formbouncerjs v1.4.6 | (c) 2019 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/bouncer */ "document" in self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) || function(e) {
    "use strict";
    if ("Element" in e) {
        var t = "classList", r = "prototype", n = e.Element[r], a = Object, i = String[r].trim || function() {
            return this.replace(/^\s+|\s+$/g, "");
        }, o = Array[r].indexOf || function(e) {
            for(var t = 0, r = this.length; t < r; t++)if (t in this && this[t] === e) return t;
            return -1;
        }, l = function(e, t) {
            this.name = e, this.code = DOMException[e], this.message = t;
        }, u = function(e, t) {
            if ("" === t) throw new l("SYNTAX_ERR", "An invalid or illegal string was specified");
            if (/\s/.test(t)) throw new l("INVALID_CHARACTER_ERR", "String contains an invalid character");
            return o.call(e, t);
        }, s = function(e) {
            for(var t = i.call(e.getAttribute("class") || ""), r = t ? t.split(/\s+/) : [], n = 0, a = r.length; n < a; n++)this.push(r[n]);
            this._updateClassName = function() {
                e.setAttribute("class", this.toString());
            };
        }, c = s[r] = [], f = function() {
            return new s(this);
        };
        if (l[r] = Error[r], c.item = function(e) {
            return this[e] || null;
        }, c.contains = function(e) {
            return -1 !== u(this, e += "");
        }, c.add = function() {
            for(var e, t = arguments, r = 0, n = t.length, a = !1; e = t[r] + "", -1 === u(this, e) && (this.push(e), a = !0), ++r < n;);
            a && this._updateClassName();
        }, c.remove = function() {
            var e, t, r = arguments, n = 0, a = r.length, i = !1;
            do for(e = r[n] + "", t = u(this, e); -1 !== t;)this.splice(t, 1), i = !0, t = u(this, e);
            while (++n < a);
            i && this._updateClassName();
        }, c.toggle = function(e, t) {
            e += "";
            var r = this.contains(e), n = r ? !0 !== t && "remove" : !1 !== t && "add";
            return n && this[n](e), !0 === t || !1 === t ? t : !r;
        }, c.toString = function() {
            return this.join(" ");
        }, a.defineProperty) {
            var d = {
                get: f,
                enumerable: !0,
                configurable: !0
            };
            try {
                a.defineProperty(n, t, d);
            } catch (e) {
                void 0 !== e.number && -2146823252 !== e.number || (d.enumerable = !1, a.defineProperty(n, t, d));
            }
        } else a[r].__defineGetter__ && n.__defineGetter__(t, f);
    }
}(self), function() {
    "use strict";
    var e = document.createElement("_");
    if (e.classList.add("c1", "c2"), !e.classList.contains("c2")) {
        var t = function(e) {
            var n = DOMTokenList.prototype[e];
            DOMTokenList.prototype[e] = function(e) {
                var t, r = arguments.length;
                for(t = 0; t < r; t++)e = arguments[t], n.call(this, e);
            };
        };
        t("add"), t("remove");
    }
    if (e.classList.toggle("c3", !1), e.classList.contains("c3")) {
        var r = DOMTokenList.prototype.toggle;
        DOMTokenList.prototype.toggle = function(e, t) {
            return 1 in arguments && !this.contains(e) == !t ? t : r.call(this, e);
        };
    }
    e = null;
}()), Element.prototype.closest || (Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest = function(e) {
    var t = this;
    if (!document.documentElement.contains(this)) return null;
    do {
        if (t.matches(e)) return t;
        t = t.parentElement;
    }while (null !== t);
    return null;
}), function() {
    if ("function" == typeof window.CustomEvent) return;
    function e(e, t) {
        t = t || {
            bubbles: !1,
            cancelable: !1,
            detail: void 0
        };
        var r = document.createEvent("CustomEvent");
        return r.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), r;
    }
    e.prototype = window.Event.prototype, window.CustomEvent = e;
}(), Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), function(e, t) {
    "function" == typeof define && define.amd ? define([], function() {
        return t(e);
    }) : $8ff1efb0b0992627$exports = t(e);
}("undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof window ? window : $8ff1efb0b0992627$exports, function(a) {
    "use strict";
    var u = {
        fieldClass: "error",
        errorClass: "error-message",
        fieldPrefix: "bouncer-field_",
        errorPrefix: "bouncer-error_",
        patterns: {
            email: /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/,
            url: /^(?:(?:https?|HTTPS?|ftp|FTP):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/,
            number: /^(?:[-+]?[0-9]*[.,]?[0-9]+)$/,
            color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
            date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))/,
            time: /^(?:(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]))$/,
            month: /^(?:(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])))$/
        },
        customValidations: {},
        messageAfterField: !0,
        messageCustom: "data-bouncer-message",
        messageTarget: "data-bouncer-target",
        messages: {
            missingValue: {
                checkbox: "This field is required.",
                radio: "Please select a value.",
                select: "Please select a value.",
                "select-multiple": "Please select at least one value.",
                default: "Please fill out this field."
            },
            patternMismatch: {
                email: "Please enter a valid email address.",
                url: "Please enter a URL.",
                number: "Please enter a number",
                color: "Please match the following format: #rrggbb",
                date: "Please use the YYYY-MM-DD format",
                time: "Please use the 24-hour time format. Ex. 23:00",
                month: "Please use the YYYY-MM format",
                default: "Please match the requested format."
            },
            outOfRange: {
                over: "Please select a value that is no more than {max}.",
                under: "Please select a value that is no less than {min}."
            },
            wrongLength: {
                over: "Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.",
                under: "Please lengthen this text to {minLength} characters or more. You are currently using {length} characters."
            },
            fallback: "There was an error with this field."
        },
        disableSubmit: !1,
        emitEvents: !0
    }, s = function(e, t) {
        Array.prototype.forEach.call(e, t);
    }, c = function() {
        var r = {};
        return s(arguments, function(e) {
            for(var t in e){
                if (!e.hasOwnProperty(t)) return;
                "[object Object]" === Object.prototype.toString.call(e[t]) ? r[t] = c(r[t], e[t]) : r[t] = e[t];
            }
        }), r;
    }, f = function(e, t, r) {
        if ("function" == typeof a.CustomEvent) {
            var n = new CustomEvent(t, {
                bubbles: !0,
                detail: r || {}
            });
            e.dispatchEvent(n);
        }
    }, d = function(e, t) {
        var r, n, a;
        return {
            missingValue: function(e) {
                if (!e.hasAttribute("required")) return !1;
                if ("checkbox" === e.type) return !e.checked;
                var t = e.value.length;
                return "radio" === e.type && (t = Array.prototype.filter.call(e.form.querySelectorAll('[name="' + m(e.name) + '"]'), function(e) {
                    return e.checked;
                }).length), t < 1;
            }(e),
            patternMismatch: (r = e, n = t, a = r.getAttribute("pattern"), !(!(a = a ? new RegExp("^(?:" + a + ")$") : n.patterns[r.type]) || !r.value || r.value.length < 1 || r.value.match(a))),
            outOfRange: function(e) {
                if (!e.value || e.value.length < 1) return !1;
                var t = e.getAttribute("max"), r = e.getAttribute("min"), n = parseFloat(e.value);
                return t && t < n ? "over" : !!(r && n < r) && "under";
            }(e),
            wrongLength: function(e) {
                if (!e.value || e.value.length < 1) return !1;
                var t = e.getAttribute("maxlength"), r = e.getAttribute("minlength"), n = e.value.length;
                return t && t < n ? "over" : !!(r && n < r) && "under";
            }(e)
        };
    }, m = function(e) {
        for(var t, r = String(e), n = r.length, a = -1, i = "", o = r.charCodeAt(0); ++a < n;){
            if (0 === (t = r.charCodeAt(a))) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
            1 <= t && t <= 31 || 127 == t || 0 === a && 48 <= t && t <= 57 || 1 === a && 48 <= t && t <= 57 && 45 === o ? i += "\\" + t.toString(16) + " " : i += 128 <= t || 45 === t || 95 === t || 48 <= t && t <= 57 || 65 <= t && t <= 90 || 97 <= t && t <= 122 ? r.charAt(a) : "\\" + r.charAt(a);
        }
        return i;
    }, h = function(e, t, r) {
        var n = e.name ? e.name : e.id;
        return !n && r && (n = t.fieldPrefix + Math.floor(999 * Math.random()), e.id = n), "checkbox" === e.type && (n += "_" + (e.value || e.id)), n;
    }, x = function(e, t) {
        var r = document.createElement("div");
        r.className = t.errorClass, r.id = t.errorPrefix + h(e, t, !0);
        var n = function(e, t, r) {
            var n = e.getAttribute(r.messageTarget);
            if (n) {
                var a = e.form.querySelector(n);
                if (a) return a.firstChild || a.appendChild(document.createTextNode(""));
            }
            return r.messageAfterField ? (t.nextSibling || t.parentNode.appendChild(document.createTextNode("")), t.nextSibling) : t;
        }(e, function(e) {
            if ("radio" === e.type && e.name) {
                var t = e.form.querySelectorAll('[name="' + m(e.name) + '"]');
                e = t[t.length - 1];
            }
            "radio" !== e.type && "checkbox" !== e.type || (e = e.closest("label") || e.form.querySelector('[for="' + e.id + '"]') || e);
            return e;
        }(e), t);
        return n.parentNode.insertBefore(r, n), r;
    }, v = function(e, t, r) {
        e.classList.add(r.fieldClass), e.setAttribute("aria-describedby", t.id), e.setAttribute("aria-invalid", !0);
    }, g = function(e, t, r) {
        var n, a, i, o = e.form.querySelector("#" + m(r.errorPrefix + h(e, r))) || x(e, r), l = function(e, t, r) {
            var n = r.messages;
            if (t.missingValue) return n.missingValue[e.type] || n.missingValue.default;
            if (t.outOfRange) return n.outOfRange[t.outOfRange].replace("{max}", e.getAttribute("max")).replace("{min}", e.getAttribute("min")).replace("{length}", e.value.length);
            if (t.wrongLength) return n.wrongLength[t.wrongLength].replace("{maxLength}", e.getAttribute("maxlength")).replace("{minLength}", e.getAttribute("minlength")).replace("{length}", e.value.length);
            if (t.patternMismatch) {
                var a = e.getAttribute(r.messageCustom);
                return a || n.patternMismatch[e.type] || n.patternMismatch.default;
            }
            for(var i in r.customValidations)if (r.customValidations.hasOwnProperty(i) && t[i] && n[i]) return n[i];
            return n.fallback;
        }(e, t, r);
        o.textContent = "function" == typeof l ? l(e, r) : l, a = o, i = r, "radio" === (n = e).type && n.name && Array.prototype.forEach.call(document.querySelectorAll('[name="' + n.name + '"]'), function(e) {
            v(e, a, i);
        }), v(n, a, i), r.emitEvents && f(e, "bouncerShowError", {
            errors: t
        });
    }, i = function(e, t) {
        e.classList.remove(t.fieldClass), e.removeAttribute("aria-describedby"), e.removeAttribute("aria-invalid");
    }, p = function(e, t) {
        var r, n, a = e.form.querySelector("#" + m(t.errorPrefix + h(e, t)));
        a && (a.parentNode.removeChild(a), n = t, "radio" === (r = e).type && r.name ? Array.prototype.forEach.call(document.querySelectorAll('[name="' + r.name + '"]'), function(e) {
            i(e, n);
        }) : i(r, n), t.emitEvents && f(e, "bouncerRemoveError"));
    };
    return function(n, e) {
        var l, r = {};
        r.validate = function(e, t) {
            if (!e.disabled && !e.readOnly && "reset" !== e.type && "submit" !== e.type && "button" !== e.type) {
                var r, n, a, i = c(l, t || {}), o = (a = d(r = e, n = i), {
                    valid: !function(e) {
                        for(var t in e)if (e[t]) return !0;
                        return !1;
                    }(a = function(e, t, r, n) {
                        for(var a in r)r.hasOwnProperty(a) && (t[a] = r[a](e, n));
                        return t;
                    }(r, a, n.customValidations, n)),
                    errors: a
                });
                if (!o.valid) return g(e, o.errors, i), o;
                p(e, i);
            }
        }, r.validateAll = function(e) {
            return Array.prototype.filter.call(e.querySelectorAll("input, select, textarea"), function(e) {
                var t = r.validate(e);
                return t && !t.valid;
            });
        };
        var a = function(e) {
            e.target.form && e.target.form.matches(n) && r.validate(e.target);
        }, i = function(e) {
            e.target.form && e.target.form.matches(n) && e.target.classList.contains(l.fieldClass) && r.validate(e.target);
        }, o = function(e) {
            if (e.target.matches(n)) {
                e.preventDefault();
                var t = r.validateAll(e.target);
                if (0 < t.length) return t[0].focus(), void f(e.target, "bouncerFormInvalid", {
                    errors: t
                });
                l.disableSubmit || e.target.submit(), l.emitEvents && f(e.target, "bouncerFormValid");
            }
        };
        r.destroy = function() {
            var e, t, r;
            document.removeEventListener("blur", a, !0), document.removeEventListener("input", i, !1), document.removeEventListener("click", i, !1), document.removeEventListener("submit", o, !1), e = n, t = l, s(document.querySelectorAll(e), function(e) {
                s(e.querySelectorAll("input, select, textarea"), function(e) {
                    p(e, t);
                });
            }), r = n, s(document.querySelectorAll(r), function(e) {
                e.removeAttribute("novalidate");
            }), l.emitEvents && f(document, "bouncerDestroyed", {
                settings: l
            }), l = null;
        };
        var t;
        return l = c(u, e || {}), t = n, s(document.querySelectorAll(t), function(e) {
            e.setAttribute("novalidate", !0);
        }), document.addEventListener("blur", a, !0), document.addEventListener("input", i, !1), document.addEventListener("click", i, !1), document.addEventListener("submit", o, !1), l.emitEvents && f(document, "bouncerInitialized", {
            settings: l
        }), r;
    };
});


const $03bdf524ba4539fe$export$8b2af14498e05840 = {
    actions: {},
    filters: {},
    // ACTIONS
    addAction: function(name, callback) {
        if (!this.actions[name]) this.actions[name] = [];
        this.actions[name].push(callback);
    },
    doAction: function(name, ...args) {
        if (this.actions[name]) this.actions[name].forEach((cb)=>{
            try {
                cb(...args);
            } catch (err) {
                console.error(`[bm_hooks] action "${name}" failed`, err);
            }
        });
    },
    // FILTERS
    addFilter: function(name, callback) {
        if (!this.filters[name]) this.filters[name] = [];
        this.filters[name].push(callback);
    },
    applyFilters: function(name, value, ...args) {
        if (this.filters[name]) return this.filters[name].reduce((acc, cb)=>{
            try {
                return cb(acc, ...args);
            } catch (err) {
                console.error(`[bm_hooks] filter "${name}" failed`, err);
                return acc;
            }
        }, value);
        return value;
    }
};
window.bm_hooks = $03bdf524ba4539fe$export$8b2af14498e05840;


const $ffb1a43efacad8ca$export$81efce3badf1ad6 = 768;


const $f2674e4a6d910bac$export$1dee74401214401b = ()=>{
    if (document.body.classList.contains("single-product")) {
        $f2674e4a6d910bac$var$initProductTabs();
        $f2674e4a6d910bac$var$initProductReviews();
        $f2674e4a6d910bac$var$initProductInfo();
    }
    if (document.querySelectorAll(".product-variations").length) $f2674e4a6d910bac$var$initProductVariations();
    if (document.querySelectorAll(".product-variations-repl").length) $f2674e4a6d910bac$var$initProductVariationReplacement();
    // delayed (first jquery init needed)
    setTimeout(function() {
        $f2674e4a6d910bac$var$initProductGallery();
    }, 10);
    // delayed (first jquery init needed)
    setTimeout(function() {
        $f2674e4a6d910bac$var$moveInStockInfoToHolder();
    }, 500);
};
const $f2674e4a6d910bac$var$moveInStockInfoToHolder = ()=>{
    const stockHolder = document.querySelector("#stock-holder");
    const stockDivs = document.querySelectorAll("form.cart .stock");
    const stockDiv = stockDivs[stockDivs.length - 1];
    if (stockDiv && stockHolder) {
        stockHolder.innerHTML = "";
        stockHolder.append(stockDiv);
    }
};
const $f2674e4a6d910bac$var$initProductGallery = ()=>{
    const gallery = document.querySelector(".woocommerce-product-gallery");
    const thumbs = document.querySelectorAll(".flex-control-thumbs li");
    if (gallery) {
        const max = gallery.dataset.columns;
        if (thumbs.length >= max) {
            const lastThumb = thumbs[max - 1];
            lastThumb.classList.add("last-plus");
            const span = document.createElement("span");
            span.innerHTML = `+${thumbs.length - max}`;
            lastThumb.append(span);
        }
    }
};
const $f2674e4a6d910bac$var$initProductTabs = ()=>{
    const productTabs = document.querySelectorAll(".product-tab");
    productTabs.forEach(function(tab) {
        tab.addEventListener("click", ()=>{
            resetProductTabIcons();
            const i = tab.id.split("-")[2];
            const icon = document.getElementById("tab-icon-" + i);
            if (icon.style.transform === "rotate(180deg)") icon.style.transform = "rotate(0deg)";
            else icon.style.transform = "rotate(180deg)";
        });
    });
    const resetProductTabIcons = ()=>{
        productTabs.forEach((tab)=>{
            const icon = document.getElementById("tab-icon-" + tab.id.split("-")[2]);
            icon.style.transform = "rotate(0deg)";
        });
    };
};
const $f2674e4a6d910bac$var$initProductReviews = ()=>{
    const reviewStars = document.querySelectorAll(".start-review a");
    reviewStars.forEach(function(elem) {
        elem.addEventListener("click", (e)=>{
            document.querySelector("#review_form_wrapper").classList.add("open");
            const rating = elem.dataset.rating;
            setTimeout(()=>{
                jQuery("#commentform a.star-" + rating).click();
            }, 1500);
        });
    });
    const readMore = document.querySelector(".read-more-btn");
    if (readMore) {
        const tabClone = document.querySelector(".woocommerce-tabs").cloneNode(true);
        const popup = document.getElementById("tabs-popup");
        popup.querySelector(".tabs-popup-body").appendChild(tabClone);
        readMore.addEventListener("click", (e)=>{
            if (window.innerWidth > (0, $ffb1a43efacad8ca$export$81efce3badf1ad6)) {
                const popup = document.getElementById("tabs-popup");
                popup.classList.add("show");
            } else {
                readMore.parentNode.classList.toggle("open");
                toggleInnerText(event.currentTarget, [
                    "Lees meer",
                    "Inklappen"
                ]);
            }
        });
    }
};
const $f2674e4a6d910bac$var$initProductInfo = ()=>{
    const popupClose = document.querySelectorAll(".tabs-popup .close-btn, .tabs-popup-bg");
    popupClose.forEach(function(elem) {
        elem.addEventListener("click", (e)=>{
            const popup = document.getElementById("tabs-popup");
            popup.classList.remove("show");
        });
    });
};
const $f2674e4a6d910bac$var$initProductVariationReplacement = ()=>{
    const productVariationsRepl = document.querySelector(".product-variations-repl");
    const productGroups = productVariationsRepl.querySelectorAll(".product-variation-group");
    const variationsActive = productVariationsRepl.querySelectorAll(".product-variation.active");
    const numVariationGroups = productGroups.length;
    const numVariationsActive = variationsActive.length;
    const hasEnoughActive = numVariationsActive == numVariationGroups;
    productVariationsRepl.querySelector(".select-all-variations-message")?.classList?.toggle("hidden", hasEnoughActive);
    if (productGroups && hasEnoughActive) productGroups.forEach(function(group) {
        const activeElement = group.querySelector(".product-variation.active");
        if (activeElement) {
            const activeLabel = activeElement.dataset.label;
            const variationId = activeElement.dataset.id;
            $f2674e4a6d910bac$var$setAttributesFromVariantId(variationId);
            const key = activeElement.dataset.key;
            if (activeElement.classList.contains("set_title")) {
                const element = document.querySelector("#" + key);
                if (element) element.innerHTML = activeLabel;
            }
        } else $f2674e4a6d910bac$var$clearVarNaming();
    });
    else $f2674e4a6d910bac$var$clearVarNaming();
};
const $f2674e4a6d910bac$var$initProductVariations = ()=>{
    const productVariationButtons = document.querySelectorAll(".product-variation");
    const badge = document.querySelector(".with-badge .badge")?.cloneNode(true) ?? false;
    const variationDataElement = document.querySelector(".variations_form");
    const variationData = variationDataElement ? JSON.parse(variationDataElement.dataset.product_variations) : [];
    const selectVariationOption = (selectElement, value)=>{
        if (!selectElement) return;
        // Set the value of the select element
        selectElement.value = value;
        // Trigger the change event to let WooCommerce handle the update
        var event1 = new Event("change", {
            bubbles: true
        });
        selectElement.dispatchEvent(event1);
        // Trigger the change event on the product form
        var productForm = selectElement.closest("form.variations_form");
        if (productForm) jQuery(productForm).trigger("check_variations");
    };
    const getProductVariation = ()=>{
        const variationGroups = document.querySelectorAll(".entry-summary .product-variations .product-variation-group");
        const numVariationGroups = variationGroups.length;
        const variationsActive = document.querySelectorAll(".entry-summary .product-variations .product-variation-group .active");
        const numVariationsActive = variationsActive.length;
        const hasEnoughActive = numVariationsActive == numVariationGroups;
        document.querySelector(".select-all-variations-message")?.classList?.toggle("hidden", hasEnoughActive);
        if (hasEnoughActive) {
            const checks = [];
            variationsActive.forEach((active, index)=>{
                checks.push({
                    name: active.dataset.name,
                    value: active.dataset.value
                });
            });
            const varIndex = variationData.findIndex((element)=>{
                let found = 0;
                checks.forEach((check)=>{
                    if (element.attributes["attribute_" + check.name] == check.value) found++;
                });
                if (found == numVariationGroups) return true;
                return false;
            });
            return variationData[varIndex];
        } else $f2674e4a6d910bac$var$clearVarNaming();
        return false;
    };
    const setProductVariation = (variation, isTrusted)=>{
        if (isTrusted) // triggered via actual click
        setProductVariationUrl(variation);
        const price_div = document.querySelector(".summary .price");
        if (price_div) {
            price_div.innerHTML = variation.price_html.replace("&nbsp;", "");
            if (badge) // price_div.appendChild(badge);
            dom.i2svg({
                node: price_div
            });
        }
        const availability_div = document.querySelector(".woocommerce-variation-availability");
        if (availability_div) dom.i2svg({
            node: availability_div
        });
        if (typeof variation.points_earned !== "undefined") document.querySelector(".points").innerHTML = variation.points_earned;
        $f2674e4a6d910bac$var$moveInStockInfoToHolder();
    };
    const setProductVariationUrl = (variation)=>{
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.forEach((_value, key)=>{
            if (key.startsWith("attribute_")) params.delete(key);
        });
        Object.entries(variation.attributes).forEach(([key, value])=>{
            params.set(key, value);
        });
        url.search = params.toString();
        history.replaceState(null, null, url.href);
    };
    productVariationButtons.forEach(function(elem) {
        elem.addEventListener("click", (event1)=>{
            const name = elem.dataset.name;
            const value = elem.dataset.value;
            const label = elem.dataset.label;
            const element = document.querySelector("#" + name);
            const key = elem.dataset.key;
            if (elem.classList.contains("set_title")) document.querySelector("#" + key).innerHTML = label;
            selectVariationOption(element, value);
            const variations = document.querySelectorAll(".product-variation." + name);
            variations.forEach(function(variant) {
                variant.classList.remove("active");
            });
            elem.classList.add("active");
            const variation = getProductVariation();
            if (variation) {
                const id = variation.id || variation.variation_id;
                $f2674e4a6d910bac$var$setAttributesFromVariantId(id);
                setProductVariation(variation, event1.isTrusted);
            } else $f2674e4a6d910bac$var$clearVarNaming();
        });
    });
    // click first item so it can be added to the cart right away
    // if variation is already selected (us that one    )
    const variation = getProductVariation();
    if (variation) // we have a varation so click to activate
    document.querySelectorAll(".entry-summary .product-variations .product-variation-group button.active").forEach(function(elem) {
        elem.click();
    });
    else // no variation so click first available per group
    document.querySelectorAll(".entry-summary .product-variations .product-variation-group").forEach(function(group) {
        const availableActiveButton = group.querySelector("button.available.active");
        if (availableActiveButton) availableActiveButton.click();
        else {
            const availableButton = group.querySelector("button.available");
            if (availableButton) availableButton.click();
        }
    });
};
document.querySelectorAll(".bundle-product").forEach(function(bundle) {
    const productId = bundle.getAttribute("id");
    const quantityInput = bundle.querySelector("input[name='quantity']");
    const wrapper = document.querySelector("#inhoud-bundle");
    const form = wrapper.querySelector(`.bundle_form[action*='add-to-cart']`);
    if (!form) return;
    const submitbtn = form.querySelector("button.add_to_cart_bulk");
    wrapper.querySelectorAll(".products .bundle-product p.price").forEach((priceElement)=>{
        priceElement.innerHTML = priceElement.innerHTML.replace(/&nbsp;/g, "");
    });
    if (quantityInput) quantityInput.addEventListener("change", function() {
        submitbtn.disabled = true;
        submitbtn.classList.add("loading");
        // submitbtn.removeAttribute("disabled");
        const action = document.querySelector(`.bundle_form[action*='add-to-cart']`).action;
        const match = action.match(new RegExp(`${productId}:\\d+`));
        if (match) document.querySelector(`.bundle_form[action*='add-to-cart']`).action = action.replace(match[0], `${productId}:${quantityInput.value}`);
        else document.querySelector(`.bundle_form[action*='add-to-cart']`).action += `,${productId}:${quantityInput.value}`;
        const prices = wrapper.querySelectorAll(".bundle-cart-total .price .woocommerce-Price-amount");
        const products = document.querySelectorAll(".bundle-product");
        const totalPrice = Array.from(products).reduce((total, product)=>{
            const quantityInput = product.querySelector("input[name='quantity']");
            const productPriceElement = product.querySelector(".price > ins span.woocommerce-Price-amount, .price > span.woocommerce-Price-amount");
            if (productPriceElement) {
                const productPrice = parseFloat(productPriceElement.innerHTML.replace(/[^\d.,]/g, "").replace(",", "."));
                if (!isNaN(productPrice)) return total + productPrice * parseFloat(quantityInput?.value || 0);
            }
            return total;
        }, 0);
        prices.forEach((price)=>{
            setTimeout(()=>{
                price.innerHTML = totalPrice.toFixed(2).replace(".", ",");
            }, 500);
        });
        setTimeout(()=>{
            submitbtn.disabled = false;
            submitbtn.classList.remove("loading");
        }, 550);
    });
});
document.querySelectorAll("button.add_to_cart_bulk").forEach((elem)=>{
    elem.addEventListener("click", async (event1)=>{
        event1.preventDefault();
        const form = elem.closest("form.bundle_form");
        if (form) {
            const formData = new FormData(form);
            const ajaxUrl = form.getAttribute("action");
            const submitbtn = form.querySelector("button.add_to_cart_bulk");
            submitbtn.disabled = true;
            submitbtn.classList.add("adding");
            try {
                const response = await fetch(ajaxUrl, {
                    method: "POST",
                    body: formData
                });
                const data = await response.text();
                const totalPriceElement = document.querySelector(".bundle-total-price .woocommerce-Price-amount");
                if (totalPriceElement) totalPriceElement.innerHTML = data;
                window.location.href = window.location.href; // disable to disable page resfresh on add to cart
            } finally{
                submitbtn.disabled = false;
                submitbtn.classList.remove("adding");
            // const message = document.querySelector(
            //     "#inhoud-bundle #bulk-add-to-cart-message",
            // );
            // if (message) {
            //     message.classList.remove("hidden");
            //     setTimeout(() => {
            //         message.classList.add("hidden");
            //     }, 2500);
            // }
            }
        }
    });
});
function $f2674e4a6d910bac$var$setAttributesFromVariantId(selectedVariation) {
    const skuNo = document.querySelector(".sku-no");
    const topVariant = skuNo.querySelector(".text-accent span");
    const globalUniqueIDtab = document.querySelector(".meta.global_unique_id");
    const eanTAB = document.querySelector(".meta .value.global_unique_id");
    const skuTAB = document.querySelector(".meta .value.sku");
    const stockVariation = document.querySelector(".stock-quantity p.stock.in-stock span");
    const searchInto = JSON.parse(document.querySelector("form.variations_form").dataset.product_variations);
    if (selectedVariation) {
        const variation = searchInto.find((v)=>v.variation_id == selectedVariation);
        if (variation) {
            const sku = variation.sku;
            const ean = variation.ean;
            const stock = variation.max_qty;
            if (skuNo.classList.contains("hidden") && (ean || sku)) skuNo.classList.remove("hidden");
            if (topVariant) {
                if (ean !== undefined) topVariant.innerHTML = "EAN: " + ean;
                else if (sku !== undefined) topVariant.innerHTML = "SKU: " + sku;
                else {
                    topVariant.innerHTML = "";
                    skuNo.classList.add("hidden");
                }
            }
            if (eanTAB && ean) {
                if (globalUniqueIDtab.classList.contains("hidden")) globalUniqueIDtab.classList.remove("hidden");
                eanTAB.innerHTML = ean;
            }
            if (skuTAB && sku) skuTAB.innerHTML = sku;
            if (stock && stockVariation) stockVariation.innerHTML = stockVariation.innerHTML.replace(/\d+/, stock);
        }
    }
}
function $f2674e4a6d910bac$var$clearVarNaming() {
    const skuNo = document.querySelector(".sku-no");
    const globalUniqueIDtab = document.querySelector(".meta.global_unique_id");
    const skuTAB = document.querySelector(".meta .value.sku");
    skuTAB.innerHTML = "N/B";
    skuNo.classList.add("hidden");
    globalUniqueIDtab.classList.add("hidden");
}


var $2a6c7837450092a1$var$cartInitInterval;
var $2a6c7837450092a1$var$cartContainer = null;
const $2a6c7837450092a1$export$e838c4b04241f74 = ()=>{
    if (document.body.classList.contains("woocommerce-cart")) {
        setTimeout(function() {
            $2a6c7837450092a1$var$alterCart();
        //moveCouponSection();
        }, 500);
        $2a6c7837450092a1$var$cartInitInterval = setInterval(function() {
            $2a6c7837450092a1$var$checkInitCardModifiers();
        }, 200);
        $2a6c7837450092a1$var$checkInitCardModifiers();
    }
};
const $2a6c7837450092a1$var$checkInitCardModifiers = ()=>{
    $2a6c7837450092a1$var$cartContainer = document.querySelector(".wc-block-cart");
    if ($2a6c7837450092a1$var$cartContainer !== null) {
        clearInterval($2a6c7837450092a1$var$cartInitInterval);
        $2a6c7837450092a1$var$initCardModifiers();
    }
};
const $2a6c7837450092a1$var$initCardModifiers = ()=>{
    const observer = new MutationObserver((mutationsList)=>{
        for (let mutation of mutationsList){
            if (mutation.type === "childList") {
                if (mutation.target.classList.contains("wc-block-cart-item__total-price-and-sale-badge-wrapper")) $2a6c7837450092a1$var$alterCart();
            //moveCouponSection();
            }
        }
    });
    // Start observing the cart container for changes
    if ($2a6c7837450092a1$var$cartContainer) observer.observe($2a6c7837450092a1$var$cartContainer, {
        childList: true,
        subtree: true
    });
};
const $2a6c7837450092a1$var$alterCart = ()=>{
    const couponButton = document.querySelector(".wc-block-components-totals-coupon .wc-block-components-panel__button");
    const cartItemRows = document.querySelectorAll(".wc-block-cart-items__row");
    if (couponButton) couponButton.childNodes[1].nodeValue = bm_variables.add_coupon_text;
    cartItemRows.forEach((row)=>{
        const badges = row.querySelectorAll(".wc-block-components-sale-badge");
        if (badges.length) {
            if (badges.length > 1) badges[0].style.display = "none";
            else badges[0].style.display = "block";
        }
    });
};
// this is killing the fixed checkout button on mobile
const $2a6c7837450092a1$var$moveCouponSection = ()=>{
    const couponSection = document.querySelector(".wp-block-woocommerce-cart-order-summary-coupon-form-block");
    if (couponSection) document.querySelector(".wc-block-cart__submit-container").after(couponSection);
};


var $f7eb0b6bc1cc70a0$var$checkoutContainer = null;
var $f7eb0b6bc1cc70a0$var$checkoutInitInterval;
const $f7eb0b6bc1cc70a0$export$a1f07e9d1ea2d6b8 = ()=>{
    if (document.body.classList.contains("woocommerce-checkout")) {
        setTimeout(function() {
            $f7eb0b6bc1cc70a0$var$changeCheckoutWording();
        //moveCouponSection();
        }, 500);
        $f7eb0b6bc1cc70a0$var$checkoutInitInterval = setInterval(function() {
            $f7eb0b6bc1cc70a0$var$checkInitCheckoutModifiers();
        }, 200);
        $f7eb0b6bc1cc70a0$var$checkInitCheckoutModifiers();
    }
};
const $f7eb0b6bc1cc70a0$var$checkInitCheckoutModifiers = ()=>{
    $f7eb0b6bc1cc70a0$var$checkoutContainer = document.querySelector(".wp-block-woocommerce-checkout");
    if ($f7eb0b6bc1cc70a0$var$checkoutContainer !== null) {
        clearInterval($f7eb0b6bc1cc70a0$var$checkoutInitInterval);
        $f7eb0b6bc1cc70a0$var$initCheckoutModifiers();
    }
};
const $f7eb0b6bc1cc70a0$var$initCheckoutModifiers = ()=>{
    const observer = new MutationObserver((mutationsList)=>{
        for (let mutation of mutationsList){
            if (mutation.type === "childList") {
                if (mutation.target.classList.contains("wp-block-woocommerce-checkout-order-summary-block")) $f7eb0b6bc1cc70a0$var$changeCheckoutWording();
            }
        }
    });
    // Start observing the cart container for changes
    if ($f7eb0b6bc1cc70a0$var$checkoutContainer) observer.observe($f7eb0b6bc1cc70a0$var$checkoutContainer, {
        childList: true,
        subtree: true
    });
};
function $f7eb0b6bc1cc70a0$var$changeCheckoutWording() {
    const couponButton = document.querySelector(".wc-block-components-totals-coupon .wc-block-components-panel__button");
    const createAccount = document.querySelector(".wc-block-checkout__create-account span");
    console.log("couponButton", couponButton);
    if (couponButton) couponButton.childNodes[1].nodeValue = bm_variables.add_coupon_text;
    if (createAccount) createAccount.innerHTML = bm_variables.checkout_create_account;
    document.querySelector(".wc-block-components-checkout-order-summary__title-text").innerHTML = bm_variables.checkout_summary_title;
}


function $9053a1adfc3661f8$export$61fc7d43ac8f84b0(func, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}
function $9053a1adfc3661f8$export$55410a3220bf7b88(elm, textArr) {
    if (elm.innerText.trim() == textArr[0]) elm.innerText = textArr[1];
    else elm.innerText = textArr[0];
}
// make available inside html
window.toggleInnerText = $9053a1adfc3661f8$export$55410a3220bf7b88;


const $bcfa53b7a0d8caec$var$verticalScrollerList = [];
const $bcfa53b7a0d8caec$export$51af453d66912164 = (el)=>{
    let itemWidth = 100;
    const scroller = el.querySelector(".scroll-items");
    const setSize = (el)=>{
        let set = scroller.scrollWidth > scroller.clientWidth;
        el.classList.toggle("has-scrollbar", set);
        itemWidth = scroller.children[0].clientWidth;
    };
    const resized = ()=>{
        $bcfa53b7a0d8caec$var$verticalScrollerList.forEach((el)=>{
            setSize(el);
        });
    };
    const move = (btn, el)=>{
        scroller.scroll({
            top: 0,
            left: scroller.scrollLeft + (btn.classList.contains("prev") ? -itemWidth : itemWidth),
            behavior: "smooth"
        });
    };
    const scroll = (scroller)=>{
        let max = scroller.scrollWidth - scroller.offsetWidth;
        let left = scroller.scrollLeft;
        let diff = 50;
        el.classList.toggle("at-end", left + diff > max);
        el.classList.toggle("at-start", left - diff < 0);
    };
    if ($bcfa53b7a0d8caec$var$verticalScrollerList.length == 0) window.addEventListener("resize", (0, $9053a1adfc3661f8$export$61fc7d43ac8f84b0)(resized, 300));
    el.querySelectorAll(".btn").forEach((btn)=>{
        btn.addEventListener("click", function() {
            move(btn, el);
        });
    });
    scroller.addEventListener("scroll", function(e) {
        scroll(e.currentTarget);
    });
    setSize(el);
    scroll(scroller);
    $bcfa53b7a0d8caec$var$verticalScrollerList.push(el);
};



const $356e9a2b0c95c367$var$verticalAutoSliders = [];
const $356e9a2b0c95c367$export$1c0c31eba7a271ae = (el, userSettings)=>{
    let current = 0;
    let last_set;
    const settings = {
        startWidth: 768,
        interval: 3000,
        speed: 1000,
        ...userSettings
    };
    el.style.setProperty("--speed", settings.speed + "ms");
    const setSize = (el)=>{
        let set = window.innerWidth <= settings.startWidth;
        el.classList.toggle("init", set);
        if (set != last_set && !set) el.querySelectorAll("item").forEach((el)=>{
            el.classList.remove("active", "last");
        });
        last_set = set;
    };
    const resized = ()=>{
        $356e9a2b0c95c367$var$verticalAutoSliders.forEach((el)=>{
            setSize(el);
        });
    };
    const totalItems = el.querySelectorAll(".item").length;
    const fixNth = (num)=>{
        if (num < 0) return totalItems;
        if (num >= totalItems) return 1;
        return num + 1;
    };
    const showNext = ()=>{
        let lastEl = el.querySelector(".item:nth-child(" + fixNth(current - 1) + ")");
        let currEl = el.querySelector(".item:nth-child(" + fixNth(current) + ")");
        let nextEl = el.querySelector(".item:nth-child(" + fixNth(current + 1) + ")");
        lastEl.classList.remove("active");
        lastEl.classList.add("last");
        currEl.classList.add("active");
        nextEl.classList.add("next");
        nextEl.classList.remove("last");
        current++;
        if (current >= totalItems) current = 0;
    };
    setInterval(showNext, settings.interval);
    showNext();
    if ($356e9a2b0c95c367$var$verticalAutoSliders.length == 0) window.addEventListener("resize", (0, $9053a1adfc3661f8$export$61fc7d43ac8f84b0)(resized, 10));
    setSize(el);
    $356e9a2b0c95c367$var$verticalAutoSliders.push(el);
};



const $06da0facb6c0b51b$export$9340b7ed135c7bb4 = ()=>{
    $06da0facb6c0b51b$var$initFilter();
    const uspBar = document.querySelectorAll(".usp-bar");
    if (uspBar) uspBar.forEach((el)=>{
        (0, $356e9a2b0c95c367$export$1c0c31eba7a271ae)(el, {
            startWidth: 1024,
            interval: 4000,
            speed: 1500
        });
    });
};
function $06da0facb6c0b51b$var$preventEmptyS() {
    s = document.querySelector(".filter #s");
    if (s.value == "") s.setAttribute("disabled", "disabled");
}
function $06da0facb6c0b51b$var$initFilter() {
    let form = document.getElementById("filter-form");
    if (form) {
        form.addEventListener("keydown", function(event) {
            if (event.key === "Enter") {
                $06da0facb6c0b51b$var$preventEmptyS();
                form.submit();
            }
        });
        form.querySelectorAll(".filter-field").forEach((field)=>{
            field.addEventListener("change", function() {
                document.getElementById("l").value = field.dataset.key;
                const term_id = field.dataset.term_id;
                document.querySelectorAll(".parent_" + term_id).forEach((el)=>{
                    el.checked = false;
                });
                $06da0facb6c0b51b$var$preventEmptyS();
                if (!$06da0facb6c0b51b$var$tryFilterNavigation()) form.submit();
            });
        });
        form.querySelectorAll(".search-filter").forEach((field)=>{
            $06da0facb6c0b51b$var$initSearchable(field);
        });
        form.querySelectorAll(".show-more").forEach((link)=>{
            link.addEventListener("click", function(event) {
                event.currentTarget.classList.toggle("closed");
                toggleInnerText(event.currentTarget.querySelector("span"), [
                    "toon meer",
                    "toon minder"
                ]);
                event.currentTarget.previousElementSibling.classList.toggle("hidden");
                event.preventDefault();
            });
        });
        document.querySelector(".remove-s")?.addEventListener("click", function(event) {
            form.querySelector("#s").remove();
            form.submit();
        });
    /*
        document.querySelectorAll(".tag-remove").forEach((link) => {
            link.addEventListener("click", function (event) {
                const forId = link.getAttribute("for");
                const filterBox = document.getElementById(forId);
                if (filterBox == null) {
                    form.submit();
                }
                event.preventDefault();
            });
        });
        */ }
}
function $06da0facb6c0b51b$var$tryFilterNavigation() {
    if (follow_category_path) {
        let form = document.getElementById("filter-form");
        let paths = [];
        let depths_counter = [];
        form.querySelectorAll(".filter-field:checked").forEach((field)=>{
            let depth = field.dataset.depth;
            depths_counter[depth] = (depths_counter[depth] || 0) + 1;
            paths.push({
                'value': field.value,
                'depth': Number(depth)
            });
        });
        if (paths.length == 0) return false;
        for(let i = 0; i < depths_counter.length; i++){
            if (depths_counter[i] > 1) return false;
        }
        let filter_url = paths.map((el)=>{
            return el.value;
        }).join("/");
        var s1 = form.querySelector("#s")?.value ?? '';
        if (s1) filter_url += "?s=" + s1;
        filter_url = bm_hooks.applyFilters('bm_pre_nav_filter_url', filter_url);
        window.location.href = window.location.origin + "/" + filter_url;
        return true;
    }
    return false;
}
function $06da0facb6c0b51b$var$initSearchable(field) {
    const optionsContainer = document.querySelector(".searchable-" + field.dataset.search);
    field.parentNode.querySelector(".clear").addEventListener("click", ()=>{
        field.value = "";
        field.dispatchEvent(new Event("keyup"));
    });
    function filterOptions() {
        const searchValue = field.value.toLowerCase();
        const options = optionsContainer.querySelectorAll(".option");
        optionsContainer.classList.toggle("searching", searchValue != "");
        field.parentNode.classList.toggle("searching", searchValue != "");
        let num_found = 0;
        options.forEach((option)=>{
            const optionText = option.dataset.title.toLowerCase();
            if (optionText.includes(searchValue) || searchValue == "") {
                option.style.display = "flex";
                num_found++;
            } else option.style.display = "none";
        });
        optionsContainer.classList.toggle("nothing", num_found == 0);
    }
    // Add event listener to search input
    field.addEventListener("keyup", filterOptions);
}


const $22ab88523984e3de$export$1e1d1c35bcf87bc1 = (el)=>{
    let timer;
    el.once().querySelectorAll("button").forEach((btn)=>{
        btn.addEventListener("click", function(e) {
            var $qty = btn.parentNode.querySelector("input"), currentVal = parseFloat($qty.value), max = parseFloat($qty.getAttribute("max")), min = parseFloat($qty.getAttribute("min")), step = $qty.getAttribute("step");
            // Format values
            if (!currentVal || currentVal === "" || currentVal === "NaN") currentVal = 0;
            if (max === "" || max === "NaN") max = "";
            if (min === "" || min === "NaN") min = 0;
            if (step === "any" || step === "" || step === undefined || parseFloat(step) === "NaN") step = 1;
            // Change the value
            if (btn.classList.contains("plus")) {
                if (max && currentVal >= max) $qty.value = max;
                else $qty.value = (currentVal + parseFloat(step)).toFixed(step.getDecimals());
            } else {
                if (min && currentVal <= min) $qty.value = min;
                else if (currentVal > 0) $qty.value = (currentVal - parseFloat(step)).toFixed(step.getDecimals());
            }
            clearTimeout(timer);
            timer = setTimeout(()=>{
                var event = new Event("change");
                $qty.dispatchEvent(event);
                jQuery($qty).trigger("change");
            }, 500);
            e.preventDefault();
            return false;
        });
    });
    el.classList.add("init");
};


// Quantify based on the staffel selection Simple Version, without Cart CHECK
// FOR CART CHECK see quantity-staffel-complex.js
const $9a1a932dedc5098d$export$b726f1920a054350 = (containerId)=>{
    const parent = containerId ? document.querySelector(`#${containerId}`) : document;
    const staffels = parent.querySelector("#staffels[data-id]");
    const variationParent = parent.querySelector(".single_variation_wrap .woocommerce-variation-price .price");
    const observer = new MutationObserver((mutationsList)=>{
        observer.disconnect();
    // mutationsList.forEach((mutation) => {
    //     if (mutation.type === "childList") {
    //         if (parent) {
    //             var variationParent = parent.querySelector(
    //                 ".single_variation_wrap .woocommerce-variation-price .price",
    //             );
    //             if (variationParent) {
    //                 var del = parent.querySelector("del bdi");
    //                 // var price = parent.querySelector("ins bdi");
    //                 if (del) {
    //                     sendValue(variationParent, del.innerText);
    //                 } else {
    //                     sendValue(variationParent);
    //                 }
    //                 observer.disconnect();
    //             }
    //         }
    //     }
    // });
    });
    observer.observe(parent, {
        childList: true,
        subtree: true
    });
    if (!staffels) return;
    const quantityInput = parent.querySelector(".cart input[name='quantity']");
    const variations_price = parent.querySelector("#pa_kleur");
    const sendValue = (value, original)=>{
        observer.observe(parent, {
            childList: true,
            subtree: true
        });
        const newPrice = original ? original : staffels.querySelector(".staffel.active .woocommerce-Price-amount.amount bdi")?.textContent;
        $9a1a932dedc5098d$var$updatePriceHtml(parent, quantityInput.value, newPrice, value);
        observer.observe(parent, {
            childList: true,
            subtree: true
        });
    };
    const updateActiveStaffel = ()=>{
        const totalVal = parseInt(quantityInput.value, 10) || 0;
        staffels.querySelectorAll(".staffel").forEach((el)=>{
            const dataValue = parseInt(el.getAttribute("data-value"), 10);
            const dataMax = parseInt(el.getAttribute("data-max"), 10);
            el.classList.toggle("active", totalVal >= dataValue && (!dataMax || totalVal <= dataMax));
        });
        if (containerId) sendValue();
    };
    staffels.querySelectorAll(".staffel").forEach((el)=>{
        el.addEventListener("click", ()=>{
            staffels.querySelectorAll(".staffel").forEach((otherEl)=>otherEl.classList.remove("active"));
            el.classList.add("active");
            const dataValue = parseInt(el.getAttribute("data-value"), 10);
            quantityInput.value = dataValue;
            jQuery(quantityInput).val(dataValue).trigger("change");
            el.scrollIntoView({
                alignToTop: true,
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
            if (containerId) sendValue();
        });
    });
    quantityInput.addEventListener("change", ()=>{
        updateActiveStaffel();
        if (containerId) sendValue();
    });
    if (!variations_price) return;
    variations_price.addEventListener("click", ()=>{
        updateActiveStaffel();
        sendValue();
    });
    updateActiveStaffel();
};
function $9a1a932dedc5098d$var$updatePriceHtml(parent, quantity, newPrice, variationParent) {
    const priceElement = parent.querySelector("p.price");
    const priceChild = priceElement.querySelector("ins");
    const price = priceElement.querySelector("ins .woocommerce-Price-amount.amount bdi");
    if (!price) return;
    // cleanupPrice
    if (priceChild.innerHTML.includes("\u2013")) {
        priceChild.innerHTML = priceChild.innerHTML.replace("\u2013", "");
        priceChild.querySelectorAll("span").forEach((el, i)=>{
            if (i > 0) el.remove();
        });
    }
    if (variationParent) {
        variationParent.innerHTML = variationParent.innerHTML.replace("&nbsp;", "");
        var thePrice = variationParent.innerHTML;
        priceElement.innerHTML = thePrice;
        const discountPercentage = parseFloat(parent.querySelector(".discount-percentage")?.textContent?.match(/\d+(\.\d+)?/)?.[0]);
        // const discountstaffelAmount = parseFloat(
        //     parent
        //         .querySelector(
        //             "#staffels[data-id] .staffel.active .awdr_bulk_discounted_value",
        //         )
        //         ?.textContent?.match(/\d+(\.\d+)?/)?.[0],
        // );
        var newPrice = newPrice.replace(",", ".");
        var newPriceFloat = parseFloat(newPrice);
        // var newPriceFloat = newPriceFloat * (discountstaffelAmount / 100);
        var discountedPrice = newPriceFloat * (discountPercentage / 100);
        var thePrice = newPriceFloat - discountedPrice; // add * quantity to get total price
        price.textContent = thePrice.toFixed(2);
    } else {
        const discountPercentage = parseFloat(parent.querySelector(".discount-percentage")?.textContent?.match(/\d+(\.\d+)?/)?.[0]);
        const discountstaffelAmount = parent.querySelector(".awdr_bulk_discounted_value").textContent;
        var newPrice = newPrice.replace(",", ".");
        var newPriceFloat = parseFloat(newPrice);
        var discountedPrice = newPriceFloat * (discountPercentage / 100);
        var thePrice = newPriceFloat - discountedPrice; // add * quantity to get total price
        price.textContent = thePrice.toFixed(2);
    }
}


const $dc5e951bd4e7c367$export$4e6f96734dfe12f4 = (el, setOptions = {})=>{
    const defaultOptions = {
        position: "none"
    };
    const dataOptions = el?.dataset?.tooltip ? JSON.parse(el?.dataset?.tooltip) : {};
    const options = {
        ...defaultOptions,
        ...dataOptions,
        ...setOptions
    };
    const rectTrigger = el.getBoundingClientRect();
    const refCenter = rectTrigger.width / 2;
    const tooltip = document.createElement("div");
    tooltip.classList.add("tooltip", options.position);
    tooltip.innerHTML = el.dataset.title;
    el.append(tooltip);
    const arrow = document.createElement("div");
    arrow.classList.add("arrow");
    tooltip.append(arrow);
    el.addEventListener("mouseenter", (e)=>{
        showTooltip();
        e.preventDefault();
        e.stopPropagation();
    });
    el.addEventListener("click", (e)=>{
        toggleTooltip();
        e.preventDefault();
        e.stopPropagation();
    });
    document.body.addEventListener("click", (e)=>{
        if (tooltip.classList.contains("visable")) {
            hideTooltip();
            e.preventDefault();
            e.stopPropagation();
        }
    });
    function toggleTooltip() {
        if (tooltip.classList.contains("visable")) hideTooltip();
        else showTooltip();
    }
    function showTooltip() {
        tooltip.style.marginLeft = "auto";
        arrow.style.marginLeft = "auto";
        tooltip.classList.add("visable");
        const rect = tooltip.getBoundingClientRect();
        if (rect.right > window.innerWidth) {
            diff = rect.right - window.innerWidth + 30;
            tooltip.style.marginLeft = `-${diff}px`;
            arrow.style.marginLeft = `${diff + refCenter}px`;
        } else if (options.position == "center") tooltip.style.marginLeft = `${refCenter}px`;
    }
    function hideTooltip() {
        tooltip.classList.remove("visable");
    }
    // mouse leave remove tooltip
    el.addEventListener("mouseleave", ()=>{
        tooltip.classList.remove("visable");
    });
};


const $ce07ec29e34ee707$export$18354b2165766aa3 = ()=>{
    var currentPopup;
    document.addEventListener("click", function(e) {
        if (e.target.classList.contains("show-modal")) {
            let modalId = e.target.dataset["target"];
            currentPopup = document.querySelector(modalId);
            currentPopup.classList.add("show");
            e.preventDefault();
        }
        if (e.target.classList.contains("bm-wp-theme-popup") || e.target.classList.contains("bm-wp-theme-popup-close")) currentPopup.classList.remove("show");
    });
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && currentPopup) currentPopup.classList.remove("show");
    });
};


(0, $03bdf524ba4539fe$export$8b2af14498e05840).doAction("bm_js_load");
document.addEventListener("DOMContentLoaded", function() {
    (0, $03bdf524ba4539fe$export$8b2af14498e05840).doAction("bm_pre_init");
    $bbc020f4507f1722$var$init();
    (0, $03bdf524ba4539fe$export$8b2af14498e05840).doAction("bm_post_init");
});
const $bbc020f4507f1722$var$observer = new MutationObserver((mutations)=>{
    mutations.forEach((mutation)=>{
        if (mutation.attributeName === "class" && mutation.target.classList.contains("show")) {
            const id = mutation.target.id;
            (0, $9a1a932dedc5098d$export$b726f1920a054350)(id);
            mutation.target.querySelector(".discount-percentage").classList.add("hidden");
            const scrollVertical = mutation.target.querySelectorAll(".scroll-vertical");
            if (scrollVertical.length) scrollVertical.forEach((el)=>{
                $bbc020f4507f1722$var$initScrollers();
            });
        }
    });
});
document.querySelectorAll(".wpvp-popup").forEach((el)=>{
    $bbc020f4507f1722$var$observer.observe(el, {
        attributes: true,
        attributeFilter: [
            "class"
        ]
    });
});
function $bbc020f4507f1722$var$init() {
    $bbc020f4507f1722$var$initUspSlider();
    $bbc020f4507f1722$var$initScrollers();
    $bbc020f4507f1722$var$initMenuScrolled();
    $bbc020f4507f1722$var$initFormChecks();
    $bbc020f4507f1722$var$initTooltips();
    (0, $ce07ec29e34ee707$export$18354b2165766aa3)();
    // initVariationPopup();
    (0, $06da0facb6c0b51b$export$9340b7ed135c7bb4)();
    $bbc020f4507f1722$var$initAjaxVariations();
    (0, $f2674e4a6d910bac$export$1dee74401214401b)();
    $bbc020f4507f1722$var$initCartQuantity();
    (0, $2a6c7837450092a1$export$e838c4b04241f74)();
    (0, $f7eb0b6bc1cc70a0$export$a1f07e9d1ea2d6b8)();
    (0, $9a1a932dedc5098d$export$b726f1920a054350)();
// QuantityStaffelComplex();
}
function $bbc020f4507f1722$var$getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
}
function $bbc020f4507f1722$var$initMenuScrolled() {
    var minScroll = 200;
    var lastScrollTop = 0;
    var diff = 0;
    var timeout, classTimer, scrolledTimer, diff_timer;
    var dir = "down";
    var st = $bbc020f4507f1722$var$getScrollTop();
    var enabled = true;
    var header = document.getElementById("main-header");
    var initHeaderHeight = header.clientHeight;
    window.addEventListener("scroll", function() {
        st = $bbc020f4507f1722$var$getScrollTop();
        if (timeout) window.cancelAnimationFrame(timeout);
        timeout = window.requestAnimationFrame(scrollFrame);
    }, false);
    header.addEventListener("click", function() {
        header.classList.remove("up", "down");
        enabled = false;
        setTimeout(function() {
            enabled = true;
        }, 500);
    });
    function scrollFrame() {
        if (enabled) {
            var currHeaderHeight = header.clientHeight;
            var headerHeightDiff = Number(initHeaderHeight) - Number(currHeaderHeight);
            var calcSt = Number(st || 0) + Number(headerHeightDiff);
            clearTimeout(scrolledTimer);
            scrolledTimer = setTimeout(function() {
                header.classList.toggle("scrolled", calcSt > minScroll);
            }, 100);
            // check for min diff of 2 pixels (chaning height causes rounding diff)
            if (Math.abs(calcSt - lastScrollTop) > 2) {
                if (calcSt >= lastScrollTop) dir = "down";
                else if (st <= lastScrollTop) dir = "up";
            }
            if (dir == "down" && calcSt >= minScroll) {
                header.classList.add("down");
                header.classList.remove("up");
                clearTimeout(classTimer);
                classTimer = setTimeout(function() {
                    header.classList.add("down");
                    header.classList.remove("up");
                }, 100);
                diff = 0;
            } else if (dir == "up" && calcSt >= minScroll) {
                if (diff > 200 || calcSt < minScroll) {
                    clearTimeout(classTimer);
                    classTimer = setTimeout(function() {
                        header.classList.add("up");
                        header.classList.remove("down");
                        diff = 0;
                    }, 10);
                }
                clearTimeout(diff_timer);
                diff_timer = setTimeout(()=>{
                    diff = 0;
                }, 1000);
            }
            diff += Number(lastScrollTop) - Number(calcSt);
            lastScrollTop = calcSt <= 0 ? 0 : calcSt; // For M
            last_diff = diff;
        }
    }
    scrollFrame();
}
function $bbc020f4507f1722$var$initScrollers() {
    document.querySelectorAll(".scroll-vertical").forEach((el)=>{
        (0, $bcfa53b7a0d8caec$export$51af453d66912164)(el);
    });
}
function $bbc020f4507f1722$var$initFormChecks() {
    var validate = new (0, (/*@__PURE__*/$parcel$interopDefault($8ff1efb0b0992627$exports)))("#mc-embedded-subscribe-form", {
        messages: (0, $37f38e07ede14368$export$2e2bcd8739ae039)
    });
    document.addEventListener("bouncerShowError", function(event) {
        event.target.classList.remove("success");
    }, false);
    document.addEventListener("bouncerRemoveError", function(event) {
        event.target.classList.add("success");
    }, false);
}
function $bbc020f4507f1722$var$initAjaxVariations() {}
// overwrite flexslider params!
if (typeof wc_single_product_params !== "undefined" && wc_single_product_params.flexslider) {
    window.addEventListener("load", ()=>{
        const getAmount = document.querySelectorAll(".flex-control-thumbs li").length;
        const lastPlus = document.querySelector(".last-plus");
        if (!lastPlus) return;
        const handleLastPlus = ()=>{
            lastPlus.classList.remove("last-plus");
            const spanElement = lastPlus.querySelector("span");
            if (spanElement && !spanElement.classList.contains("hidden")) spanElement.classList.add("hidden");
        };
        if (getAmount > 4) {
            const observer = new MutationObserver(()=>{
                const element = lastPlus.querySelector("*");
                if (element && element.classList.contains("flex-active")) {
                    if (!lastPlus.classList.contains("last-plus")) return;
                    handleLastPlus();
                    observer.disconnect();
                }
            });
            observer.observe(document.querySelector(".woocommerce-product-gallery"), {
                subtree: true,
                childList: true
            });
        } else handleLastPlus();
    });
    wc_single_product_params.flexslider.directionNav = true;
}
var $bbc020f4507f1722$var$cartMenuCount;
function $bbc020f4507f1722$var$initCartQuantity() {
    $bbc020f4507f1722$var$cartMenuCount = document.querySelector("#menu-cart-count");
    // dirty hack for React cart
    $bbc020f4507f1722$var$initQuanitityUpdater();
    jQuery(document.body).on("removed_from_cart updated_cart_totals added_to_cart", function(event, args) {
        let cartCount = args["cart_contents_count"];
        if (cartCount) {
            $bbc020f4507f1722$var$cartMenuCount.innerHTML = cartCount;
            $bbc020f4507f1722$var$cartMenuCount.classList.remove("hidden");
        } else $bbc020f4507f1722$var$cartMenuCount.classList.add("hidden");
        $bbc020f4507f1722$var$initQuantitySelect();
    });
    jQuery(document.body).on("wc_cart_emptied", function() {
        $bbc020f4507f1722$var$setEmptyCart();
    });
    $bbc020f4507f1722$var$initQuantitySelect();
}
function $bbc020f4507f1722$var$setEmptyCart() {
    let cartMenuCount = document.querySelector("#menu-cart-count");
    cartMenuCount.remove();
}
function $bbc020f4507f1722$var$initQuantitySelect() {
    document.querySelectorAll(".quantity-selector").forEach((el)=>{
        (0, $22ab88523984e3de$export$1e1d1c35bcf87bc1)(el);
    });
    document.querySelectorAll(".woocommerce-cart-form .qty").forEach((el)=>{
        el.addEventListener("change", function() {
            document.querySelector("button[name='update_cart']").disabled = false;
        });
    });
}
function $bbc020f4507f1722$var$initQuanitityUpdater() {
    if (document.querySelector(".wc-block-cart")) setInterval($bbc020f4507f1722$var$doQuantityUpdate, 1000);
    if (document.querySelector(".wp-block-woocommerce-empty-cart-block")) $bbc020f4507f1722$var$setEmptyCart();
}
function $bbc020f4507f1722$var$doQuantityUpdate() {
    var total = 0;
    document.querySelectorAll(".wc-block-components-quantity-selector__input").forEach((el)=>{
        total += parseInt(el.value);
    });
    $bbc020f4507f1722$var$cartMenuCount.innerHTML = total;
    if (total == 0) $bbc020f4507f1722$var$setEmptyCart();
}
function $bbc020f4507f1722$var$initUspSlider() {
    const usps = document.querySelector("#usps");
    if (usps && usps.querySelectorAll(".item").length > 0) (0, $356e9a2b0c95c367$export$1c0c31eba7a271ae)(usps, {
        startWidth: 1024,
        interval: 4000,
        speed: 1500
    });
}
function $bbc020f4507f1722$var$initTooltips() {
    document.querySelectorAll(".has-tooltip").forEach((el)=>{
        // create custom tooltip div on hover
        (0, $dc5e951bd4e7c367$export$4e6f96734dfe12f4)(el);
    });
}

})();
//# sourceMappingURL=index.js.map
